const DarkTokens = {
    name: "dark",
    selectors: [":root[data-sas-theme='graph-dark']"],
    tokens: {
        "annotation-line-alt-color": "hsl(219, 12%, 98%)",
        "annotation-line-color": "hsl(219, 12%, 98%)",
        "annotation-line-pattern": "1",
        "annotation-line-text-color": "hsl(219, 12%, 72%)",
        "annotation-line-thickness": "1px",
        "annotation-reference-alt-color": "#DFE0E0",
        "annotation-reference-line-color": "#DFE0E0",
        "annotation-reference-line-pattern": "1",
        "annotation-reference-line-thickness": "1dpx",
        "annotation-reference-marker-color": "#DFE0E0",
        "annotation-reference-text-color": "#DFE0E0",
        "annotation-shape-alt-color": "hsl(219, 12%, 55%)",
        "annotation-shape-color": "hsl(219, 12%, 17%)",
        "annotation-shape-fill-color": "hsl(219, 12%, 17%)",
        "annotation-shape-line-color": "hsl(219, 12%, 55%)",
        "annotation-shape-line-pattern": "1",
        "annotation-shape-line-thickness": "1px",
        "annotation-shape-marker-color": "hsl(219, 12%, 72%)",
        "annotation-shape-marker-size": "11px",
        "annotation-shape-marker-symbol": "Starfilled",
        "annotation-shape-text-color": "hsl(219, 12%, 72%)",
        "annotation-text-color": "hsl(219, 12%, 72%)",
        "annotation-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "annotation-text-fontSize": "9.3pt",
        "annotation-text-fontStyle": "normal",
        "annotation-text-fontWeight": "400",
        "axis-discrete-displayOpts": "tickvalues ticks line label",
        "axis-discrete-gridDisplay": "0",
        "axis-linear-displayOpts": "tickvalues label",
        "axis-linear-gridDisplay": "1",
        "axis-log-displayOpts": "tickvalues label",
        "axis-log-gridDisplay": "1",
        "axis-time-displayOpts": "tickvalues label",
        "axis-time-gridDisplay": "1",
        "chrome-axis-line-color": "hsl(219, 12%, 98%)",
        "chrome-axis-line-pattern": "1",
        "chrome-axis-line-thickness": "1dpx",
        "chrome-axis-tickDisplay": "OUTSIDE",
        "chrome-background-fill-color": "hsl(219, 12%, 17%)",
        "chrome-background-frameBorder": "0",
        "chrome-border-line-color": "hsl(219, 12%, 98%)",
        "chrome-border-line-pattern": "1",
        "chrome-border-line-thickness": "1dpx",
        "chrome-callout-line-color": "hsl(219, 12%, 98%)",
        "chrome-callout-line-pattern": "1",
        "chrome-callout-line-thickness": "1dpx",
        "chrome-callout-line-transparency": "0.4",
        "chrome-cellSeparator-line-color": "hsl(219, 12%, 98%)",
        "chrome-cellSeparator-line-pattern": "34",
        "chrome-cellSeparator-line-thickness": "1dpx",
        "chrome-grid-gridLayer": "front",
        "chrome-grid-line-color": "hsl(219, 12%, 98%)",
        "chrome-grid-line-pattern": "34",
        "chrome-grid-line-thickness": "1dpx",
        "chrome-grid-line-transparency": "0.6",
        "chrome-header-fill-color": "hsl(219, 12%, 27%)",
        "chrome-legend-fill-color": "hsl(219, 12%, 17%)",
        "chrome-legend-frameBorder": "0",
        "chrome-legend-titleBorder": "0",
        "chrome-wall-displayOpts": "none",
        "chrome-wall-fill-color": "hsl(219, 12%, 17%)",
        "chrome-wall-fill-transparency": "0",
        "chrome-wall-frameBorder": "0",
        "chrome-wall-line-color": "hsl(219, 12%, 98%)",
        "chrome-wall-line-pattern": "1",
        "chrome-wall-line-thickness": "1dpx",
        "chrome-wall-line-transparency": "0",
        "confidence-1-alt-color": "#57718F",
        "confidence-1-color": "#4D647E",
        "confidence-1-fill-color": "#4D647E",
        "confidence-1-fill-pattern": "E",
        "confidence-1-fill-patternColor": "#57718F",
        "confidence-1-fill-transparency": "0.5",
        "confidence-1-line-color": "#57718F",
        "confidence-1-line-pattern": "4",
        "confidence-1-line-thickness": "2px",
        "confidence-1-marker-color": "#57718F",
        "confidence-1-marker-size": "11px",
        "confidence-1-marker-symbol": "squarefilled",
        "confidence-1-text-color": "#5C7796",
        "confidence-2-alt-color": "#876E5E",
        "confidence-2-color": "#755F51",
        "confidence-2-fill-color": "#755F51",
        "confidence-2-fill-pattern": "E",
        "confidence-2-fill-patternColor": "#876E5E",
        "confidence-2-fill-transparency": "0.5",
        "confidence-2-line-color": "#876E5E",
        "confidence-2-line-pattern": "8",
        "confidence-2-line-thickness": "2px",
        "confidence-2-marker-color": "#876E5E",
        "confidence-2-marker-size": "11px",
        "confidence-2-marker-symbol": "trianglefilled",
        "confidence-2-text-color": "#8F7463",
        "dataStyle-0-alt-color": "#3C89E0",
        "dataStyle-0-color": "#4398F9",
        "dataStyle-0-fill-color": "#4398F9",
        "dataStyle-0-fill-pattern": "L1",
        "dataStyle-0-fill-patternColor": "#3C89E0",
        "dataStyle-0-line-color": "#3C89E0",
        "dataStyle-0-line-pattern": "1",
        "dataStyle-0-line-thickness": "2px",
        "dataStyle-0-marker-color": "#3C89E0",
        "dataStyle-0-marker-size": "11px",
        "dataStyle-0-marker-symbol": "circlefilled",
        "dataStyle-0-text-color": "#75B3F9",
        "dataStyle-1-alt-color": "#3C89E0",
        "dataStyle-1-color": "#4398F9",
        "dataStyle-1-fill-color": "#4398F9",
        "dataStyle-1-fill-pattern": "L1",
        "dataStyle-1-fill-patternColor": "#3C89E0",
        "dataStyle-1-line-color": "#3C89E0",
        "dataStyle-1-line-pattern": "1",
        "dataStyle-1-line-thickness": "2px",
        "dataStyle-1-marker-color": "#3C89E0",
        "dataStyle-1-marker-size": "11px",
        "dataStyle-1-marker-symbol": "circlefilled",
        "dataStyle-1-text-color": "#75B3F9",
        "dataStyle-10-fill-pattern": "X4",
        "dataStyle-10-line-pattern": "42",
        "dataStyle-10-line-thickness": "2px",
        "dataStyle-11-fill-pattern": "L3",
        "dataStyle-11-line-pattern": "2",
        "dataStyle-11-line-thickness": "2px",
        "dataStyle-2-alt-color": "#D97D3D",
        "dataStyle-2-color": "#F28D44",
        "dataStyle-2-fill-color": "#F28D44",
        "dataStyle-2-fill-pattern": "X1",
        "dataStyle-2-fill-patternColor": "#D97D3D",
        "dataStyle-2-line-color": "#D97D3D",
        "dataStyle-2-line-pattern": "4",
        "dataStyle-2-line-thickness": "2px",
        "dataStyle-2-marker-color": "#D97D3D",
        "dataStyle-2-marker-size": "11px",
        "dataStyle-2-marker-symbol": "squarefilled",
        "dataStyle-2-text-color": "#F2A974",
        "dataStyle-3-alt-color": "#489C8C",
        "dataStyle-3-color": "#54B6A4",
        "dataStyle-3-fill-color": "#54B6A4",
        "dataStyle-3-fill-pattern": "R4",
        "dataStyle-3-fill-patternColor": "#489C8C",
        "dataStyle-3-line-color": "#489C8C",
        "dataStyle-3-line-pattern": "8",
        "dataStyle-3-line-thickness": "2px",
        "dataStyle-3-marker-color": "#489C8C",
        "dataStyle-3-marker-size": "11px",
        "dataStyle-3-marker-symbol": "trianglefilled",
        "dataStyle-3-text-color": "#78B6AB",
        "dataStyle-4-alt-color": "#D473B8",
        "dataStyle-4-color": "#EC80CE",
        "dataStyle-4-fill-color": "#EC80CE",
        "dataStyle-4-fill-pattern": "X3",
        "dataStyle-4-fill-patternColor": "#D473B8",
        "dataStyle-4-line-color": "#D473B8",
        "dataStyle-4-line-pattern": "5",
        "dataStyle-4-line-thickness": "2px",
        "dataStyle-4-marker-color": "#D473B8",
        "dataStyle-4-marker-size": "11px",
        "dataStyle-4-marker-symbol": "diamondfilled",
        "dataStyle-4-text-color": "#ECAFDB",
        "dataStyle-5-alt-color": "#82A637",
        "dataStyle-5-color": "#97C03F",
        "dataStyle-5-fill-color": "#97C03F",
        "dataStyle-5-fill-pattern": "R3",
        "dataStyle-5-fill-patternColor": "#82A637",
        "dataStyle-5-line-color": "#82A637",
        "dataStyle-5-line-pattern": "14",
        "dataStyle-5-line-thickness": "2px",
        "dataStyle-5-marker-color": "#82A637",
        "dataStyle-5-marker-size": "11px",
        "dataStyle-5-marker-symbol": "starfilled",
        "dataStyle-5-text-color": "#A3C066",
        "dataStyle-6-alt-color": "#9364CF",
        "dataStyle-6-color": "#A570E8",
        "dataStyle-6-fill-color": "#A570E8",
        "dataStyle-6-fill-pattern": "L5",
        "dataStyle-6-fill-patternColor": "#9364CF",
        "dataStyle-6-line-color": "#9364CF",
        "dataStyle-6-line-pattern": "26",
        "dataStyle-6-line-thickness": "2px",
        "dataStyle-6-marker-color": "#9364CF",
        "dataStyle-6-marker-size": "11px",
        "dataStyle-6-marker-symbol": "triangledownfilled",
        "dataStyle-6-text-color": "#BE9DE8",
        "dataStyle-7-alt-color": "#C29F16",
        "dataStyle-7-color": "#DCB519",
        "dataStyle-7-fill-color": "#DCB519",
        "dataStyle-7-fill-pattern": "R1",
        "dataStyle-7-fill-patternColor": "#C29F16",
        "dataStyle-7-line-color": "#C29F16",
        "dataStyle-7-line-pattern": "15",
        "dataStyle-7-line-thickness": "2px",
        "dataStyle-7-marker-color": "#C29F16",
        "dataStyle-7-marker-size": "11px",
        "dataStyle-7-marker-symbol": "homedownfilled",
        "dataStyle-7-text-color": "#DCBE44",
        "dataStyle-8-alt-color": "#D66354",
        "dataStyle-8-color": "#F06F5E",
        "dataStyle-8-fill-color": "#F06F5E",
        "dataStyle-8-fill-pattern": "X5",
        "dataStyle-8-fill-patternColor": "#D66354",
        "dataStyle-8-line-color": "#D66354",
        "dataStyle-8-line-pattern": "20",
        "dataStyle-8-line-thickness": "2px",
        "dataStyle-8-marker-color": "#D66354",
        "dataStyle-8-marker-size": "11px",
        "dataStyle-8-text-color": "#F0998E",
        "dataStyle-9-fill-pattern": "L4",
        "dataStyle-9-line-pattern": "41",
        "dataStyle-9-line-thickness": "2px",
        "dataStyle-ramps-0-color-end": "#F28D44",
        "dataStyle-ramps-0-color-neutral": "#373A41",
        "dataStyle-ramps-0-color-start": "#4398F9",
        "dataStyle-specificUse-decrease-alt-color": "#A33636",
        "dataStyle-specificUse-decrease-color": "#BD3F3F",
        "dataStyle-specificUse-decrease-fill-color": "#BD3F3F",
        "dataStyle-specificUse-decrease-fill-pattern": "L1",
        "dataStyle-specificUse-decrease-fill-patternColor": "#A33636",
        "dataStyle-specificUse-decrease-line-color": "#A33636",
        "dataStyle-specificUse-decrease-line-pattern": "1",
        "dataStyle-specificUse-decrease-line-thickness": "1px",
        "dataStyle-specificUse-decrease-marker-color": "#A33636",
        "dataStyle-specificUse-decrease-marker-symbol": "triangledownfilled",
        "dataStyle-specificUse-decrease-text-color": "#A33636",
        "dataStyle-specificUse-error-alt-color": "#9A9A9A",
        "dataStyle-specificUse-error-color": "#B3B3B3",
        "dataStyle-specificUse-error-fill-color": "#B3B3B3",
        "dataStyle-specificUse-error-line-color": "#9A9A9A",
        "dataStyle-specificUse-error-line-pattern": "5",
        "dataStyle-specificUse-error-line-thickness": "2px",
        "dataStyle-specificUse-error-marker-color": "#9A9A9A",
        "dataStyle-specificUse-error-marker-size": "11px",
        "dataStyle-specificUse-error-marker-symbol": "diamondfilled",
        "dataStyle-specificUse-error-text-color": "#CCCCCC",
        "dataStyle-specificUse-increase-alt-color": "#2E8059",
        "dataStyle-specificUse-increase-color": "#389A6B",
        "dataStyle-specificUse-increase-fill-color": "#389A6B",
        "dataStyle-specificUse-increase-fill-pattern": "R2",
        "dataStyle-specificUse-increase-fill-patternColor": "#2E8059",
        "dataStyle-specificUse-increase-line-color": "#2E8059",
        "dataStyle-specificUse-increase-line-pattern": "1",
        "dataStyle-specificUse-increase-line-thickness": "1px",
        "dataStyle-specificUse-increase-marker-color": "#2E8059",
        "dataStyle-specificUse-increase-marker-symbol": "triangleupfilled",
        "dataStyle-specificUse-increase-text-color": "#2E8059",
        "dataStyle-specificUse-missing-alt-color": "#36383B",
        "dataStyle-specificUse-missing-color": "#4E5054",
        "dataStyle-specificUse-missing-fill-color": "#4E5054",
        "dataStyle-specificUse-missing-fill-pattern": "R5",
        "dataStyle-specificUse-missing-fill-patternColor": "#36383B",
        "dataStyle-specificUse-missing-line-color": "#36383B",
        "dataStyle-specificUse-missing-line-pattern": "35",
        "dataStyle-specificUse-missing-line-thickness": "2px",
        "dataStyle-specificUse-missing-marker-color": "#36383B",
        "dataStyle-specificUse-missing-marker-size": "11px",
        "dataStyle-specificUse-missing-marker-symbol": "x",
        "dataStyle-specificUse-missing-text-color": "#66686E",
        "dataStyle-specificUse-other-alt-color": "#707070",
        "dataStyle-specificUse-other-color": "#898989",
        "dataStyle-specificUse-other-fill-color": "#898989",
        "dataStyle-specificUse-other-fill-pattern": "X2",
        "dataStyle-specificUse-other-fill-patternColor": "#707070",
        "dataStyle-specificUse-other-line-color": "#707070",
        "dataStyle-specificUse-other-line-pattern": "34",
        "dataStyle-specificUse-other-line-thickness": "2px",
        "dataStyle-specificUse-other-marker-color": "#707070",
        "dataStyle-specificUse-other-marker-size": "11px",
        "dataStyle-specificUse-other-marker-symbol": "asterisk",
        "dataStyle-specificUse-other-text-color": "#A3A3A3",
        "dataStyle-specificUse-overflow-alt-color": "#A073DB",
        "dataStyle-specificUse-overflow-color": "#B381f5",
        "dataStyle-specificUse-overflow-fill-color": "#B381f5",
        "dataStyle-specificUse-overflow-fill-pattern": "R2",
        "dataStyle-specificUse-overflow-fill-patternColor": "#A073DB",
        "dataStyle-specificUse-overflow-line-color": "#A073DB",
        "dataStyle-specificUse-overflow-line-pattern": "1",
        "dataStyle-specificUse-overflow-line-thickness": "2px",
        "dataStyle-specificUse-overflow-marker-color": "#A073DB",
        "dataStyle-specificUse-overflow-marker-size": "11px",
        "dataStyle-specificUse-overflow-marker-symbol": "triangle",
        "dataStyle-specificUse-overflow-text-color": "#CFB3F5",
        "dataStyle-specificUse-underflow-alt-color": "#64C9C1",
        "dataStyle-specificUse-underflow-color": "#71E4DA",
        "dataStyle-specificUse-underflow-fill-color": "#71E4DA",
        "dataStyle-specificUse-underflow-fill-pattern": "L2",
        "dataStyle-specificUse-underflow-fill-patternColor": "#64C9C1",
        "dataStyle-specificUse-underflow-line-color": "#64C9C1",
        "dataStyle-specificUse-underflow-line-pattern": "1",
        "dataStyle-specificUse-underflow-line-thickness": "2px",
        "dataStyle-specificUse-underflow-marker-color": "#64C9C1",
        "dataStyle-specificUse-underflow-marker-size": "11px",
        "dataStyle-specificUse-underflow-marker-symbol": "triangledown",
        "dataStyle-specificUse-underflow-text-color": "#A0E4DE",
        "dataTip-fill-color": "hsl(219, 12%, 17%)",
        "dataTip-text-color": "hsl(219, 12%, 72%)",
        "dataTip-transparency": "0",
        "elementMeasurement-line-thickness": "2px",
        "elementMeasurement-marker-size": "11px",
        "elementMeasurement-thinLine-line-color": "#3C89E0",
        "elementMeasurement-thinLine-line-pattern": "1",
        "elementMeasurement-thinLine-line-thickness": "1px",
        "fit-1-alt-color": "#547294",
        "fit-1-color": "#749DCC",
        "fit-1-fill-color": "#749DCC",
        "fit-1-fill-pattern": "E",
        "fit-1-fill-patternColor": "#547294",
        "fit-1-line-color": "#547294",
        "fit-1-line-pattern": "1",
        "fit-1-line-thickness": "2px",
        "fit-1-marker-color": "#547294",
        "fit-1-marker-size": "11px",
        "fit-1-marker-symbol": "circlefilled",
        "fit-1-text-color": "#455E7A",
        "fit-2-alt-color": "#8C6951",
        "fit-2-color": "#C49372",
        "fit-2-fill-color": "#749DCC",
        "fit-2-fill-pattern": "E",
        "fit-2-fill-patternColor": "#8C6951",
        "fit-2-line-color": "#8C6951",
        "fit-2-line-pattern": "8",
        "fit-2-line-thickness": "2px",
        "fit-2-marker-color": "#8C6951",
        "fit-2-marker-size": "11px",
        "fit-2-marker-symbol": "trianglefilled",
        "fit-2-text-color": "#735642",
        "geospatial-area-fill-color": "hsl(219, 0%, 100%)",
        "geospatial-area-fill-transparency": "0.8",
        "geospatial-area-focus-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-focus-line-pattern": "34",
        "geospatial-area-focus-line-thickness": "1px",
        "geospatial-area-focus-line-transparency": "0",
        "geospatial-area-focusPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-focusPerimeter-line-pattern": "solid",
        "geospatial-area-focusPerimeter-line-thickness": "0",
        "geospatial-area-focusPerimeter-line-transparency": "1",
        "geospatial-area-innerPerimeter-line-color": "hsl(219, 12%, 8%)",
        "geospatial-area-innerPerimeter-line-pattern": "1",
        "geospatial-area-innerPerimeter-line-thickness": "1px",
        "geospatial-area-innerPerimeter-line-transparency": "0",
        "geospatial-area-innerPerimeterThick-line-color": "hsl(219, 12%, 8%)",
        "geospatial-area-innerPerimeterThick-line-pattern": "1",
        "geospatial-area-innerPerimeterThick-line-thickness": "1px",
        "geospatial-area-innerPerimeterThick-line-transparency": "0",
        "geospatial-area-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-line-pattern": "1",
        "geospatial-area-line-thickness": "1px",
        "geospatial-area-line-transparency": "0",
        "geospatial-area-outerHover-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-outerHover-line-pattern": "1",
        "geospatial-area-outerHover-line-thickness": "3px",
        "geospatial-area-outerHover-line-transparency": "0.4",
        "geospatial-area-outerPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-outerPerimeter-line-pattern": "1",
        "geospatial-area-outerPerimeter-line-thickness": "1px",
        "geospatial-area-outerPerimeter-line-transparency": "0.6",
        "geospatial-area-outerPerimeterInverse-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-outerPerimeterInverse-line-pattern": "1",
        "geospatial-area-outerPerimeterInverse-line-thickness": "0",
        "geospatial-area-outerPerimeterInverse-line-transparency": "1",
        "geospatial-area-outerSelection-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-outerSelection-line-pattern": "1",
        "geospatial-area-outerSelection-line-thickness": "3px",
        "geospatial-area-outerSelection-line-transparency": "0",
        "geospatial-area-selection-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-selection-line-pattern": "2",
        "geospatial-area-selection-line-thickness": "2px",
        "geospatial-area-selection-line-transparency": "0",
        "geospatial-basemap-tileset": "dark",
        "geospatial-overlayData-inset-aspectRatio": "1",
        "geospatial-overlayData-inset-size-default": "60px",
        "geospatial-overlayData-inset-size-max": "100px",
        "geospatial-overlayData-inset-size-min": "30px",
        "geospatial-pie-inset-aspectRatio": "1",
        "geospatial-pie-inset-otherSlicePercent": "10",
        "geospatial-pie-inset-ring-size": "0.4",
        "geospatial-pie-inset-size-default": "60px",
        "geospatial-pie-inset-size-max": "100px",
        "geospatial-pie-inset-size-min": "30px",
        "geospatial-pie-outlinesPerimeter-line-color": "hsl(219, 12%, 72%)",
        "geospatial-pie-outlinesPerimeter-line-pattern": "1",
        "geospatial-pie-outlinesPerimeter-line-thickness": "1px",
        "geospatial-pie-outlinesPerimeter-line-transparency": "0",
        "geospatial-pin-color": "hsl(219, 0%, 100%)",
        "geospatial-pin-icon-text-color": "hsl(219, 0%, 100%)",
        "geospatial-pin-icon-text-fontFamily": "sas-icons",
        "geospatial-pin-icon-text-fontSize": "11.85pt",
        "geospatial-pin-icon-text-fontStyle": "normal",
        "geospatial-pin-icon-text-fontWeight": "400",
        "geospatial-pin-label-text-color": "hsl(219, 12%, 8%)",
        "geospatial-pin-label-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "geospatial-pin-label-text-fontSize": "10.5pt",
        "geospatial-pin-label-text-fontStyle": "normal",
        "geospatial-pin-label-text-fontWeight": "700",
        "geospatial-pin-search-color": "hsl(219, 12%, 55%)",
        "geospatial-pin-search-style": "dark",
        "geospatial-pin-style": "dark",
        "geospatial-region-empty-fill-color": "hsl(219, 12%, 8%)",
        "geospatial-region-empty-fill-pattern": "E",
        "geospatial-region-empty-fill-transparency": "0",
        "geospatial-region-empty-line-color": "#4E5054",
        "geospatial-region-empty-line-pattern": "1",
        "geospatial-region-empty-line-thickness": "2px",
        "geospatial-region-empty-line-transparency": "0",
        "geospatial-route-centerPath-line-color": "hsl(219, 12%, 8%)",
        "geospatial-route-centerPath-line-pattern": "1",
        "geospatial-route-centerPath-line-thickness": "2px",
        "geospatial-route-centerPath-line-transparency": "0",
        "geospatial-route-centroidPoint-pin-color": "hsl(219, 0%, 100%)",
        "geospatial-route-centroidPoint-pin-style": "dark",
        "geospatial-route-mainPath-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-mainPath-line-pattern": "1",
        "geospatial-route-mainPath-line-thickness": "8px",
        "geospatial-route-mainPath-line-transparency": "0",
        "geospatial-route-pathFocus-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-pathFocus-line-pattern": "34",
        "geospatial-route-pathFocus-line-thickness": "1px",
        "geospatial-route-pathFocus-line-transparency": "0",
        "geospatial-route-pathFocusPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-pathFocusPerimeter-line-pattern": "solid",
        "geospatial-route-pathFocusPerimeter-line-thickness": "0",
        "geospatial-route-pathFocusPerimeter-line-transparency": "1",
        "geospatial-route-pathHover-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-pathHover-line-pattern": "1",
        "geospatial-route-pathHover-line-thickness": "3px",
        "geospatial-route-pathHover-line-transparency": "0.4",
        "geospatial-route-pathInnerPerimeter-line-color": "hsl(219, 12%, 8%)",
        "geospatial-route-pathInnerPerimeter-line-pattern": "1",
        "geospatial-route-pathInnerPerimeter-line-thickness": "1px",
        "geospatial-route-pathInnerPerimeter-line-transparency": "0",
        "geospatial-route-pathOuterPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-pathOuterPerimeter-line-pattern": "1",
        "geospatial-route-pathOuterPerimeter-line-thickness": "1px",
        "geospatial-route-pathOuterPerimeter-line-transparency": "0.6",
        "geospatial-route-pathOuterPerimeterInverse-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-pathOuterPerimeterInverse-line-pattern": "1",
        "geospatial-route-pathOuterPerimeterInverse-line-thickness": "0",
        "geospatial-route-pathOuterPerimeterInverse-line-transparency": "1",
        "geospatial-route-pathSelection-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-pathSelection-line-pattern": "1",
        "geospatial-route-pathSelection-line-thickness": "3px",
        "geospatial-route-pathSelection-line-transparency": "0",
        "geospatial-route-point-pin-color": "hsl(219, 0%, 100%)",
        "geospatial-route-point-pin-style": "dark",
        "geospatial-route-point-text-color": "hsl(219, 0%, 100%)",
        "geospatial-route-point-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "geospatial-route-point-text-fontSize": "7.35pt",
        "geospatial-route-point-text-fontStyle": "normal",
        "geospatial-route-point-text-fontWeight": "700",
        "graphAppThemeTokens-brand-color-alert": "hsl(0, 100%, 40%)",
        "graphAppThemeTokens-brand-color-alert-00": "hsl(0, 0%, 100%)",
        "graphAppThemeTokens-brand-color-alert-10": "hsl(0, 100%, 98%)",
        "graphAppThemeTokens-brand-color-alert-100": "hsl(0, 100%, 64%)",
        "graphAppThemeTokens-brand-color-alert-1000": "hsl(0, 0%, 0%)",
        "graphAppThemeTokens-brand-color-alert-20": "hsl(0, 100%, 95%)",
        "graphAppThemeTokens-brand-color-alert-200": "hsl(0, 100%, 59%)",
        "graphAppThemeTokens-brand-color-alert-30": "hsl(0, 100%, 92%)",
        "graphAppThemeTokens-brand-color-alert-300": "hsl(0, 100%, 54%)",
        "graphAppThemeTokens-brand-color-alert-40": "hsl(0, 100%, 88%)",
        "graphAppThemeTokens-brand-color-alert-400": "hsl(0, 100%, 46%)",
        "graphAppThemeTokens-brand-color-alert-450": "hsl(0, 100%, 40%)",
        "graphAppThemeTokens-brand-color-alert-50": "hsl(0, 100%, 84%)",
        "graphAppThemeTokens-brand-color-alert-500": "hsl(0, 100%, 36%)",
        "graphAppThemeTokens-brand-color-alert-550": "hsl(0, 100%, 33%)",
        "graphAppThemeTokens-brand-color-alert-60": "hsl(0, 100%, 79%)",
        "graphAppThemeTokens-brand-color-alert-600": "hsl(0, 100%, 30%)",
        "graphAppThemeTokens-brand-color-alert-650": "hsl(0, 100%, 27%)",
        "graphAppThemeTokens-brand-color-alert-70": "hsl(0, 100%, 76%)",
        "graphAppThemeTokens-brand-color-alert-700": "hsl(0, 100%, 22%)",
        "graphAppThemeTokens-brand-color-alert-750": "hsl(0, 100%, 17%)",
        "graphAppThemeTokens-brand-color-alert-80": "hsl(0, 100%, 72%)",
        "graphAppThemeTokens-brand-color-alert-800": "hsl(0, 100%, 12%)",
        "graphAppThemeTokens-brand-color-alert-850": "hsl(0, 100%, 8%)",
        "graphAppThemeTokens-brand-color-alert-90": "hsl(0, 100%, 68%)",
        "graphAppThemeTokens-brand-color-alert-900": "hsl(0, 100%, 3%)",
        "graphAppThemeTokens-brand-color-blue": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-blue-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-brand-color-blue-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-brand-color-blue-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-brand-color-blue-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-brand-color-blue-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-brand-color-blue-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-brand-color-blue-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-brand-color-blue-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-brand-color-blue-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-brand-color-blue-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-brand-color-blue-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-blue-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-brand-color-blue-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-brand-color-blue-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-brand-color-blue-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-brand-color-blue-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-brand-color-blue-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-brand-color-blue-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-brand-color-blue-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-brand-color-blue-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-brand-color-blue-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-brand-color-blue-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-brand-color-blue-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-brand-color-blue-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-brand-color-blue-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-brand-color-cranberry": "hsl(329, 60%, 40%)",
        "graphAppThemeTokens-brand-color-cranberry-00": "hsl(329,60%,100%)",
        "graphAppThemeTokens-brand-color-cranberry-10": "hsl(329,60%,98%)",
        "graphAppThemeTokens-brand-color-cranberry-100": "hsl(329,60%,62%)",
        "graphAppThemeTokens-brand-color-cranberry-1000": "hsl(329,60%,0%)",
        "graphAppThemeTokens-brand-color-cranberry-20": "hsl(329,60%,97%)",
        "graphAppThemeTokens-brand-color-cranberry-200": "hsl(329,60%,57%)",
        "graphAppThemeTokens-brand-color-cranberry-30": "hsl(329,60%,92%)",
        "graphAppThemeTokens-brand-color-cranberry-300": "hsl(329,60%,55%)",
        "graphAppThemeTokens-brand-color-cranberry-40": "hsl(329,60%,88%)",
        "graphAppThemeTokens-brand-color-cranberry-400": "hsl(329,60%,52%)",
        "graphAppThemeTokens-brand-color-cranberry-450": "hsl(329,60%,40%)",
        "graphAppThemeTokens-brand-color-cranberry-50": "hsl(329,60%,84%)",
        "graphAppThemeTokens-brand-color-cranberry-500": "hsl(329,60%,37%)",
        "graphAppThemeTokens-brand-color-cranberry-550": "hsl(329,60%,32%)",
        "graphAppThemeTokens-brand-color-cranberry-60": "hsl(329,60%,78%)",
        "graphAppThemeTokens-brand-color-cranberry-600": "hsl(329,60%,30%)",
        "graphAppThemeTokens-brand-color-cranberry-650": "hsl(329,60%,27%)",
        "graphAppThemeTokens-brand-color-cranberry-70": "hsl(329,60%,76%)",
        "graphAppThemeTokens-brand-color-cranberry-700": "hsl(329,60%,22%)",
        "graphAppThemeTokens-brand-color-cranberry-750": "hsl(329,60%,16%)",
        "graphAppThemeTokens-brand-color-cranberry-80": "hsl(329,60%,72%)",
        "graphAppThemeTokens-brand-color-cranberry-800": "hsl(329,60%,11%)",
        "graphAppThemeTokens-brand-color-cranberry-850": "hsl(329,60%,9%)",
        "graphAppThemeTokens-brand-color-cranberry-90": "hsl(329,60%,68%)",
        "graphAppThemeTokens-brand-color-cranberry-900": "hsl(329,60%,4%)",
        "graphAppThemeTokens-brand-color-grey": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-brand-color-grey-00": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-brand-color-grey-10": "hsl(219, 12%, 98%)",
        "graphAppThemeTokens-brand-color-grey-100": "hsl(219, 12%, 64%)",
        "graphAppThemeTokens-brand-color-grey-1000": "hsl(219, 0%, 0%)",
        "graphAppThemeTokens-brand-color-grey-20": "hsl(219, 12%, 96%)",
        "graphAppThemeTokens-brand-color-grey-200": "hsl(219, 12%, 59%)",
        "graphAppThemeTokens-brand-color-grey-30": "hsl(219, 12%, 92%)",
        "graphAppThemeTokens-brand-color-grey-300": "hsl(219, 12%, 55%)",
        "graphAppThemeTokens-brand-color-grey-40": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-brand-color-grey-400": "hsl(219, 12%, 48%)",
        "graphAppThemeTokens-brand-color-grey-450": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-brand-color-grey-50": "hsl(219, 12%, 84%)",
        "graphAppThemeTokens-brand-color-grey-500": "hsl(219, 12%, 36%)",
        "graphAppThemeTokens-brand-color-grey-550": "hsl(219, 12%, 33%)",
        "graphAppThemeTokens-brand-color-grey-60": "hsl(219, 12%, 79%)",
        "graphAppThemeTokens-brand-color-grey-600": "hsl(219, 12%, 30%)",
        "graphAppThemeTokens-brand-color-grey-650": "hsl(219, 12%, 27%)",
        "graphAppThemeTokens-brand-color-grey-70": "hsl(219, 12%, 76%)",
        "graphAppThemeTokens-brand-color-grey-700": "hsl(219, 12%, 22%)",
        "graphAppThemeTokens-brand-color-grey-750": "hsl(219, 12%, 17%)",
        "graphAppThemeTokens-brand-color-grey-80": "hsl(219, 12%, 72%)",
        "graphAppThemeTokens-brand-color-grey-800": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-brand-color-grey-850": "hsl(219, 12%, 8%)",
        "graphAppThemeTokens-brand-color-grey-90": "hsl(219, 12%, 68%)",
        "graphAppThemeTokens-brand-color-grey-900": "hsl(219, 12%, 3%)",
        "graphAppThemeTokens-brand-color-info": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-info-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-brand-color-info-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-brand-color-info-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-brand-color-info-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-brand-color-info-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-brand-color-info-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-brand-color-info-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-brand-color-info-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-brand-color-info-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-brand-color-info-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-brand-color-info-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-info-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-brand-color-info-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-brand-color-info-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-brand-color-info-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-brand-color-info-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-brand-color-info-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-brand-color-info-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-brand-color-info-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-brand-color-info-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-brand-color-info-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-brand-color-info-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-brand-color-info-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-brand-color-info-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-brand-color-info-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-brand-color-success": "hsl(123, 46%, 43%)",
        "graphAppThemeTokens-brand-color-success-00": "hsl(123, 0%, 100%)",
        "graphAppThemeTokens-brand-color-success-10": "hsl(123, 46%, 98%)",
        "graphAppThemeTokens-brand-color-success-100": "hsl(123, 46%, 63%)",
        "graphAppThemeTokens-brand-color-success-1000": "hsl(123, 0%, 0%)",
        "graphAppThemeTokens-brand-color-success-20": "hsl(123, 46%, 95%)",
        "graphAppThemeTokens-brand-color-success-200": "hsl(123, 46%, 58%)",
        "graphAppThemeTokens-brand-color-success-30": "hsl(123, 46%, 90%)",
        "graphAppThemeTokens-brand-color-success-300": "hsl(123, 46%, 55%)",
        "graphAppThemeTokens-brand-color-success-40": "hsl(123, 46%, 87%)",
        "graphAppThemeTokens-brand-color-success-400": "hsl(123, 46%, 48%)",
        "graphAppThemeTokens-brand-color-success-450": "hsl(123, 46%, 43%)",
        "graphAppThemeTokens-brand-color-success-50": "hsl(123, 46%, 82%)",
        "graphAppThemeTokens-brand-color-success-500": "hsl(123, 46%, 36%)",
        "graphAppThemeTokens-brand-color-success-550": "hsl(123, 46%, 34%)",
        "graphAppThemeTokens-brand-color-success-60": "hsl(123, 46%, 78%)",
        "graphAppThemeTokens-brand-color-success-600": "hsl(123, 46%, 30%)",
        "graphAppThemeTokens-brand-color-success-650": "hsl(123, 46%, 25%)",
        "graphAppThemeTokens-brand-color-success-70": "hsl(123, 46%, 75%)",
        "graphAppThemeTokens-brand-color-success-700": "hsl(123, 46%, 22%)",
        "graphAppThemeTokens-brand-color-success-750": "hsl(123, 46%, 17%)",
        "graphAppThemeTokens-brand-color-success-80": "hsl(123, 46%, 70%)",
        "graphAppThemeTokens-brand-color-success-800": "hsl(123, 46%, 12%)",
        "graphAppThemeTokens-brand-color-success-850": "hsl(123, 46%, 8%)",
        "graphAppThemeTokens-brand-color-success-90": "hsl(123, 46%, 66%)",
        "graphAppThemeTokens-brand-color-success-900": "hsl(123, 46%, 3%)",
        "graphAppThemeTokens-brand-color-warning": "hsl(43, 89%, 44%)",
        "graphAppThemeTokens-brand-color-warning-00": "hsl(43, 0%, 100%)",
        "graphAppThemeTokens-brand-color-warning-10": "hsl(43, 89%, 98%)",
        "graphAppThemeTokens-brand-color-warning-100": "hsl(43, 89%, 64%)",
        "graphAppThemeTokens-brand-color-warning-1000": "hsl(43, 0%, 0%)",
        "graphAppThemeTokens-brand-color-warning-20": "hsl(43, 89%, 95%)",
        "graphAppThemeTokens-brand-color-warning-200": "hsl(43, 89%, 60%)",
        "graphAppThemeTokens-brand-color-warning-30": "hsl(43, 89%, 92%)",
        "graphAppThemeTokens-brand-color-warning-300": "hsl(43, 89%, 56%)",
        "graphAppThemeTokens-brand-color-warning-40": "hsl(43, 89%, 88%)",
        "graphAppThemeTokens-brand-color-warning-400": "hsl(43, 89%, 52%)",
        "graphAppThemeTokens-brand-color-warning-450": "hsl(43, 89%, 44%)",
        "graphAppThemeTokens-brand-color-warning-50": "hsl(43, 89%, 84%)",
        "graphAppThemeTokens-brand-color-warning-500": "hsl(43, 89%, 39%)",
        "graphAppThemeTokens-brand-color-warning-550": "hsl(43, 89%, 35%)",
        "graphAppThemeTokens-brand-color-warning-60": "hsl(43, 89%, 79%)",
        "graphAppThemeTokens-brand-color-warning-600": "hsl(43, 89%, 31%)",
        "graphAppThemeTokens-brand-color-warning-650": "hsl(43, 89%, 27%)",
        "graphAppThemeTokens-brand-color-warning-70": "hsl(43, 89%, 76%)",
        "graphAppThemeTokens-brand-color-warning-700": "hsl(43, 89%, 24%)",
        "graphAppThemeTokens-brand-color-warning-750": "hsl(43, 89%, 17%)",
        "graphAppThemeTokens-brand-color-warning-80": "hsl(43, 89%, 72%)",
        "graphAppThemeTokens-brand-color-warning-800": "hsl(43, 89%, 12%)",
        "graphAppThemeTokens-brand-color-warning-850": "hsl(43, 89%, 8%)",
        "graphAppThemeTokens-brand-color-warning-90": "hsl(43, 89%, 68%)",
        "graphAppThemeTokens-brand-color-warning-900": "hsl(43, 89%, 3%)",
        "graphAppThemeTokens-color-action-background-subtle-selected": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-color-action-text-subtle-selected": "hsl(219, 12%, 30%)",
        "graphAppThemeTokens-color-alert-00": "hsl(0, 0%, 100%)",
        "graphAppThemeTokens-color-alert-10": "hsl(0, 100%, 98%)",
        "graphAppThemeTokens-color-alert-100": "hsl(0, 100%, 64%)",
        "graphAppThemeTokens-color-alert-1000": "hsl(0, 0%, 0%)",
        "graphAppThemeTokens-color-alert-20": "hsl(0, 100%, 95%)",
        "graphAppThemeTokens-color-alert-200": "hsl(0, 100%, 59%)",
        "graphAppThemeTokens-color-alert-30": "hsl(0, 100%, 92%)",
        "graphAppThemeTokens-color-alert-300": "hsl(0, 100%, 54%)",
        "graphAppThemeTokens-color-alert-40": "hsl(0, 100%, 88%)",
        "graphAppThemeTokens-color-alert-400": "hsl(0, 100%, 46%)",
        "graphAppThemeTokens-color-alert-450": "hsl(0, 100%, 40%)",
        "graphAppThemeTokens-color-alert-50": "hsl(0, 100%, 84%)",
        "graphAppThemeTokens-color-alert-500": "hsl(0, 100%, 36%)",
        "graphAppThemeTokens-color-alert-550": "hsl(0, 100%, 33%)",
        "graphAppThemeTokens-color-alert-60": "hsl(0, 100%, 79%)",
        "graphAppThemeTokens-color-alert-600": "hsl(0, 100%, 30%)",
        "graphAppThemeTokens-color-alert-650": "hsl(0, 100%, 27%)",
        "graphAppThemeTokens-color-alert-70": "hsl(0, 100%, 76%)",
        "graphAppThemeTokens-color-alert-700": "hsl(0, 100%, 22%)",
        "graphAppThemeTokens-color-alert-750": "hsl(0, 100%, 17%)",
        "graphAppThemeTokens-color-alert-80": "hsl(0, 100%, 72%)",
        "graphAppThemeTokens-color-alert-800": "hsl(0, 100%, 12%)",
        "graphAppThemeTokens-color-alert-850": "hsl(0, 100%, 8%)",
        "graphAppThemeTokens-color-alert-90": "hsl(0, 100%, 68%)",
        "graphAppThemeTokens-color-alert-900": "hsl(0, 100%, 3%)",
        "graphAppThemeTokens-color-body-text": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-color-container-background-0": "hsl(219, 12%, 17%)",
        "graphAppThemeTokens-color-container-background-1": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-color-container-background-2": "hsl(219, 12%, 8%)",
        "graphAppThemeTokens-color-container-background-3": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-container-border-4": "hsl(219, 12%, 30%)",
        "graphAppThemeTokens-color-heading-text": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-color-info-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-color-info-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-color-info-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-color-info-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-color-info-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-color-info-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-color-info-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-color-info-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-color-info-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-color-info-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-color-info-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-info-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-color-info-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-color-info-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-color-info-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-color-info-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-color-info-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-color-info-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-color-info-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-color-info-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-color-info-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-color-info-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-color-info-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-color-info-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-color-info-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-color-neutral": "hsl(219, 12%, 64%)",
        "graphAppThemeTokens-color-neutral-00": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-color-neutral-10": "hsl(219, 12%, 98%)",
        "graphAppThemeTokens-color-neutral-100": "hsl(219, 12%, 64%)",
        "graphAppThemeTokens-color-neutral-1000": "hsl(219, 0%, 0%)",
        "graphAppThemeTokens-color-neutral-20": "hsl(219, 12%, 96%)",
        "graphAppThemeTokens-color-neutral-200": "hsl(219, 12%, 59%)",
        "graphAppThemeTokens-color-neutral-30": "hsl(219, 12%, 92%)",
        "graphAppThemeTokens-color-neutral-300": "hsl(219, 12%, 55%)",
        "graphAppThemeTokens-color-neutral-40": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-color-neutral-400": "hsl(219, 12%, 48%)",
        "graphAppThemeTokens-color-neutral-450": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-color-neutral-50": "hsl(219, 12%, 84%)",
        "graphAppThemeTokens-color-neutral-500": "hsl(219, 12%, 36%)",
        "graphAppThemeTokens-color-neutral-550": "hsl(219, 12%, 33%)",
        "graphAppThemeTokens-color-neutral-60": "hsl(219, 12%, 79%)",
        "graphAppThemeTokens-color-neutral-600": "hsl(219, 12%, 30%)",
        "graphAppThemeTokens-color-neutral-650": "hsl(219, 12%, 27%)",
        "graphAppThemeTokens-color-neutral-70": "hsl(219, 12%, 76%)",
        "graphAppThemeTokens-color-neutral-700": "hsl(219, 12%, 22%)",
        "graphAppThemeTokens-color-neutral-750": "hsl(219, 12%, 17%)",
        "graphAppThemeTokens-color-neutral-80": "hsl(219, 12%, 72%)",
        "graphAppThemeTokens-color-neutral-800": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-color-neutral-850": "hsl(219, 12%, 8%)",
        "graphAppThemeTokens-color-neutral-90": "hsl(219, 12%, 68%)",
        "graphAppThemeTokens-color-neutral-900": "hsl(219, 12%, 3%)",
        "graphAppThemeTokens-color-primary": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-color-primary-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-color-primary-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-color-primary-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-color-primary-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-color-primary-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-color-primary-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-color-primary-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-color-primary-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-color-primary-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-color-primary-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-color-primary-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-primary-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-color-primary-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-color-primary-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-color-primary-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-color-primary-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-color-primary-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-color-primary-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-color-primary-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-color-primary-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-color-primary-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-color-primary-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-color-primary-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-color-primary-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-color-primary-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-color-secondary": "hsl(329,60%,40%)",
        "graphAppThemeTokens-color-secondary-00": "hsl(329,60%,100%)",
        "graphAppThemeTokens-color-secondary-10": "hsl(329,60%,98%)",
        "graphAppThemeTokens-color-secondary-100": "hsl(329,60%,62%)",
        "graphAppThemeTokens-color-secondary-1000": "hsl(329,60%,0%)",
        "graphAppThemeTokens-color-secondary-20": "hsl(329,60%,97%)",
        "graphAppThemeTokens-color-secondary-200": "hsl(329,60%,57%)",
        "graphAppThemeTokens-color-secondary-30": "hsl(329,60%,92%)",
        "graphAppThemeTokens-color-secondary-300": "hsl(329,60%,55%)",
        "graphAppThemeTokens-color-secondary-40": "hsl(329,60%,88%)",
        "graphAppThemeTokens-color-secondary-400": "hsl(329,60%,52%)",
        "graphAppThemeTokens-color-secondary-450": "hsl(329,60%,40%)",
        "graphAppThemeTokens-color-secondary-50": "hsl(329,60%,84%)",
        "graphAppThemeTokens-color-secondary-500": "hsl(329,60%,37%)",
        "graphAppThemeTokens-color-secondary-550": "hsl(329,60%,32%)",
        "graphAppThemeTokens-color-secondary-60": "hsl(329,60%,78%)",
        "graphAppThemeTokens-color-secondary-600": "hsl(329,60%,30%)",
        "graphAppThemeTokens-color-secondary-650": "hsl(329,60%,27%)",
        "graphAppThemeTokens-color-secondary-70": "hsl(329,60%,76%)",
        "graphAppThemeTokens-color-secondary-700": "hsl(329,60%,22%)",
        "graphAppThemeTokens-color-secondary-750": "hsl(329,60%,16%)",
        "graphAppThemeTokens-color-secondary-80": "hsl(329,60%,72%)",
        "graphAppThemeTokens-color-secondary-800": "hsl(329,60%,11%)",
        "graphAppThemeTokens-color-secondary-850": "hsl(329,60%,9%)",
        "graphAppThemeTokens-color-secondary-90": "hsl(329,60%,68%)",
        "graphAppThemeTokens-color-secondary-900": "hsl(329,60%,4%)",
        "graphAppThemeTokens-color-status-icon-alert": "hsl(0, 100%, 64%)",
        "graphAppThemeTokens-color-status-icon-info": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-color-status-icon-neutral": "hsl(219, 12%, 64%)",
        "graphAppThemeTokens-color-status-icon-success": "hsl(123, 46%, 63%)",
        "graphAppThemeTokens-color-status-icon-warning": "hsl(43, 89%, 64%)",
        "graphAppThemeTokens-color-success-00": "hsl(123, 0%, 100%)",
        "graphAppThemeTokens-color-success-10": "hsl(123, 46%, 98%)",
        "graphAppThemeTokens-color-success-100": "hsl(123, 46%, 63%)",
        "graphAppThemeTokens-color-success-1000": "hsl(123, 0%, 0%)",
        "graphAppThemeTokens-color-success-20": "hsl(123, 46%, 95%)",
        "graphAppThemeTokens-color-success-200": "hsl(123, 46%, 58%)",
        "graphAppThemeTokens-color-success-30": "hsl(123, 46%, 90%)",
        "graphAppThemeTokens-color-success-300": "hsl(123, 46%, 55%)",
        "graphAppThemeTokens-color-success-40": "hsl(123, 46%, 87%)",
        "graphAppThemeTokens-color-success-400": "hsl(123, 46%, 48%)",
        "graphAppThemeTokens-color-success-450": "hsl(123, 46%, 43%)",
        "graphAppThemeTokens-color-success-50": "hsl(123, 46%, 82%)",
        "graphAppThemeTokens-color-success-500": "hsl(123, 46%, 36%)",
        "graphAppThemeTokens-color-success-550": "hsl(123, 46%, 34%)",
        "graphAppThemeTokens-color-success-60": "hsl(123, 46%, 78%)",
        "graphAppThemeTokens-color-success-600": "hsl(123, 46%, 30%)",
        "graphAppThemeTokens-color-success-650": "hsl(123, 46%, 25%)",
        "graphAppThemeTokens-color-success-70": "hsl(123, 46%, 75%)",
        "graphAppThemeTokens-color-success-700": "hsl(123, 46%, 22%)",
        "graphAppThemeTokens-color-success-750": "hsl(123, 46%, 17%)",
        "graphAppThemeTokens-color-success-80": "hsl(123, 46%, 70%)",
        "graphAppThemeTokens-color-success-800": "hsl(123, 46%, 12%)",
        "graphAppThemeTokens-color-success-850": "hsl(123, 46%, 8%)",
        "graphAppThemeTokens-color-success-90": "hsl(123, 46%, 66%)",
        "graphAppThemeTokens-color-success-900": "hsl(123, 46%, 3%)",
        "graphAppThemeTokens-color-text-neutral": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-color-text-primary": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-color-warning-00": "hsl(43, 0%, 100%)",
        "graphAppThemeTokens-color-warning-10": "hsl(43, 89%, 98%)",
        "graphAppThemeTokens-color-warning-100": "hsl(43, 89%, 64%)",
        "graphAppThemeTokens-color-warning-1000": "hsl(43, 0%, 0%)",
        "graphAppThemeTokens-color-warning-20": "hsl(43, 89%, 95%)",
        "graphAppThemeTokens-color-warning-200": "hsl(43, 89%, 60%)",
        "graphAppThemeTokens-color-warning-30": "hsl(43, 89%, 92%)",
        "graphAppThemeTokens-color-warning-300": "hsl(43, 89%, 56%)",
        "graphAppThemeTokens-color-warning-40": "hsl(43, 89%, 88%)",
        "graphAppThemeTokens-color-warning-400": "hsl(43, 89%, 52%)",
        "graphAppThemeTokens-color-warning-450": "hsl(43, 89%, 44%)",
        "graphAppThemeTokens-color-warning-50": "hsl(43, 89%, 84%)",
        "graphAppThemeTokens-color-warning-500": "hsl(43, 89%, 39%)",
        "graphAppThemeTokens-color-warning-550": "hsl(43, 89%, 35%)",
        "graphAppThemeTokens-color-warning-60": "hsl(43, 89%, 79%)",
        "graphAppThemeTokens-color-warning-600": "hsl(43, 89%, 31%)",
        "graphAppThemeTokens-color-warning-650": "hsl(43, 89%, 27%)",
        "graphAppThemeTokens-color-warning-70": "hsl(43, 89%, 76%)",
        "graphAppThemeTokens-color-warning-700": "hsl(43, 89%, 24%)",
        "graphAppThemeTokens-color-warning-750": "hsl(43, 89%, 17%)",
        "graphAppThemeTokens-color-warning-80": "hsl(43, 89%, 72%)",
        "graphAppThemeTokens-color-warning-800": "hsl(43, 89%, 12%)",
        "graphAppThemeTokens-color-warning-850": "hsl(43, 89%, 8%)",
        "graphAppThemeTokens-color-warning-90": "hsl(43, 89%, 68%)",
        "graphAppThemeTokens-color-warning-900": "hsl(43, 89%, 3%)",
        "graphAppThemeTokens-font-family-primary": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "graphAppThemeTokens-font-size-body-text-l": "11.85pt",
        "graphAppThemeTokens-font-size-body-text-m": "10.5pt",
        "graphAppThemeTokens-font-size-body-text-m-rem": "0.875rem",
        "graphAppThemeTokens-font-size-body-text-s": "9.3pt",
        "graphAppThemeTokens-font-size-body-text-xl": "13.92pt",
        "graphAppThemeTokens-font-size-body-text-xs": "8.325pt",
        "graphAppThemeTokens-font-size-body-text-xxl": "14.925pt",
        "graphAppThemeTokens-font-size-body-text-xxs": "7.35pt",
        "graphAppThemeTokens-font-size-body-text-xxxl": "16.8pt",
        "graphAppThemeTokens-font-size-body-text-xxxs": "6.525pt",
        "graphAppThemeTokens-font-size-body-text-xxxxl": "18.9pt",
        "graphAppThemeTokens-font-size-heading-text-1": "34pt",
        "graphAppThemeTokens-font-size-heading-text-2": "27pt",
        "graphAppThemeTokens-font-size-heading-text-3": "21pt",
        "graphAppThemeTokens-font-size-heading-text-4": "17pt",
        "graphAppThemeTokens-font-size-heading-text-5": "11pt",
        "graphAppThemeTokens-font-size-heading-text-6": "9pt",
        "graphAppThemeTokens-font-style-expression": "normal",
        "graphAppThemeTokens-font-style-overflow-wrap-normal": "normal",
        "graphAppThemeTokens-font-style-weight-400": "400",
        "graphAppThemeTokens-font-style-weight-700": "700",
        "graphAppThemeTokens-size-border-width-s": "1px",
        "graphs-band-displayOpts": "standard",
        "graphs-bar-displayOpts": "standard",
        "graphs-blockPlot-altBlock-color": "hsl(219, 12%, 27%)",
        "graphs-blockPlot-altBlock-fill-color": "hsl(219, 12%, 27%)",
        "graphs-blockPlot-block-color": "hsl(219, 12%, 17%)",
        "graphs-blockPlot-block-fill-color": "hsl(219, 12%, 17%)",
        "graphs-box-capStyle": "serif",
        "graphs-box-connect": "mean",
        "graphs-box-displayOpts": "standard",
        "graphs-box-mean-alt-color": "#9A9A9A",
        "graphs-box-mean-marker-color": "#9A9A9A",
        "graphs-box-mean-marker-size": "11px",
        "graphs-box-mean-marker-symbol": "squarefilled",
        "graphs-box-mean-text-color": "#9A9A9A",
        "graphs-box-median-alt-color": "#9A9A9A",
        "graphs-box-median-line-color": "#9A9A9A",
        "graphs-box-median-line-pattern": "1",
        "graphs-box-median-line-thickness": "1px",
        "graphs-box-median-text-color": "#9A9A9A",
        "graphs-box-whisker-alt-color": "#9A9A9A",
        "graphs-box-whisker-line-color": "#9A9A9A",
        "graphs-box-whisker-line-pattern": "1",
        "graphs-box-whisker-line-thickness": "1px",
        "graphs-box-whisker-text-color": "#9A9A9A",
        "graphs-bubble-displayOpts": "standard",
        "graphs-bubble-size-max": "28px",
        "graphs-bubble-size-min": "7px",
        "graphs-decisionTree-displayOpts": "standard",
        "graphs-ellipse-displayOpts": "standard",
        "graphs-heatMap-displayOpts": "standard",
        "graphs-highLow-displayOpts": "standard",
        "graphs-histogram-displayOpts": "standard",
        "graphs-icicle-displayOpts": "standard",
        "graphs-icicle-gap": "1dpx",
        "graphs-keyValue-outline-line-color": "#4398F9",
        "graphs-keyValue-outline-line-thickness": "12px",
        "graphs-keyValue-text-color": "#3C89E0",
        "graphs-keyValue-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "graphs-keyValue-text-fontSize": "9.3pt",
        "graphs-keyValue-text-fontStyle": "normal",
        "graphs-keyValue-text-fontWeight": "400",
        "graphs-lineChart-displayOpts": "standard",
        "graphs-mapRegionLayer-displayOpts": "standard",
        "graphs-mosaic-displayOpts": "standard",
        "graphs-mosaic-gap": "1dpx",
        "graphs-network-displayOpts": "standard",
        "graphs-pie-displayOpts": "standard",
        "graphs-pie-donut": "1",
        "graphs-pie-gap": "1dpx",
        "graphs-pie-hole-size-min": "0.15",
        "graphs-pie-ring-size": "0.3",
        "graphs-sankey-displayOpts": "standard",
        "graphs-scatter-marker-size-max": "28px",
        "graphs-scatter-marker-size-min": "7px",
        "graphs-schedule-displayOpts": "standard",
        "graphs-series-displayOpts": "standard",
        "graphs-series-line-thickness-max": "8px",
        "graphs-series-line-thickness-min": "2px",
        "graphs-timeSeries-displayOpts": "standard",
        "graphs-treeMap-displayOpts": "standard",
        "graphs-treeMap-gap": "1dpx",
        "graphs-waterfall-connect-line-color": "#9A9A9A",
        "graphs-waterfall-connect-line-pattern": "1",
        "graphs-waterfall-connect-line-thickness": "1px",
        "graphs-waterfall-displayOpts": "standard",
        "graphs-waterfall-final-alt-color": "#575757",
        "graphs-waterfall-final-color": "#707070",
        "graphs-waterfall-final-fill-color": "#707070",
        "graphs-waterfall-final-fill-pattern": "X1",
        "graphs-waterfall-final-fill-patternColor": "#575757",
        "graphs-waterfall-final-line-color": "#575757",
        "graphs-waterfall-final-line-pattern": "1",
        "graphs-waterfall-final-line-thickness": "1px",
        "graphs-waterfall-final-marker-color": "#575757",
        "graphs-waterfall-final-marker-size": "11px",
        "graphs-waterfall-final-marker-symbol": "squarefilled",
        "graphs-waterfall-final-text-color": "hsl(219, 12%, 79%)",
        "graphs-waterfall-initial-alt-color": "#575757",
        "graphs-waterfall-initial-color": "#707070",
        "graphs-waterfall-initial-fill-color": "#707070",
        "graphs-waterfall-initial-fill-pattern": "X4",
        "graphs-waterfall-initial-fill-patternColor": "#575757",
        "graphs-waterfall-initial-line-color": "#575757",
        "graphs-waterfall-initial-line-pattern": "1",
        "graphs-waterfall-initial-line-thickness": "1px",
        "graphs-waterfall-initial-marker-color": "#575757",
        "graphs-waterfall-initial-marker-size": "11px",
        "graphs-waterfall-initial-marker-symbol": "trianglerightfilled",
        "graphs-waterfall-initial-text-color": "hsl(219, 12%, 79%)",
        "interaction-animationControlPanel-fill-color": "hsl(219, 12%, 17%)",
        "interaction-animationControlPanel-frameBorder": "1",
        "interaction-animationControlPanel-line-color": "hsl(219, 12%, 55%)",
        "interaction-dropZone-fill-color": "hsl(212, 94%, 47%)",
        "interaction-dropZone-line-color": "hsl(212, 94%, 47%)",
        "interaction-dropZone-line-pattern": "1",
        "interaction-dropZone-line-thickness": "1px",
        "interaction-dropZone-transparency": "0.85",
        "interaction-hyperlink-text-color": "hsl(219, 12%, 72%)",
        "interaction-keyFrameValue-padding": "0.03",
        "interaction-keyFrameValue-text-alignment-horizontal": "right",
        "interaction-keyFrameValue-text-alignment-vertical": "bottom",
        "interaction-keyFrameValue-text-color": "hsl(219, 12%, 96%)",
        "interaction-keyFrameValue-text-fitWidth": "0.42",
        "interaction-keyFrameValue-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "interaction-keyFrameValue-text-fontSize": "13.92pt",
        "interaction-keyFrameValue-text-fontStyle": "normal",
        "interaction-keyFrameValue-text-fontWeight": "700",
        "interaction-keyFrameValue-text-transparency": "0",
        "kpiStyles-indicator-alt-color": "hsl(219, 12%, 17%)",
        "kpiStyles-indicator-fill-color": "hsl(219, 12%, 98%)",
        "kpiStyles-indicator-line-color": "hsl(219, 0%, 0%)",
        "kpiStyles-indicator-transparency": "0.6",
        "kpiStyles-overflow-alt-color": "#41B27C",
        "kpiStyles-overflow-color": "#4ACC8E",
        "kpiStyles-overflow-fill-color": "#4ACC8E",
        "kpiStyles-overflow-fill-pattern": "R2",
        "kpiStyles-overflow-fill-patternColor": "#41B27C",
        "kpiStyles-overflow-line-color": "#41B27C",
        "kpiStyles-overflow-line-pattern": "1",
        "kpiStyles-overflow-line-thickness": "2px",
        "kpiStyles-overflow-marker-color": "#41B27C",
        "kpiStyles-overflow-marker-size": "11px",
        "kpiStyles-overflow-marker-symbol": "circlefilled",
        "kpiStyles-overflow-text-color": "#72CCA1",
        "kpiStyles-range-1-alt-color": "#A33636",
        "kpiStyles-range-1-color": "#BD3F3F",
        "kpiStyles-range-1-fill-color": "#BD3F3F",
        "kpiStyles-range-1-fill-pattern": "R3",
        "kpiStyles-range-1-fill-patternColor": "#A33636",
        "kpiStyles-range-1-line-color": "#A33636",
        "kpiStyles-range-1-line-pattern": "1",
        "kpiStyles-range-1-line-thickness": "2px",
        "kpiStyles-range-1-marker-color": "#A33636",
        "kpiStyles-range-1-marker-size": "11px",
        "kpiStyles-range-1-marker-symbol": "circlefilled",
        "kpiStyles-range-1-text-color": "#BD6464",
        "kpiStyles-range-2-alt-color": "#C2864D",
        "kpiStyles-range-2-color": "#DC9857",
        "kpiStyles-range-2-fill-color": "#DC9857",
        "kpiStyles-range-2-fill-pattern": "L1",
        "kpiStyles-range-2-fill-patternColor": "#C2864D",
        "kpiStyles-range-2-line-color": "#C2864D",
        "kpiStyles-range-2-line-pattern": "1",
        "kpiStyles-range-2-line-thickness": "2px",
        "kpiStyles-range-2-marker-color": "#C2864D",
        "kpiStyles-range-2-marker-size": "11px",
        "kpiStyles-range-2-marker-symbol": "circlefilled",
        "kpiStyles-range-2-text-color": "#DCAF84",
        "kpiStyles-range-3-alt-color": "#B5B041",
        "kpiStyles-range-3-color": "#CFCA4A",
        "kpiStyles-range-3-fill-color": "#CFCA4A",
        "kpiStyles-range-3-fill-pattern": "R4",
        "kpiStyles-range-3-fill-patternColor": "#B5B041",
        "kpiStyles-range-3-line-color": "#B5B041",
        "kpiStyles-range-3-line-pattern": "1",
        "kpiStyles-range-3-line-thickness": "2px",
        "kpiStyles-range-3-marker-color": "#B5B041",
        "kpiStyles-range-3-marker-size": "11px",
        "kpiStyles-range-3-marker-symbol": "circlefilled",
        "kpiStyles-range-3-text-color": "#CFCC74",
        "kpiStyles-range-4-alt-color": "#639645",
        "kpiStyles-range-4-color": "#74B151",
        "kpiStyles-range-4-fill-color": "#74B151",
        "kpiStyles-range-4-fill-pattern": "X1",
        "kpiStyles-range-4-fill-patternColor": "#639645",
        "kpiStyles-range-4-line-color": "#639645",
        "kpiStyles-range-4-line-pattern": "1",
        "kpiStyles-range-4-line-thickness": "2px",
        "kpiStyles-range-4-marker-color": "#639645",
        "kpiStyles-range-4-marker-size": "11px",
        "kpiStyles-range-4-marker-symbol": "circlefilled",
        "kpiStyles-range-4-text-color": "#8BB175",
        "kpiStyles-range-5-alt-color": "#2E8059",
        "kpiStyles-range-5-color": "#389A6B",
        "kpiStyles-range-5-fill-color": "#389A6B",
        "kpiStyles-range-5-fill-pattern": "X3",
        "kpiStyles-range-5-fill-patternColor": "#2E8059",
        "kpiStyles-range-5-line-color": "#2E8059",
        "kpiStyles-range-5-line-pattern": "1",
        "kpiStyles-range-5-line-thickness": "2px",
        "kpiStyles-range-5-marker-color": "#2E8059",
        "kpiStyles-range-5-marker-size": "11px",
        "kpiStyles-range-5-marker-symbol": "circlefilled",
        "kpiStyles-range-5-text-color": "#569A7A",
        "kpiStyles-range-alt-color": "#050505",
        "kpiStyles-range-text-color": "hsl(219, 12%, 98%)",
        "kpiStyles-range-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "kpiStyles-range-text-fontSize": "8.325pt",
        "kpiStyles-range-text-fontStyle": "normal",
        "kpiStyles-range-text-fontWeight": "400",
        "kpiStyles-underflow-alt-color": "#D64747",
        "kpiStyles-underflow-color": "#F05050",
        "kpiStyles-underflow-fill-color": "#F05050",
        "kpiStyles-underflow-fill-pattern": "L2",
        "kpiStyles-underflow-fill-patternColor": "#D64747",
        "kpiStyles-underflow-line-color": "#D64747",
        "kpiStyles-underflow-line-pattern": "1",
        "kpiStyles-underflow-line-thickness": "2px",
        "kpiStyles-underflow-marker-color": "#D64747",
        "kpiStyles-underflow-marker-size": "11px",
        "kpiStyles-underflow-marker-symbol": "circlefilled",
        "kpiStyles-underflow-text-color": "#F07F7F",
        "kpiStyles-value-alt-text-color": "#0A0A0A",
        "kpiStyles-value-text-color": "hsl(219, 12%, 96%)",
        "kpiStyles-value-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "kpiStyles-value-text-fontSize": "9.3pt",
        "kpiStyles-value-text-fontStyle": "normal",
        "kpiStyles-value-text-fontWeight": "400",
        "layout-dataMatrix-cellSeparator": "1",
        "layout-dataMatrix-matrixBorder": "hsl(219, 12%, 98%)",
        "layout-dataPanel-confineTickValues": "true",
        "layout-lattice-confineTickValues": "true",
        "layout-matrixBorder-line-color": "hsl(219, 12%, 98%)",
        "layout-matrixBorder-line-pattern": "1",
        "layout-matrixBorder-line-thickness": "1dpx",
        "layout-overlay": "top",
        "legend-continuous-frameBorder": "0",
        "legend-continuous-title-hAlign": "left",
        "legend-continuous-title-position": "top",
        "legend-continuous-titleSeparatorTop": "1",
        "legend-discrete-frameBorder": "0",
        "legend-discrete-title-hAlign": "left",
        "legend-discrete-title-position": "top",
        "legend-discrete-titleSeparatorTop": "1",
        "legend-global-dataMatrix-align": "begin",
        "legend-global-dataMatrix-alignTo": "wall",
        "legend-global-lattice": "begin",
        "legend-global-overlay-align": "begin",
        "legend-global-overlay-alignTo": "wall",
        "legend-global-region-align": "begin",
        "legend-size-frameBorder": "0",
        "legend-size-title-hAlign": "left",
        "legend-size-title-position": "top",
        "legend-size-titleSeparatorTop": "1",
        "nodeLinkDiagram-dataNode-0-alt-color": "#7B7B7B",
        "nodeLinkDiagram-dataNode-0-color": "#595959",
        "nodeLinkDiagram-dataNode-0-fill-color": "#595959",
        "nodeLinkDiagram-dataNode-0-fill-pattern": "L1",
        "nodeLinkDiagram-dataNode-0-fill-patternColor": "#595959",
        "nodeLinkDiagram-dataNode-0-line-color": "#7B7B7B",
        "nodeLinkDiagram-dataNode-0-line-thickness": "1px",
        "nodeLinkDiagram-dataNode-0-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-dataNode-1-alt-color": "#3C89E0",
        "nodeLinkDiagram-dataNode-1-color": "#346195",
        "nodeLinkDiagram-dataNode-1-fill-color": "#346195",
        "nodeLinkDiagram-dataNode-1-line-color": "#3C89E0",
        "nodeLinkDiagram-dataNode-1-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-dataNode-2-alt-color": "#D97D3D",
        "nodeLinkDiagram-dataNode-2-color": "#8C5B3A",
        "nodeLinkDiagram-dataNode-2-fill-color": "#8C5B3A",
        "nodeLinkDiagram-dataNode-2-line-color": "#D97D3D",
        "nodeLinkDiagram-dataNode-2-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-dataNode-3-alt-color": "#489C8C",
        "nodeLinkDiagram-dataNode-3-color": "#3D706A",
        "nodeLinkDiagram-dataNode-3-fill-color": "#3D706A",
        "nodeLinkDiagram-dataNode-3-line-color": "#489C8C",
        "nodeLinkDiagram-dataNode-3-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-dataNode-4-alt-color": "#D473B8",
        "nodeLinkDiagram-dataNode-4-color": "#89557F",
        "nodeLinkDiagram-dataNode-4-fill-color": "#89557F",
        "nodeLinkDiagram-dataNode-4-line-color": "#D473B8",
        "nodeLinkDiagram-dataNode-4-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-dataNode-5-alt-color": "#82A637",
        "nodeLinkDiagram-dataNode-5-color": "#5E7538",
        "nodeLinkDiagram-dataNode-5-fill-color": "#5E7538",
        "nodeLinkDiagram-dataNode-5-line-color": "#82A637",
        "nodeLinkDiagram-dataNode-5-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-dataNode-6-alt-color": "#9364CF",
        "nodeLinkDiagram-dataNode-6-color": "#654D8C",
        "nodeLinkDiagram-dataNode-6-fill-color": "#654D8C",
        "nodeLinkDiagram-dataNode-6-line-color": "#9364CF",
        "nodeLinkDiagram-dataNode-6-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-dataNode-7-alt-color": "#C29F16",
        "nodeLinkDiagram-dataNode-7-color": "#816F25",
        "nodeLinkDiagram-dataNode-7-fill-color": "#816F25",
        "nodeLinkDiagram-dataNode-7-line-color": "#C29F16",
        "nodeLinkDiagram-dataNode-7-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-dataNode-8-alt-color": "#D66354",
        "nodeLinkDiagram-dataNode-8-color": "#8B4D48",
        "nodeLinkDiagram-dataNode-8-fill-color": "#8B4D48",
        "nodeLinkDiagram-dataNode-8-line-color": "#D66354",
        "nodeLinkDiagram-dataNode-8-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-dataNode-ramps-0-fill-end": "#F28D44",
        "nodeLinkDiagram-dataNode-ramps-0-fill-neutral": "#373A41",
        "nodeLinkDiagram-dataNode-ramps-0-fill-start": "#4398F9",
        "nodeLinkDiagram-details-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-details-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-details-text-fontSize": "7.35pt",
        "nodeLinkDiagram-details-text-fontStyle": "normal",
        "nodeLinkDiagram-details-text-fontWeight": "400",
        "nodeLinkDiagram-group-closed-fill-color": "hsl(219, 12%, 17%)",
        "nodeLinkDiagram-group-closed-line-color": "hsl(219, 12%, 92%)",
        "nodeLinkDiagram-group-closed-line-thickness": "1px",
        "nodeLinkDiagram-group-closed-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-group-closed-transparency": "0",
        "nodeLinkDiagram-group-contentArea-fill-color": "hsl(219, 12%, 17%)",
        "nodeLinkDiagram-group-contentArea-fill-transparency": "0.2",
        "nodeLinkDiagram-group-open-fill-color": "hsl(219, 12%, 17%)",
        "nodeLinkDiagram-group-open-line-color": "hsl(219, 12%, 92%)",
        "nodeLinkDiagram-group-open-line-thickness": "1px",
        "nodeLinkDiagram-group-open-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-group-open-transparency": "0",
        "nodeLinkDiagram-group-title-fill-transparency": "0.2",
        "nodeLinkDiagram-group-title-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-group-title-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-group-title-text-fontSize": "10.5pt",
        "nodeLinkDiagram-group-title-text-fontStyle": "normal",
        "nodeLinkDiagram-group-title-text-fontWeight": "400",
        "nodeLinkDiagram-iconNode-end-text-color": "hsl(0, 100%, 64%)",
        "nodeLinkDiagram-iconNode-fill-color": "hsl(219, 12%, 17%)",
        "nodeLinkDiagram-iconNode-gateway-exclusive-text-color": "hsl(212, 94%, 62%)",
        "nodeLinkDiagram-iconNode-gateway-inclusive-text-color": "hsl(212, 94%, 62%)",
        "nodeLinkDiagram-iconNode-start-text-color": "hsl(123, 46%, 63%)",
        "nodeLinkDiagram-iconNode-timer-text-color": "hsl(212, 94%, 62%)",
        "nodeLinkDiagram-inputLabel-text-color": "hsl(219, 12%, 96%)",
        "nodeLinkDiagram-inputLabel-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-inputLabel-text-fontSize": "10.5pt",
        "nodeLinkDiagram-inputLabel-text-fontStyle": "normal",
        "nodeLinkDiagram-inputLabel-text-fontWeight": "400",
        "nodeLinkDiagram-label-text-color": "hsl(219, 12%, 96%)",
        "nodeLinkDiagram-label-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-label-text-fontSize": "10.5pt",
        "nodeLinkDiagram-label-text-fontStyle": "normal",
        "nodeLinkDiagram-label-text-fontWeight": "400",
        "nodeLinkDiagram-link-alt-color": "#757575",
        "nodeLinkDiagram-link-color": "#6D6D6D",
        "nodeLinkDiagram-link-crossover-alt-color": "#757575",
        "nodeLinkDiagram-link-crossover-line-color": "#757575",
        "nodeLinkDiagram-link-crossover-line-pattern": "2",
        "nodeLinkDiagram-link-crossover-line-thickness": "2px",
        "nodeLinkDiagram-link-crossover-line-transparency": "0",
        "nodeLinkDiagram-link-fill-color": "#6D6D6D",
        "nodeLinkDiagram-link-line-color": "#757575",
        "nodeLinkDiagram-link-line-pattern": "1",
        "nodeLinkDiagram-link-line-thickness": "2px",
        "nodeLinkDiagram-link-marker-color": "#757575",
        "nodeLinkDiagram-note-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-note-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-note-text-fontSize": "7.35pt",
        "nodeLinkDiagram-note-text-fontStyle": "normal",
        "nodeLinkDiagram-note-text-fontWeight": "400",
        "nodeLinkDiagram-outlinesNode-line-color": "hsl(219, 12%, 27%)",
        "nodeLinkDiagram-status-animatedProgressIndicator-text-color": "hsl(212, 94%, 62%)",
        "nodeLinkDiagram-status-background-fill-color": "hsl(219, 12%, 17%)",
        "nodeLinkDiagram-status-clustered-text-color": "hsl(212, 94%, 62%)",
        "nodeLinkDiagram-status-complete-text-color": "hsl(123, 46%, 63%)",
        "nodeLinkDiagram-status-error-text-color": "hsl(0, 100%, 64%)",
        "nodeLinkDiagram-status-important-text-color": "hsl(0, 100%, 64%)",
        "nodeLinkDiagram-status-incomplete-text-color": "hsl(0, 100%, 64%)",
        "nodeLinkDiagram-status-incompleteInProgress-text-color": "hsl(212, 94%, 62%)",
        "nodeLinkDiagram-status-information-text-color": "hsl(212, 94%, 62%)",
        "nodeLinkDiagram-status-locked-text-color": "hsl(219, 12%, 42%)",
        "nodeLinkDiagram-status-mediumPriority-text-color": "hsl(43, 89%, 64%)",
        "nodeLinkDiagram-status-neutral-text-color": "hsl(219, 12%, 42%)",
        "nodeLinkDiagram-status-progress-text-color": "hsl(212, 94%, 62%)",
        "nodeLinkDiagram-status-scheduled-text-color": "hsl(212, 94%, 62%)",
        "nodeLinkDiagram-status-stopped-text-color": "hsl(0, 100%, 64%)",
        "nodeLinkDiagram-status-stopping-text-color": "hsl(0, 100%, 64%)",
        "nodeLinkDiagram-status-warning-text-color": "hsl(43, 89%, 64%)",
        "nodeLinkDiagram-subject-fill-color": "#346195",
        "nodeLinkDiagram-subject-line-color": "#3C89E0",
        "nodeLinkDiagram-subject-line-pattern": "1",
        "nodeLinkDiagram-subject-line-thickness": "1px",
        "nodeLinkDiagram-subject-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-title-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-title-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-title-text-fontSize": "9.3pt",
        "nodeLinkDiagram-title-text-fontStyle": "normal",
        "nodeLinkDiagram-title-text-fontWeight": "700",
        "outlier-alt-color": "#808080",
        "outlier-color": "#9A9A9A",
        "outlier-fill-color": "#9A9A9A",
        "outlier-line-color": "#808080",
        "outlier-line-pattern": "1",
        "outlier-line-thickness": "2px",
        "outlier-marker-color": "#808080",
        "outlier-marker-size": "11px",
        "outlier-marker-symbol": "circlefilled",
        "outlier-ramps-fill-color-end": "hsla(0, 0%, 48%, 1)",
        "outlier-ramps-fill-color-start": "#383838",
        "outlier-text-color": "#808080",
        "outlines-line-color": "hsl(219, 12%, 17%)",
        "outlines-line-pattern": "1",
        "outlines-line-thickness": "1px",
        "outlines-unfilled-line-color": "#9A9A9A",
        "outlines-unfilled-line-pattern": "1",
        "outlines-unfilled-line-thickness": "1px",
        "overplotting-grouped-marker-size-min": "6px",
        "overplotting-ungrouped-marker-size-min": "4px",
        "overview-axis-filter-color": "hsl(219, 12%, 22%)",
        "overview-axis-filter-fill-color": "hsl(219, 12%, 22%)",
        "overview-axis-filter-fill-transparency": "0.7",
        "overview-axis-line-color": "hsl(219, 12%, 98%)",
        "overview-axis-line-thickness": "1dpx",
        "overview-border-line-color": "hsl(219, 12%, 55%)",
        "overview-border-line-thickness": "1dpx",
        "overview-border-transparency": "0",
        "overview-fill-color": "hsl(219, 12%, 17%)",
        "overview-filter-fill-color": "hsl(219, 12%, 22%)",
        "overview-filter-transparency": "0.7",
        "overview-transparency": "0",
        "overview-viewportBorder-line-color": "hsl(212, 94%, 47%)",
        "overview-viewportBorder-line-thickness": "1dpx",
        "overview-viewportBorder-transparency": "0",
        "palette-discrete-1": "#4398F9",
        "palette-discrete-2": "#F28D44",
        "palette-discrete-3": "#54B6A4",
        "palette-discrete-4": "#EC80CE",
        "palette-discrete-5": "#97C03F",
        "palette-discrete-6": "#A570E8",
        "palette-discrete-7": "#DCB519",
        "palette-discrete-8": "#F06F5E",
        "palette-kpi-1": "#BD3F3F",
        "palette-kpi-3": "#CFCA4A",
        "palette-kpi-5": "#389A6B",
        "prediction-alt-color": "#736782",
        "prediction-color": "#A493BA",
        "prediction-fill-color": "#A493BA",
        "prediction-line-color": "#736782",
        "prediction-line-pattern": "34",
        "prediction-line-thickness": "2px",
        "prediction-marker-color": "#736782",
        "prediction-marker-size": "11px",
        "prediction-marker-symbol": "squarefilled",
        "prediction-text-color": "#5C5369",
        "predictionLimits-alt-color": "#756D87",
        "predictionLimits-color": "#655E75",
        "predictionLimits-fill-color": "#655E75",
        "predictionLimits-fill-pattern": "E",
        "predictionLimits-fill-patternColor": "#756D87",
        "predictionLimits-fill-transparency": "0.5",
        "predictionLimits-line-color": "#756D87",
        "predictionLimits-line-pattern": "34",
        "predictionLimits-line-thickness": "2px",
        "predictionLimits-marker-color": "#756D87",
        "predictionLimits-marker-size": "11px",
        "predictionLimits-marker-symbol": "trianglefilled",
        "predictionLimits-text-color": "#7B738F",
        "ramps-threeColorDivergent-0-alt-color-end": "#D97D3D",
        "ramps-threeColorDivergent-0-alt-color-neutral": "#233142",
        "ramps-threeColorDivergent-0-alt-color-start": "#3C89E0",
        "ramps-threeColorDivergent-0-fill-color-end": "#F28D44",
        "ramps-threeColorDivergent-0-fill-color-neutral": "#373A41",
        "ramps-threeColorDivergent-0-fill-color-start": "#4398F9",
        "ramps-threeColorDivergent-1-alt-color-end": "#D97D3D",
        "ramps-threeColorDivergent-1-alt-color-neutral": "#233142",
        "ramps-threeColorDivergent-1-alt-color-start": "#3C89E0",
        "ramps-threeColorDivergent-1-fill-color-end": "#F28D44",
        "ramps-threeColorDivergent-1-fill-color-neutral": "#373A41",
        "ramps-threeColorDivergent-1-fill-color-start": "#4398F9",
        "ramps-threeColorDivergent-2-alt-color-end": "#D473B8",
        "ramps-threeColorDivergent-2-alt-color-neutral": "#2E3038",
        "ramps-threeColorDivergent-2-alt-color-start": "#489C8C",
        "ramps-threeColorDivergent-2-fill-color-end": "#EC80CE",
        "ramps-threeColorDivergent-2-fill-color-neutral": "#383B45",
        "ramps-threeColorDivergent-2-fill-color-start": "#54B6A4",
        "ramps-threeColorDivergent-3-alt-color-end": "#9364CF",
        "ramps-threeColorDivergent-3-alt-color-neutral": "#2D2E33",
        "ramps-threeColorDivergent-3-alt-color-start": "#82A637",
        "ramps-threeColorDivergent-3-fill-color-end": "#A570E8",
        "ramps-threeColorDivergent-3-fill-color-neutral": "#383A40",
        "ramps-threeColorDivergent-3-fill-color-start": "#97C03F",
        "ramps-threeColorDivergent-4-alt-color-end": "#D66354",
        "ramps-threeColorDivergent-4-alt-color-neutral": "#362E28",
        "ramps-threeColorDivergent-4-alt-color-start": "#C29F16",
        "ramps-threeColorDivergent-4-fill-color-end": "#F06F5E",
        "ramps-threeColorDivergent-4-fill-color-neutral": "#433A32",
        "ramps-threeColorDivergent-4-fill-color-start": "#DCB519",
        "ramps-threeColorKPI-alt-color-end": "#2E8059",
        "ramps-threeColorKPI-alt-color-neutral": "#B5B041",
        "ramps-threeColorKPI-alt-color-start": "#A33636",
        "ramps-threeColorKPI-fill-color-end": "#389A6B",
        "ramps-threeColorKPI-fill-color-neutral": "#CFCA4A",
        "ramps-threeColorKPI-fill-color-start": "#BD3F3F",
        "ramps-twoColorLinear-0-alt-color-end": "#267DE0",
        "ramps-twoColorLinear-0-alt-color-start": "#1D314A",
        "ramps-twoColorLinear-0-fill-color-end": "#2A8BF9",
        "ramps-twoColorLinear-0-fill-color-start": "#2A3A4F",
        "ramps-twoColorLinear-1-alt-color-end": "#267DE0",
        "ramps-twoColorLinear-1-alt-color-start": "#1D314A",
        "ramps-twoColorLinear-1-fill-color-end": "#2A8BF9",
        "ramps-twoColorLinear-1-fill-color-start": "#2A3A4F",
        "ramps-twoColorLinear-2-alt-color-end": "#D97127",
        "ramps-twoColorLinear-2-alt-color-start": "#402D22",
        "ramps-twoColorLinear-2-fill-color-end": "#F27E2C",
        "ramps-twoColorLinear-2-fill-color-start": "#453934",
        "ramps-twoColorLinear-3-alt-color-end": "#389C89",
        "ramps-twoColorLinear-3-alt-color-start": "#1E3333",
        "ramps-twoColorLinear-3-fill-color-end": "#42B6A1",
        "ramps-twoColorLinear-3-fill-color-start": "#2D3F42",
        "ramps-twoColorLinear-4-alt-color-end": "#D45DB2",
        "ramps-twoColorLinear-4-alt-color-start": "#3D283C",
        "ramps-twoColorLinear-4-fill-color-end": "#EC68C7",
        "ramps-twoColorLinear-4-fill-color-start": "#443748",
        "ramps-twoColorLinear-5-alt-color-end": "#7DA626",
        "ramps-twoColorLinear-5-alt-color-start": "#2C3620",
        "ramps-twoColorLinear-5-fill-color-end": "#91C02C",
        "ramps-twoColorLinear-5-fill-color-start": "#374133",
        "ramps-twoColorLinear-6-alt-color-end": "#864ECF",
        "ramps-twoColorLinear-6-alt-color-start": "#302645",
        "ramps-twoColorLinear-6-fill-color-end": "#9758E8",
        "ramps-twoColorLinear-6-fill-color-start": "#39344C",
        "ramps-twoColorLinear-7-alt-color-end": "#C29B02",
        "ramps-twoColorLinear-7-alt-color-start": "#3B351A",
        "ramps-twoColorLinear-7-fill-color-end": "#DCB002",
        "ramps-twoColorLinear-7-fill-color-start": "#413F2D",
        "ramps-twoColorLinear-8-alt-color-end": "#D6503E",
        "ramps-twoColorLinear-8-alt-color-start": "#402727",
        "ramps-twoColorLinear-8-fill-color-end": "#F05A46",
        "ramps-twoColorLinear-8-fill-color-start": "#443438",
        "ramps-twoColorLinear-other-alt-color-end": "#6E6E6E",
        "ramps-twoColorLinear-other-alt-color-start": "#2E2E2E",
        "ramps-twoColorLinear-other-fill-color-end": "#7A7A7A",
        "ramps-twoColorLinear-other-fill-color-start": "#383838",
        "reports-base-font-family": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "reports-base-font-size": "10.5pt",
        "reports-base-font-style": "normal",
        "reports-base-font-weight": "400",
        "reports-base-text-color": "hsl(219, 12%, 88%)",
        "reports-button-bar-background-color": "hsl(219, 12%, 17%)",
        "reports-button-bar-color": "hsl(219, 12%, 88%)",
        "reports-button-bar-font-weight": "normal",
        "reports-button-bar-selected-background-color": "hsl(212, 94%, 23%)",
        "reports-button-bar-selected-color": "hsl(219, 12%, 30%)",
        "reports-checkbox-list-background-color": "hsl(219, 12%, 17%)",
        "reports-checkbox-list-color": "hsl(219, 12%, 88%)",
        "reports-combobox-background-color": "hsl(219, 12%, 17%)",
        "reports-combobox-color": "hsl(219, 12%, 88%)",
        "reports-container-background-color": "hsl(219, 12%, 17%)",
        "reports-container-border-color": "hsl(219, 12%, 30%)",
        "reports-crosstab-header-background-color": "hsl(219, 12%, 17%)",
        "reports-crosstab-header-color": "hsl(219, 12%, 88%)",
        "reports-crosstab-header-font-size": "9.3pt",
        "reports-crosstab-header-font-weight": "700",
        "reports-crosstab-header-line-color": "hsl(219, 12%, 30%)",
        "reports-crosstab-measureHeader-background-color": "hsl(219, 12%, 17%)",
        "reports-crosstab-measureHeader-color": "hsl(219, 12%, 88%)",
        "reports-crosstab-measureHeader-font-size": "9.3pt",
        "reports-crosstab-measureHeader-font-weight": "700",
        "reports-crosstab-rowHeader-background-color": "hsl(219, 12%, 17%)",
        "reports-crosstab-rowHeader-color": "hsl(219, 12%, 88%)",
        "reports-crosstab-rowHeader-font-size": "9.3pt",
        "reports-crosstab-rowHeader-font-weight": "700",
        "reports-crosstab-scrollbar-fill-color": "hsl(219, 12%, 64%)",
        "reports-crosstab-subtotals-background-color": "hsl(219, 12%, 17%)",
        "reports-crosstab-subtotals-color": "hsl(219, 12%, 88%)",
        "reports-crosstab-subtotals-font-size": "9.3pt",
        "reports-crosstab-subtotals-font-weight": "700",
        "reports-crosstab-table-alt-row-color": "hsl(219, 12%, 17%)",
        "reports-crosstab-table-border-style": "none",
        "reports-crosstab-table-color": "hsl(219, 12%, 88%)",
        "reports-crosstab-table-displayOpts": "plain",
        "reports-crosstab-table-font-size": "9.3pt",
        "reports-crosstab-table-font-weight": "400",
        "reports-crosstab-table-horizontal-line-pattern": "solid",
        "reports-crosstab-table-vertical-line-pattern": "solid",
        "reports-crosstab-totals-background-color": "hsl(219, 12%, 17%)",
        "reports-crosstab-totals-color": "hsl(219, 12%, 88%)",
        "reports-crosstab-totals-font-size": "9.3pt",
        "reports-crosstab-totals-font-weight": "700",
        "reports-element-container-padding": "16px",
        "reports-graph-menu-border-color": "hsl(219, 12%, 30%)",
        "reports-graph-menu-text-colorSelected": "hsl(219, 12%, 30%)",
        "reports-graph-slider-bar-fill-color": "hsl(219, 12%, 17%)",
        "reports-graph-slider-bar-line-colorBottom": "hsl(219, 12%, 30%)",
        "reports-graph-slider-bar-line-colorTop": "hsl(219, 12%, 30%)",
        "reports-graph-slider-thumb-fill-colorCenter": "hsl(212, 94%, 62%)",
        "reports-graph-slider-thumb-line-color": "hsl(219, 12%, 30%)",
        "reports-graph-slider-ui5-bar-fill-color": "hsl(212, 94%, 62%)",
        "reports-graph-slider-ui5-bar-line-colorBottom": "hsl(219, 12%, 30%)",
        "reports-graph-slider-ui5-bar-line-colorTop": "hsl(219, 12%, 30%)",
        "reports-graph-slider-ui5-thumb-fill-colorCenter": "hsl(212, 94%, 62%)",
        "reports-graph-slider-ui5-thumb-fill-colorDonut": "hsl(219, 12%, 17%)",
        "reports-graph-slider-ui5-thumb-line-color": "hsl(219, 12%, 30%)",
        "reports-heading-alt-color": "hsl(212, 94%, 62%)",
        "reports-heading-color": "hsl(219, 12%, 88%)",
        "reports-heading-font-family": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "reports-heading-font-weight": "400",
        "reports-hover-background-color": "hsl(219, 12%, 17%)",
        "reports-hover-text-color": "hsl(219, 12%, 88%)",
        "reports-page-padding": "16px",
        "reports-prompt-bar-background-color": "hsl(219, 12%, 17%)",
        "reports-radio-button-color": "hsl(219, 12%, 88%)",
        "reports-report-background-color": "hsl(219, 12%, 17%)",
        "reports-selected-background-color": "hsl(212, 94%, 23%)",
        "reports-selected-text-color": "hsl(219, 12%, 88%)",
        "reports-stack-container-background-color": "hsl(219, 12%, 17%)",
        "reports-stack-container-color": "hsl(219, 12%, 88%)",
        "reports-stack-container-selected-background-color": "hsl(212, 94%, 23%)",
        "reports-stack-container-selected-border-color": "hsl(219, 12%, 30%)",
        "reports-stack-container-selected-color": "hsl(219, 12%, 30%)",
        "reports-subtotals-background-color": "hsl(219, 12%, 17%)",
        "reports-subtotals-color": "hsl(219, 12%, 88%)",
        "reports-subtotals-font-size": "9.3pt",
        "reports-subtotals-font-weight": "700",
        "reports-table-alt-row-color": "hsl(219, 12%, 17%)",
        "reports-table-border-color": "hsl(219, 12%, 30%)",
        "reports-table-border-style": "solid",
        "reports-table-border-width": "1px",
        "reports-table-color": "hsl(219, 12%, 88%)",
        "reports-table-displayOpts": "plain",
        "reports-table-font-size": "9.3pt",
        "reports-table-header-background-color": "hsl(219, 12%, 17%)",
        "reports-table-header-color": "hsl(219, 12%, 88%)",
        "reports-table-header-font-size": "9.3pt",
        "reports-table-header-font-weight": "700",
        "reports-table-horizontal-line-pattern": "solid",
        "reports-table-row-color": "hsl(219, 12%, 17%)",
        "reports-table-scrollbar-fill-color": "hsl(219, 12%, 64%)",
        "reports-table-totals-background-color": "hsl(219, 12%, 17%)",
        "reports-table-totals-color": "hsl(219, 12%, 88%)",
        "reports-table-totals-font-size": "9.3pt",
        "reports-table-totals-font-weight": "400",
        "reports-table-vertical-line-pattern": "solid",
        "reports-text-input-color": "hsl(219, 12%, 88%)",
        "reports-title-style-color": "hsl(219, 12%, 88%)",
        "reports-title-style-font-size": "13.92pt",
        "reports-totals-background-color": "hsl(219, 12%, 17%)",
        "reports-totals-color": "hsl(219, 12%, 88%)",
        "reports-totals-font-size": "9.3pt",
        "reports-totals-font-weight": "700",
        "reports-visual-prompt-container-background-color": "hsl(219, 12%, 17%)",
        "reports-zoom-scrollbar-endHandle-color": "hsl(219, 12%, 64%)",
        "reports-zoom-scrollbar-endHandle-line-color": "hsl(219, 12%, 64%)",
        "reports-zoom-scrollbar-thumb-color": "hsl(219, 12%, 17%)",
        "skin-blend-color-end": "hsl(219, 0%, 100%)",
        "skin-blend-color-start": "hsl(219, 0%, 100%)",
        "skin-blend-endColorFactor": "0",
        "skin-blend-mode": "normal",
        "skin-blend-startColorFactor": "0",
        "skin-data": "none",
        "skin-glow-blur": "0",
        "skin-glow-color": "hsl(219, 0%, 100%)",
        "skin-glow-colorFactor": "-0.9",
        "skin-glow-thickness": "1px",
        "skin-kpi": "none",
        "states-focus-background": "0",
        "states-focus-background-line-color": "hsl(219, 12%, 17%)",
        "states-focus-background-line-pattern": "1",
        "states-focus-background-line-thickness": "5px",
        "states-focus-background-line-transparency": "1",
        "states-focus-line-color": "#A0B1CF",
        "states-focus-line-pattern": "34",
        "states-focus-line-thickness": "1px",
        "states-focus-line-transparency": "0",
        "states-selection-alt-color": "#A0B1CF",
        "states-selection-color": "hsl(219, 12%, 17%)",
        "states-selection-fill-color": "hsl(219, 12%, 17%)",
        "states-selection-line-color": "#A0B1CF",
        "states-selection-line-pattern": "1",
        "states-selection-line-thickness": "2px",
        "states-selection-marker-color": "#A0B1CF",
        "states-selection-marker-size": "11px",
        "states-selection-marker-symbol": "circlefilled",
        "states-selection-text-color": "#A0B1CF",
        "templateContainer-attributeProperty": "color",
        "templateContainer-dataStyleReference": "remapped",
        "typography-data-text-color": "hsl(219, 12%, 98%)",
        "typography-data-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-data-text-fontSize": "8.325pt",
        "typography-data-text-fontStyle": "normal",
        "typography-data-text-fontWeight": "400",
        "typography-footnote-text-color": "hsl(219, 12%, 96%)",
        "typography-footnote-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-footnote-text-fontSize": "10.5pt",
        "typography-footnote-text-fontStyle": "normal",
        "typography-footnote-text-fontWeight": "400",
        "typography-label-text-color": "hsl(219, 12%, 96%)",
        "typography-label-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-label-text-fontSize": "10.5pt",
        "typography-label-text-fontStyle": "normal",
        "typography-label-text-fontWeight": "700",
        "typography-title-text-color": "hsl(219, 12%, 96%)",
        "typography-title-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-title-text-fontSize": "13.92pt",
        "typography-title-text-fontStyle": "normal",
        "typography-title-text-fontWeight": "400",
        "typography-values-text-color": "hsl(219, 12%, 72%)",
        "typography-values-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-values-text-fontSize": "9.3pt",
        "typography-values-text-fontStyle": "normal",
        "typography-values-text-fontWeight": "400"
    }
};

const HighContrastTokens = {
    name: "high-contrast",
    selectors: [":root[data-sas-theme='graph-high-contrast']"],
    tokens: {
        "annotation-line-alt-color": "hsl(219, 0%, 100%)",
        "annotation-line-color": "hsl(219, 0%, 100%)",
        "annotation-line-pattern": "1",
        "annotation-line-text-color": "hsl(219, 12%, 79%)",
        "annotation-line-thickness": "3px",
        "annotation-reference-alt-color": "hsl(219, 0%, 100%)",
        "annotation-reference-line-color": "hsl(219, 0%, 100%)",
        "annotation-reference-line-pattern": "1",
        "annotation-reference-line-thickness": "2dpx",
        "annotation-reference-marker-color": "hsl(219, 0%, 100%)",
        "annotation-reference-text-color": "hsl(219, 0%, 100%)",
        "annotation-shape-alt-color": "hsl(219, 0%, 100%)",
        "annotation-shape-color": "hsl(219, 0%, 0%)",
        "annotation-shape-fill-color": "hsl(219, 0%, 0%)",
        "annotation-shape-line-color": "hsl(219, 0%, 100%)",
        "annotation-shape-line-pattern": "1",
        "annotation-shape-line-thickness": "2px",
        "annotation-shape-marker-color": "hsl(219, 12%, 79%)",
        "annotation-shape-marker-size": "16px",
        "annotation-shape-marker-symbol": "Starfilled",
        "annotation-shape-text-color": "hsl(219, 12%, 79%)",
        "annotation-text-color": "hsl(219, 12%, 79%)",
        "annotation-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "annotation-text-fontSize": "9.3pt",
        "annotation-text-fontStyle": "normal",
        "annotation-text-fontWeight": "400",
        "axis-discrete-displayOpts": "tickvalues ticks line label",
        "axis-discrete-gridDisplay": "0",
        "axis-linear-displayOpts": "tickvalues label",
        "axis-linear-gridDisplay": "1",
        "axis-log-displayOpts": "tickvalues label",
        "axis-log-gridDisplay": "1",
        "axis-time-displayOpts": "tickvalues label",
        "axis-time-gridDisplay": "1",
        "chrome-axis-line-color": "hsl(219, 0%, 100%)",
        "chrome-axis-line-pattern": "1",
        "chrome-axis-line-thickness": "2dpx",
        "chrome-axis-tickDisplay": "OUTSIDE",
        "chrome-background-fill-color": "hsl(219, 0%, 0%)",
        "chrome-background-frameBorder": "0",
        "chrome-border-line-color": "hsl(219, 0%, 100%)",
        "chrome-border-line-pattern": "1",
        "chrome-border-line-thickness": "2dpx",
        "chrome-callout-line-color": "hsl(219, 0%, 100%)",
        "chrome-callout-line-pattern": "1",
        "chrome-callout-line-thickness": "2dpx",
        "chrome-callout-line-transparency": "0",
        "chrome-cellSeparator-line-color": "hsl(219, 0%, 100%)",
        "chrome-cellSeparator-line-pattern": "34",
        "chrome-cellSeparator-line-thickness": "2dpx",
        "chrome-grid-gridLayer": "back",
        "chrome-grid-line-color": "#969696",
        "chrome-grid-line-pattern": "2",
        "chrome-grid-line-thickness": "2dpx",
        "chrome-grid-line-transparency": "0",
        "chrome-header-fill-color": "hsl(219, 0%, 0%)",
        "chrome-legend-fill-color": "hsl(219, 0%, 0%)",
        "chrome-legend-frameBorder": "0",
        "chrome-legend-titleBorder": "0",
        "chrome-wall-displayOpts": "none",
        "chrome-wall-fill-color": "hsl(219, 0%, 0%)",
        "chrome-wall-fill-transparency": "0",
        "chrome-wall-frameBorder": "0",
        "chrome-wall-line-color": "hsl(219, 0%, 100%)",
        "chrome-wall-line-pattern": "1",
        "chrome-wall-line-thickness": "2dpx",
        "chrome-wall-line-transparency": "0",
        "confidence-1-alt-color": "#9CC9FC",
        "confidence-1-color": "#173C69",
        "confidence-1-fill-color": "#173C69",
        "confidence-1-fill-pattern": "E",
        "confidence-1-fill-patternColor": "hsl(219, 0%, 0%)",
        "confidence-1-fill-transparency": "0.4",
        "confidence-1-line-color": "#9CC9FC",
        "confidence-1-line-pattern": "1",
        "confidence-1-line-thickness": "1px",
        "confidence-1-marker-color": "#9CC9FC",
        "confidence-1-marker-size": "16px",
        "confidence-1-marker-symbol": "circlefilled",
        "confidence-1-text-color": "#2E78D1",
        "confidence-2-alt-color": "#FBB074",
        "confidence-2-color": "#583113",
        "confidence-2-fill-color": "#583113",
        "confidence-2-fill-pattern": "E",
        "confidence-2-fill-patternColor": "hsl(219, 0%, 0%)",
        "confidence-2-fill-transparency": "0.4",
        "confidence-2-line-color": "#FBB074",
        "confidence-2-line-pattern": "4",
        "confidence-2-line-thickness": "1px",
        "confidence-2-marker-color": "#FBB074",
        "confidence-2-marker-size": "16px",
        "confidence-2-marker-symbol": "squarefilled",
        "confidence-2-text-color": "#C16C2A",
        "dataStyle-0-alt-color": "#9CC9FC",
        "dataStyle-0-color": "#61A8FA",
        "dataStyle-0-fill-color": "#61A8FA",
        "dataStyle-0-fill-pattern": "L1",
        "dataStyle-0-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-0-line-color": "#9CC9FC",
        "dataStyle-0-line-pattern": "1",
        "dataStyle-0-line-thickness": "5px",
        "dataStyle-0-marker-color": "#9CC9FC",
        "dataStyle-0-marker-size": "16px",
        "dataStyle-0-marker-symbol": "circlefilled",
        "dataStyle-0-text-color": "#9CC9FC",
        "dataStyle-1-alt-color": "#9CC9FC",
        "dataStyle-1-color": "#61A8FA",
        "dataStyle-1-fill-color": "#61A8FA",
        "dataStyle-1-fill-pattern": "L1",
        "dataStyle-1-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-1-line-color": "#9CC9FC",
        "dataStyle-1-line-pattern": "1",
        "dataStyle-1-line-thickness": "5px",
        "dataStyle-1-marker-color": "#9CC9FC",
        "dataStyle-1-marker-size": "16px",
        "dataStyle-1-marker-symbol": "circlefilled",
        "dataStyle-1-text-color": "#9CC9FC",
        "dataStyle-10-fill-pattern": "X4",
        "dataStyle-10-line-pattern": "42",
        "dataStyle-10-line-thickness": "5px",
        "dataStyle-11-fill-pattern": "L3",
        "dataStyle-11-line-pattern": "2",
        "dataStyle-11-line-thickness": "5px",
        "dataStyle-2-alt-color": "#FBB074",
        "dataStyle-2-color": "#F98E39",
        "dataStyle-2-fill-color": "#F98E39",
        "dataStyle-2-fill-pattern": "X1",
        "dataStyle-2-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-2-line-color": "#FBB074",
        "dataStyle-2-line-pattern": "4",
        "dataStyle-2-line-thickness": "5px",
        "dataStyle-2-marker-color": "#FBB074",
        "dataStyle-2-marker-size": "16px",
        "dataStyle-2-marker-symbol": "squarefilled",
        "dataStyle-2-text-color": "#FBB074",
        "dataStyle-3-alt-color": "#3ADECB",
        "dataStyle-3-color": "#1FBBA9",
        "dataStyle-3-fill-color": "#1FBBA9",
        "dataStyle-3-fill-pattern": "R4",
        "dataStyle-3-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-3-line-color": "#3ADECB",
        "dataStyle-3-line-pattern": "8",
        "dataStyle-3-line-thickness": "5px",
        "dataStyle-3-marker-color": "#3ADECB",
        "dataStyle-3-marker-size": "16px",
        "dataStyle-3-marker-symbol": "trianglefilled",
        "dataStyle-3-text-color": "#3ADECB",
        "dataStyle-4-alt-color": "#FFADDA",
        "dataStyle-4-color": "#FF6FBD",
        "dataStyle-4-fill-color": "#FF6FBD",
        "dataStyle-4-fill-pattern": "X3",
        "dataStyle-4-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-4-line-color": "#FFADDA",
        "dataStyle-4-line-pattern": "5",
        "dataStyle-4-line-thickness": "5px",
        "dataStyle-4-marker-color": "#FFADDA",
        "dataStyle-4-marker-size": "16px",
        "dataStyle-4-marker-symbol": "diamondfilled",
        "dataStyle-4-text-color": "#FFADDA",
        "dataStyle-5-alt-color": "#A4D053",
        "dataStyle-5-color": "#87B532",
        "dataStyle-5-fill-color": "#87B532",
        "dataStyle-5-fill-pattern": "R3",
        "dataStyle-5-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-5-line-color": "#A4D053",
        "dataStyle-5-line-pattern": "14",
        "dataStyle-5-line-thickness": "5px",
        "dataStyle-5-marker-color": "#A4D053",
        "dataStyle-5-marker-size": "16px",
        "dataStyle-5-marker-symbol": "starfilled",
        "dataStyle-5-text-color": "#A4D053",
        "dataStyle-6-alt-color": "#E4C7FF",
        "dataStyle-6-color": "#C68AFF",
        "dataStyle-6-fill-color": "#C68AFF",
        "dataStyle-6-fill-pattern": "L5",
        "dataStyle-6-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-6-line-color": "#E4C7FF",
        "dataStyle-6-line-pattern": "26",
        "dataStyle-6-line-thickness": "5px",
        "dataStyle-6-marker-color": "#E4C7FF",
        "dataStyle-6-marker-size": "16px",
        "dataStyle-6-marker-symbol": "triangledownfilled",
        "dataStyle-6-text-color": "#E4C7FF",
        "dataStyle-7-alt-color": "#E0D46B",
        "dataStyle-7-color": "#D6C539",
        "dataStyle-7-fill-color": "#D6C539",
        "dataStyle-7-fill-pattern": "R1",
        "dataStyle-7-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-7-line-color": "#E0D46B",
        "dataStyle-7-line-pattern": "15",
        "dataStyle-7-line-thickness": "5px",
        "dataStyle-7-marker-color": "#E0D46B",
        "dataStyle-7-marker-size": "16px",
        "dataStyle-7-marker-symbol": "homedownfilled",
        "dataStyle-7-text-color": "#E0D46B",
        "dataStyle-8-alt-color": "#FFB1AD",
        "dataStyle-8-color": "#FF7973",
        "dataStyle-8-fill-color": "#FF7973",
        "dataStyle-8-fill-pattern": "X5",
        "dataStyle-8-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-8-line-color": "#FFB1AD",
        "dataStyle-8-line-pattern": "20",
        "dataStyle-8-line-thickness": "5px",
        "dataStyle-8-marker-color": "#FFB1AD",
        "dataStyle-8-marker-size": "16px",
        "dataStyle-8-text-color": "#FFB1AD",
        "dataStyle-9-fill-pattern": "L4",
        "dataStyle-9-line-pattern": "41",
        "dataStyle-9-line-thickness": "5px",
        "dataStyle-ramps-0-color-end": "#F98E39",
        "dataStyle-ramps-0-color-neutral": "#FFFFFF",
        "dataStyle-ramps-0-color-start": "#61A8FA",
        "dataStyle-specificUse-decrease-alt-color": "#FFA3A3",
        "dataStyle-specificUse-decrease-color": "#FF6464",
        "dataStyle-specificUse-decrease-fill-color": "#FF6464",
        "dataStyle-specificUse-decrease-fill-pattern": "L1",
        "dataStyle-specificUse-decrease-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-specificUse-decrease-line-color": "#FFA3A3",
        "dataStyle-specificUse-decrease-line-pattern": "1",
        "dataStyle-specificUse-decrease-line-thickness": "3px",
        "dataStyle-specificUse-decrease-marker-color": "#FFA3A3",
        "dataStyle-specificUse-decrease-marker-symbol": "triangledownfilled",
        "dataStyle-specificUse-decrease-text-color": "#FFA3A3",
        "dataStyle-specificUse-error-alt-color": "#C9C9C9",
        "dataStyle-specificUse-error-color": "#ABABAB",
        "dataStyle-specificUse-error-fill-color": "#ABABAB",
        "dataStyle-specificUse-error-line-color": "#C9C9C9",
        "dataStyle-specificUse-error-line-pattern": "5",
        "dataStyle-specificUse-error-line-thickness": "5px",
        "dataStyle-specificUse-error-marker-color": "#C9C9C9",
        "dataStyle-specificUse-error-marker-size": "16px",
        "dataStyle-specificUse-error-marker-symbol": "diamondfilled",
        "dataStyle-specificUse-error-text-color": "#C9C9C9",
        "dataStyle-specificUse-increase-alt-color": "#8FD693",
        "dataStyle-specificUse-increase-color": "#63C568",
        "dataStyle-specificUse-increase-fill-color": "#63C568",
        "dataStyle-specificUse-increase-fill-pattern": "R2",
        "dataStyle-specificUse-increase-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-specificUse-increase-line-color": "#8FD693",
        "dataStyle-specificUse-increase-line-pattern": "1",
        "dataStyle-specificUse-increase-line-thickness": "3px",
        "dataStyle-specificUse-increase-marker-color": "#8FD693",
        "dataStyle-specificUse-increase-marker-symbol": "triangleupfilled",
        "dataStyle-specificUse-increase-text-color": "#8FD693",
        "dataStyle-specificUse-missing-alt-color": "#787878",
        "dataStyle-specificUse-missing-color": "#5A5A5A",
        "dataStyle-specificUse-missing-fill-color": "#5A5A5A",
        "dataStyle-specificUse-missing-fill-pattern": "R5",
        "dataStyle-specificUse-missing-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-specificUse-missing-line-color": "#787878",
        "dataStyle-specificUse-missing-line-pattern": "35",
        "dataStyle-specificUse-missing-line-thickness": "5px",
        "dataStyle-specificUse-missing-marker-color": "#787878",
        "dataStyle-specificUse-missing-marker-size": "16px",
        "dataStyle-specificUse-missing-marker-symbol": "x",
        "dataStyle-specificUse-missing-text-color": "#787878",
        "dataStyle-specificUse-other-alt-color": "#BBBBBB",
        "dataStyle-specificUse-other-color": "#9C9C9C",
        "dataStyle-specificUse-other-fill-color": "#9C9C9C",
        "dataStyle-specificUse-other-fill-pattern": "X2",
        "dataStyle-specificUse-other-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-specificUse-other-line-color": "#BBBBBB",
        "dataStyle-specificUse-other-line-pattern": "34",
        "dataStyle-specificUse-other-line-thickness": "5px",
        "dataStyle-specificUse-other-marker-color": "#BBBBBB",
        "dataStyle-specificUse-other-marker-size": "16px",
        "dataStyle-specificUse-other-marker-symbol": "asterisk",
        "dataStyle-specificUse-other-text-color": "#BBBBBB",
        "dataStyle-specificUse-overflow-alt-color": "#D4B8F9",
        "dataStyle-specificUse-overflow-color": "#B381f5",
        "dataStyle-specificUse-overflow-fill-color": "#B381f5",
        "dataStyle-specificUse-overflow-fill-pattern": "R2",
        "dataStyle-specificUse-overflow-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-specificUse-overflow-line-color": "#D4B8F9",
        "dataStyle-specificUse-overflow-line-pattern": "1",
        "dataStyle-specificUse-overflow-line-thickness": "5px",
        "dataStyle-specificUse-overflow-marker-color": "#D4B8F9",
        "dataStyle-specificUse-overflow-marker-size": "16px",
        "dataStyle-specificUse-overflow-marker-symbol": "triangleupfilled",
        "dataStyle-specificUse-overflow-text-color": "#D4B8F9",
        "dataStyle-specificUse-underflow-alt-color": "#A5EEE8",
        "dataStyle-specificUse-underflow-color": "#71E4DA",
        "dataStyle-specificUse-underflow-fill-color": "#71E4DA",
        "dataStyle-specificUse-underflow-fill-pattern": "L2",
        "dataStyle-specificUse-underflow-fill-patternColor": "hsl(219, 0%, 0%)",
        "dataStyle-specificUse-underflow-line-color": "#A5EEE8",
        "dataStyle-specificUse-underflow-line-pattern": "1",
        "dataStyle-specificUse-underflow-line-thickness": "5px",
        "dataStyle-specificUse-underflow-marker-color": "#A5EEE8",
        "dataStyle-specificUse-underflow-marker-size": "16px",
        "dataStyle-specificUse-underflow-marker-symbol": "triangledownfilled",
        "dataStyle-specificUse-underflow-text-color": "#A5EEE8",
        "dataTip-fill-color": "hsl(219, 0%, 0%)",
        "dataTip-text-color": "hsl(219, 0%, 100%)",
        "dataTip-transparency": "0",
        "elementMeasurement-line-thickness": "5px",
        "elementMeasurement-marker-size": "16px",
        "elementMeasurement-thinLine-line-color": "#9CC9FC",
        "elementMeasurement-thinLine-line-pattern": "1",
        "elementMeasurement-thinLine-line-thickness": "3px",
        "fit-1-alt-color": "#2E79D1",
        "fit-1-color": "#8AB4E5",
        "fit-1-fill-color": "#8AB4E5",
        "fit-1-fill-pattern": "E",
        "fit-1-fill-patternColor": "hsl(219, 0%, 0%)",
        "fit-1-line-color": "#2E79D1",
        "fit-1-line-pattern": "1",
        "fit-1-line-thickness": "5px",
        "fit-1-marker-color": "#2E79D1",
        "fit-1-marker-size": "16px",
        "fit-1-marker-symbol": "circlefilled",
        "fit-1-text-color": "#2561A7",
        "fit-2-alt-color": "#B06327",
        "fit-2-color": "#DE9C69",
        "fit-2-fill-color": "#8AB4E5",
        "fit-2-fill-pattern": "E",
        "fit-2-fill-patternColor": "hsl(219, 0%, 0%)",
        "fit-2-line-color": "#B06327",
        "fit-2-line-pattern": "4",
        "fit-2-line-thickness": "5px",
        "fit-2-marker-color": "#B06327",
        "fit-2-marker-size": "16px",
        "fit-2-marker-symbol": "squarefilled",
        "fit-2-text-color": "#864B1E",
        "geospatial-area-fill-color": "hsl(219, 0%, 100%)",
        "geospatial-area-fill-transparency": "0.8",
        "geospatial-area-focus-line-color": "hsl(212, 94%, 42%)",
        "geospatial-area-focus-line-pattern": "34",
        "geospatial-area-focus-line-thickness": "4px",
        "geospatial-area-focus-line-transparency": "0",
        "geospatial-area-focusPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-focusPerimeter-line-pattern": "solid",
        "geospatial-area-focusPerimeter-line-thickness": "5px",
        "geospatial-area-focusPerimeter-line-transparency": "1",
        "geospatial-area-innerPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-innerPerimeter-line-pattern": "1",
        "geospatial-area-innerPerimeter-line-thickness": "0",
        "geospatial-area-innerPerimeter-line-transparency": "1",
        "geospatial-area-innerPerimeterThick-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-innerPerimeterThick-line-pattern": "1",
        "geospatial-area-innerPerimeterThick-line-thickness": "0",
        "geospatial-area-innerPerimeterThick-line-transparency": "1",
        "geospatial-area-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-line-pattern": "1",
        "geospatial-area-line-thickness": "2px",
        "geospatial-area-line-transparency": "0",
        "geospatial-area-outerHover-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-outerHover-line-pattern": "1",
        "geospatial-area-outerHover-line-thickness": "4px",
        "geospatial-area-outerHover-line-transparency": "0.4",
        "geospatial-area-outerPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-outerPerimeter-line-pattern": "1",
        "geospatial-area-outerPerimeter-line-thickness": "1px",
        "geospatial-area-outerPerimeter-line-transparency": "0.6",
        "geospatial-area-outerPerimeterInverse-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-outerPerimeterInverse-line-pattern": "1",
        "geospatial-area-outerPerimeterInverse-line-thickness": "0",
        "geospatial-area-outerPerimeterInverse-line-transparency": "1",
        "geospatial-area-outerSelection-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-outerSelection-line-pattern": "1",
        "geospatial-area-outerSelection-line-thickness": "4px",
        "geospatial-area-outerSelection-line-transparency": "0",
        "geospatial-area-selection-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-selection-line-pattern": "2",
        "geospatial-area-selection-line-thickness": "2px",
        "geospatial-area-selection-line-transparency": "0",
        "geospatial-basemap-tileset": "HighContrast",
        "geospatial-overlayData-inset-aspectRatio": "1",
        "geospatial-overlayData-inset-size-default": "64px",
        "geospatial-overlayData-inset-size-max": "140px",
        "geospatial-overlayData-inset-size-min": "35px",
        "geospatial-pie-inset-aspectRatio": "1",
        "geospatial-pie-inset-otherSlicePercent": "10",
        "geospatial-pie-inset-ring-size": "0.4",
        "geospatial-pie-inset-size-default": "64px",
        "geospatial-pie-inset-size-max": "140px",
        "geospatial-pie-inset-size-min": "35px",
        "geospatial-pie-outlinesPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-pie-outlinesPerimeter-line-pattern": "1",
        "geospatial-pie-outlinesPerimeter-line-thickness": "3px",
        "geospatial-pie-outlinesPerimeter-line-transparency": "0",
        "geospatial-pin-color": "hsl(219, 0%, 100%)",
        "geospatial-pin-icon-text-color": "hsl(219, 0%, 0%)",
        "geospatial-pin-icon-text-fontFamily": "sas-icons",
        "geospatial-pin-icon-text-fontSize": "11.85pt",
        "geospatial-pin-icon-text-fontStyle": "normal",
        "geospatial-pin-icon-text-fontWeight": "400",
        "geospatial-pin-label-text-color": "hsl(219, 0%, 0%)",
        "geospatial-pin-label-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "geospatial-pin-label-text-fontSize": "10.5pt",
        "geospatial-pin-label-text-fontStyle": "normal",
        "geospatial-pin-label-text-fontWeight": "700",
        "geospatial-pin-search-color": "hsl(219, 12%, 79%)",
        "geospatial-pin-search-style": "highContrast",
        "geospatial-pin-style": "highContrast",
        "geospatial-region-empty-fill-color": "hsl(219, 0%, 0%)",
        "geospatial-region-empty-fill-pattern": "E",
        "geospatial-region-empty-fill-transparency": "0",
        "geospatial-region-empty-line-color": "#5A5A5A",
        "geospatial-region-empty-line-pattern": "1",
        "geospatial-region-empty-line-thickness": "5px",
        "geospatial-region-empty-line-transparency": "0",
        "geospatial-route-centerPath-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-centerPath-line-pattern": "1",
        "geospatial-route-centerPath-line-thickness": "3px",
        "geospatial-route-centerPath-line-transparency": "0",
        "geospatial-route-centroidPoint-pin-color": "hsl(219, 0%, 100%)",
        "geospatial-route-centroidPoint-pin-style": "highContrast",
        "geospatial-route-mainPath-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-mainPath-line-pattern": "1",
        "geospatial-route-mainPath-line-thickness": "10px",
        "geospatial-route-mainPath-line-transparency": "0",
        "geospatial-route-pathFocus-line-color": "hsl(212, 94%, 42%)",
        "geospatial-route-pathFocus-line-pattern": "2",
        "geospatial-route-pathFocus-line-thickness": "4px",
        "geospatial-route-pathFocus-line-transparency": "0",
        "geospatial-route-pathFocusPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-pathFocusPerimeter-line-pattern": "solid",
        "geospatial-route-pathFocusPerimeter-line-thickness": "5px",
        "geospatial-route-pathFocusPerimeter-line-transparency": "1",
        "geospatial-route-pathHover-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-pathHover-line-pattern": "1",
        "geospatial-route-pathHover-line-thickness": "4px",
        "geospatial-route-pathHover-line-transparency": "0.4",
        "geospatial-route-pathInnerPerimeter-line-color": "hsl(219, 12%, 8%)",
        "geospatial-route-pathInnerPerimeter-line-pattern": "solid",
        "geospatial-route-pathInnerPerimeter-line-thickness": "1px",
        "geospatial-route-pathInnerPerimeter-line-transparency": "0",
        "geospatial-route-pathOuterPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-pathOuterPerimeter-line-pattern": "1",
        "geospatial-route-pathOuterPerimeter-line-thickness": "1px",
        "geospatial-route-pathOuterPerimeter-line-transparency": "0.6",
        "geospatial-route-pathOuterPerimeterInverse-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-pathOuterPerimeterInverse-line-pattern": "1",
        "geospatial-route-pathOuterPerimeterInverse-line-thickness": "0",
        "geospatial-route-pathOuterPerimeterInverse-line-transparency": "1",
        "geospatial-route-pathSelection-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-pathSelection-line-pattern": "1",
        "geospatial-route-pathSelection-line-thickness": "4px",
        "geospatial-route-pathSelection-line-transparency": "0",
        "geospatial-route-point-pin-color": "hsl(219, 0%, 100%)",
        "geospatial-route-point-pin-style": "highContrast",
        "geospatial-route-point-text-color": "hsl(219, 0%, 100%)",
        "geospatial-route-point-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "geospatial-route-point-text-fontSize": "7.35pt",
        "geospatial-route-point-text-fontStyle": "normal",
        "geospatial-route-point-text-fontWeight": "700",
        "graphAppThemeTokens-brand-color-alert": "hsl(0, 100%, 40%)",
        "graphAppThemeTokens-brand-color-alert-00": "hsl(0, 0%, 100%)",
        "graphAppThemeTokens-brand-color-alert-10": "hsl(0, 100%, 98%)",
        "graphAppThemeTokens-brand-color-alert-100": "hsl(0, 100%, 64%)",
        "graphAppThemeTokens-brand-color-alert-1000": "hsl(0, 0%, 0%)",
        "graphAppThemeTokens-brand-color-alert-20": "hsl(0, 100%, 95%)",
        "graphAppThemeTokens-brand-color-alert-200": "hsl(0, 100%, 59%)",
        "graphAppThemeTokens-brand-color-alert-30": "hsl(0, 100%, 92%)",
        "graphAppThemeTokens-brand-color-alert-300": "hsl(0, 100%, 54%)",
        "graphAppThemeTokens-brand-color-alert-40": "hsl(0, 100%, 88%)",
        "graphAppThemeTokens-brand-color-alert-400": "hsl(0, 100%, 46%)",
        "graphAppThemeTokens-brand-color-alert-450": "hsl(0, 100%, 40%)",
        "graphAppThemeTokens-brand-color-alert-50": "hsl(0, 100%, 84%)",
        "graphAppThemeTokens-brand-color-alert-500": "hsl(0, 100%, 36%)",
        "graphAppThemeTokens-brand-color-alert-550": "hsl(0, 100%, 33%)",
        "graphAppThemeTokens-brand-color-alert-60": "hsl(0, 100%, 79%)",
        "graphAppThemeTokens-brand-color-alert-600": "hsl(0, 100%, 30%)",
        "graphAppThemeTokens-brand-color-alert-650": "hsl(0, 100%, 27%)",
        "graphAppThemeTokens-brand-color-alert-70": "hsl(0, 100%, 76%)",
        "graphAppThemeTokens-brand-color-alert-700": "hsl(0, 100%, 22%)",
        "graphAppThemeTokens-brand-color-alert-750": "hsl(0, 100%, 17%)",
        "graphAppThemeTokens-brand-color-alert-80": "hsl(0, 100%, 72%)",
        "graphAppThemeTokens-brand-color-alert-800": "hsl(0, 100%, 12%)",
        "graphAppThemeTokens-brand-color-alert-850": "hsl(0, 100%, 8%)",
        "graphAppThemeTokens-brand-color-alert-90": "hsl(0, 100%, 68%)",
        "graphAppThemeTokens-brand-color-alert-900": "hsl(0, 100%, 3%)",
        "graphAppThemeTokens-brand-color-blue": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-blue-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-brand-color-blue-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-brand-color-blue-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-brand-color-blue-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-brand-color-blue-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-brand-color-blue-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-brand-color-blue-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-brand-color-blue-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-brand-color-blue-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-brand-color-blue-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-brand-color-blue-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-blue-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-brand-color-blue-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-brand-color-blue-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-brand-color-blue-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-brand-color-blue-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-brand-color-blue-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-brand-color-blue-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-brand-color-blue-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-brand-color-blue-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-brand-color-blue-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-brand-color-blue-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-brand-color-blue-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-brand-color-blue-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-brand-color-blue-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-brand-color-cranberry": "hsl(329, 60%, 40%)",
        "graphAppThemeTokens-brand-color-cranberry-00": "hsl(329,60%,100%)",
        "graphAppThemeTokens-brand-color-cranberry-10": "hsl(329,60%,98%)",
        "graphAppThemeTokens-brand-color-cranberry-100": "hsl(329,60%,62%)",
        "graphAppThemeTokens-brand-color-cranberry-1000": "hsl(329,60%,0%)",
        "graphAppThemeTokens-brand-color-cranberry-20": "hsl(329,60%,97%)",
        "graphAppThemeTokens-brand-color-cranberry-200": "hsl(329,60%,57%)",
        "graphAppThemeTokens-brand-color-cranberry-30": "hsl(329,60%,92%)",
        "graphAppThemeTokens-brand-color-cranberry-300": "hsl(329,60%,55%)",
        "graphAppThemeTokens-brand-color-cranberry-40": "hsl(329,60%,88%)",
        "graphAppThemeTokens-brand-color-cranberry-400": "hsl(329,60%,52%)",
        "graphAppThemeTokens-brand-color-cranberry-450": "hsl(329,60%,40%)",
        "graphAppThemeTokens-brand-color-cranberry-50": "hsl(329,60%,84%)",
        "graphAppThemeTokens-brand-color-cranberry-500": "hsl(329,60%,37%)",
        "graphAppThemeTokens-brand-color-cranberry-550": "hsl(329,60%,32%)",
        "graphAppThemeTokens-brand-color-cranberry-60": "hsl(329,60%,78%)",
        "graphAppThemeTokens-brand-color-cranberry-600": "hsl(329,60%,30%)",
        "graphAppThemeTokens-brand-color-cranberry-650": "hsl(329,60%,27%)",
        "graphAppThemeTokens-brand-color-cranberry-70": "hsl(329,60%,76%)",
        "graphAppThemeTokens-brand-color-cranberry-700": "hsl(329,60%,22%)",
        "graphAppThemeTokens-brand-color-cranberry-750": "hsl(329,60%,16%)",
        "graphAppThemeTokens-brand-color-cranberry-80": "hsl(329,60%,72%)",
        "graphAppThemeTokens-brand-color-cranberry-800": "hsl(329,60%,11%)",
        "graphAppThemeTokens-brand-color-cranberry-850": "hsl(329,60%,9%)",
        "graphAppThemeTokens-brand-color-cranberry-90": "hsl(329,60%,68%)",
        "graphAppThemeTokens-brand-color-cranberry-900": "hsl(329,60%,4%)",
        "graphAppThemeTokens-brand-color-grey": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-brand-color-grey-00": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-brand-color-grey-10": "hsl(219, 12%, 98%)",
        "graphAppThemeTokens-brand-color-grey-100": "hsl(219, 12%, 64%)",
        "graphAppThemeTokens-brand-color-grey-1000": "hsl(219, 0%, 0%)",
        "graphAppThemeTokens-brand-color-grey-20": "hsl(219, 12%, 96%)",
        "graphAppThemeTokens-brand-color-grey-200": "hsl(219, 12%, 59%)",
        "graphAppThemeTokens-brand-color-grey-30": "hsl(219, 12%, 92%)",
        "graphAppThemeTokens-brand-color-grey-300": "hsl(219, 12%, 55%)",
        "graphAppThemeTokens-brand-color-grey-40": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-brand-color-grey-400": "hsl(219, 12%, 48%)",
        "graphAppThemeTokens-brand-color-grey-450": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-brand-color-grey-50": "hsl(219, 12%, 84%)",
        "graphAppThemeTokens-brand-color-grey-500": "hsl(219, 12%, 36%)",
        "graphAppThemeTokens-brand-color-grey-550": "hsl(219, 12%, 33%)",
        "graphAppThemeTokens-brand-color-grey-60": "hsl(219, 12%, 79%)",
        "graphAppThemeTokens-brand-color-grey-600": "hsl(219, 12%, 30%)",
        "graphAppThemeTokens-brand-color-grey-650": "hsl(219, 12%, 27%)",
        "graphAppThemeTokens-brand-color-grey-70": "hsl(219, 12%, 76%)",
        "graphAppThemeTokens-brand-color-grey-700": "hsl(219, 12%, 22%)",
        "graphAppThemeTokens-brand-color-grey-750": "hsl(219, 12%, 17%)",
        "graphAppThemeTokens-brand-color-grey-80": "hsl(219, 12%, 72%)",
        "graphAppThemeTokens-brand-color-grey-800": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-brand-color-grey-850": "hsl(219, 12%, 8%)",
        "graphAppThemeTokens-brand-color-grey-90": "hsl(219, 12%, 68%)",
        "graphAppThemeTokens-brand-color-grey-900": "hsl(219, 12%, 3%)",
        "graphAppThemeTokens-brand-color-info": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-info-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-brand-color-info-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-brand-color-info-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-brand-color-info-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-brand-color-info-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-brand-color-info-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-brand-color-info-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-brand-color-info-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-brand-color-info-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-brand-color-info-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-brand-color-info-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-info-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-brand-color-info-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-brand-color-info-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-brand-color-info-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-brand-color-info-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-brand-color-info-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-brand-color-info-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-brand-color-info-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-brand-color-info-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-brand-color-info-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-brand-color-info-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-brand-color-info-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-brand-color-info-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-brand-color-info-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-brand-color-success": "hsl(123, 46%, 43%)",
        "graphAppThemeTokens-brand-color-success-00": "hsl(123, 0%, 100%)",
        "graphAppThemeTokens-brand-color-success-10": "hsl(123, 46%, 98%)",
        "graphAppThemeTokens-brand-color-success-100": "hsl(123, 46%, 63%)",
        "graphAppThemeTokens-brand-color-success-1000": "hsl(123, 0%, 0%)",
        "graphAppThemeTokens-brand-color-success-20": "hsl(123, 46%, 95%)",
        "graphAppThemeTokens-brand-color-success-200": "hsl(123, 46%, 58%)",
        "graphAppThemeTokens-brand-color-success-30": "hsl(123, 46%, 90%)",
        "graphAppThemeTokens-brand-color-success-300": "hsl(123, 46%, 55%)",
        "graphAppThemeTokens-brand-color-success-40": "hsl(123, 46%, 87%)",
        "graphAppThemeTokens-brand-color-success-400": "hsl(123, 46%, 48%)",
        "graphAppThemeTokens-brand-color-success-450": "hsl(123, 46%, 43%)",
        "graphAppThemeTokens-brand-color-success-50": "hsl(123, 46%, 82%)",
        "graphAppThemeTokens-brand-color-success-500": "hsl(123, 46%, 36%)",
        "graphAppThemeTokens-brand-color-success-550": "hsl(123, 46%, 34%)",
        "graphAppThemeTokens-brand-color-success-60": "hsl(123, 46%, 78%)",
        "graphAppThemeTokens-brand-color-success-600": "hsl(123, 46%, 30%)",
        "graphAppThemeTokens-brand-color-success-650": "hsl(123, 46%, 25%)",
        "graphAppThemeTokens-brand-color-success-70": "hsl(123, 46%, 75%)",
        "graphAppThemeTokens-brand-color-success-700": "hsl(123, 46%, 22%)",
        "graphAppThemeTokens-brand-color-success-750": "hsl(123, 46%, 17%)",
        "graphAppThemeTokens-brand-color-success-80": "hsl(123, 46%, 70%)",
        "graphAppThemeTokens-brand-color-success-800": "hsl(123, 46%, 12%)",
        "graphAppThemeTokens-brand-color-success-850": "hsl(123, 46%, 8%)",
        "graphAppThemeTokens-brand-color-success-90": "hsl(123, 46%, 66%)",
        "graphAppThemeTokens-brand-color-success-900": "hsl(123, 46%, 3%)",
        "graphAppThemeTokens-brand-color-warning": "hsl(43, 89%, 44%)",
        "graphAppThemeTokens-brand-color-warning-00": "hsl(43, 0%, 100%)",
        "graphAppThemeTokens-brand-color-warning-10": "hsl(43, 89%, 98%)",
        "graphAppThemeTokens-brand-color-warning-100": "hsl(43, 89%, 64%)",
        "graphAppThemeTokens-brand-color-warning-1000": "hsl(43, 0%, 0%)",
        "graphAppThemeTokens-brand-color-warning-20": "hsl(43, 89%, 95%)",
        "graphAppThemeTokens-brand-color-warning-200": "hsl(43, 89%, 60%)",
        "graphAppThemeTokens-brand-color-warning-30": "hsl(43, 89%, 92%)",
        "graphAppThemeTokens-brand-color-warning-300": "hsl(43, 89%, 56%)",
        "graphAppThemeTokens-brand-color-warning-40": "hsl(43, 89%, 88%)",
        "graphAppThemeTokens-brand-color-warning-400": "hsl(43, 89%, 52%)",
        "graphAppThemeTokens-brand-color-warning-450": "hsl(43, 89%, 44%)",
        "graphAppThemeTokens-brand-color-warning-50": "hsl(43, 89%, 84%)",
        "graphAppThemeTokens-brand-color-warning-500": "hsl(43, 89%, 39%)",
        "graphAppThemeTokens-brand-color-warning-550": "hsl(43, 89%, 35%)",
        "graphAppThemeTokens-brand-color-warning-60": "hsl(43, 89%, 79%)",
        "graphAppThemeTokens-brand-color-warning-600": "hsl(43, 89%, 31%)",
        "graphAppThemeTokens-brand-color-warning-650": "hsl(43, 89%, 27%)",
        "graphAppThemeTokens-brand-color-warning-70": "hsl(43, 89%, 76%)",
        "graphAppThemeTokens-brand-color-warning-700": "hsl(43, 89%, 24%)",
        "graphAppThemeTokens-brand-color-warning-750": "hsl(43, 89%, 17%)",
        "graphAppThemeTokens-brand-color-warning-80": "hsl(43, 89%, 72%)",
        "graphAppThemeTokens-brand-color-warning-800": "hsl(43, 89%, 12%)",
        "graphAppThemeTokens-brand-color-warning-850": "hsl(43, 89%, 8%)",
        "graphAppThemeTokens-brand-color-warning-90": "hsl(43, 89%, 68%)",
        "graphAppThemeTokens-brand-color-warning-900": "hsl(43, 89%, 3%)",
        "graphAppThemeTokens-color-action-background-subtle-selected": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-color-action-text-subtle-selected": "hsl(219, 12%, 30%)",
        "graphAppThemeTokens-color-alert-00": "hsl(0, 0%, 100%)",
        "graphAppThemeTokens-color-alert-10": "hsl(0, 100%, 98%)",
        "graphAppThemeTokens-color-alert-100": "hsl(0, 100%, 64%)",
        "graphAppThemeTokens-color-alert-1000": "hsl(0, 0%, 0%)",
        "graphAppThemeTokens-color-alert-20": "hsl(0, 100%, 95%)",
        "graphAppThemeTokens-color-alert-200": "hsl(0, 100%, 59%)",
        "graphAppThemeTokens-color-alert-30": "hsl(0, 100%, 92%)",
        "graphAppThemeTokens-color-alert-300": "hsl(0, 100%, 54%)",
        "graphAppThemeTokens-color-alert-40": "hsl(0, 100%, 88%)",
        "graphAppThemeTokens-color-alert-400": "hsl(0, 100%, 46%)",
        "graphAppThemeTokens-color-alert-450": "hsl(0, 100%, 40%)",
        "graphAppThemeTokens-color-alert-50": "hsl(0, 100%, 84%)",
        "graphAppThemeTokens-color-alert-500": "hsl(0, 100%, 36%)",
        "graphAppThemeTokens-color-alert-550": "hsl(0, 100%, 33%)",
        "graphAppThemeTokens-color-alert-60": "hsl(0, 100%, 79%)",
        "graphAppThemeTokens-color-alert-600": "hsl(0, 100%, 30%)",
        "graphAppThemeTokens-color-alert-650": "hsl(0, 100%, 27%)",
        "graphAppThemeTokens-color-alert-70": "hsl(0, 100%, 76%)",
        "graphAppThemeTokens-color-alert-700": "hsl(0, 100%, 22%)",
        "graphAppThemeTokens-color-alert-750": "hsl(0, 100%, 17%)",
        "graphAppThemeTokens-color-alert-80": "hsl(0, 100%, 72%)",
        "graphAppThemeTokens-color-alert-800": "hsl(0, 100%, 12%)",
        "graphAppThemeTokens-color-alert-850": "hsl(0, 100%, 8%)",
        "graphAppThemeTokens-color-alert-90": "hsl(0, 100%, 68%)",
        "graphAppThemeTokens-color-alert-900": "hsl(0, 100%, 3%)",
        "graphAppThemeTokens-color-body-text": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-color-container-background-0": "hsl(219, 0%, 0%)",
        "graphAppThemeTokens-color-container-background-1": "hsl(219, 0%, 0%)",
        "graphAppThemeTokens-color-container-background-2": "hsl(219, 0%, 0%)",
        "graphAppThemeTokens-color-container-background-3": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-container-border-4": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-color-heading-text": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-color-icon-secondary": "hsl(329,60%,62%)",
        "graphAppThemeTokens-color-info-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-color-info-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-color-info-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-color-info-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-color-info-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-color-info-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-color-info-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-color-info-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-color-info-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-color-info-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-color-info-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-info-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-color-info-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-color-info-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-color-info-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-color-info-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-color-info-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-color-info-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-color-info-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-color-info-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-color-info-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-color-info-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-color-info-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-color-info-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-color-info-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-color-neutral": "hsl(219, 12%, 84%)",
        "graphAppThemeTokens-color-neutral-00": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-color-neutral-10": "hsl(219, 12%, 98%)",
        "graphAppThemeTokens-color-neutral-100": "hsl(219, 12%, 64%)",
        "graphAppThemeTokens-color-neutral-1000": "hsl(219, 0%, 0%)",
        "graphAppThemeTokens-color-neutral-20": "hsl(219, 12%, 96%)",
        "graphAppThemeTokens-color-neutral-200": "hsl(219, 12%, 59%)",
        "graphAppThemeTokens-color-neutral-30": "hsl(219, 12%, 92%)",
        "graphAppThemeTokens-color-neutral-300": "hsl(219, 12%, 55%)",
        "graphAppThemeTokens-color-neutral-40": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-color-neutral-400": "hsl(219, 12%, 48%)",
        "graphAppThemeTokens-color-neutral-450": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-color-neutral-50": "hsl(219, 12%, 84%)",
        "graphAppThemeTokens-color-neutral-500": "hsl(219, 12%, 36%)",
        "graphAppThemeTokens-color-neutral-550": "hsl(219, 12%, 33%)",
        "graphAppThemeTokens-color-neutral-60": "hsl(219, 12%, 79%)",
        "graphAppThemeTokens-color-neutral-600": "hsl(219, 12%, 30%)",
        "graphAppThemeTokens-color-neutral-650": "hsl(219, 12%, 27%)",
        "graphAppThemeTokens-color-neutral-70": "hsl(219, 12%, 76%)",
        "graphAppThemeTokens-color-neutral-700": "hsl(219, 12%, 22%)",
        "graphAppThemeTokens-color-neutral-750": "hsl(219, 12%, 17%)",
        "graphAppThemeTokens-color-neutral-80": "hsl(219, 12%, 72%)",
        "graphAppThemeTokens-color-neutral-800": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-color-neutral-850": "hsl(219, 12%, 8%)",
        "graphAppThemeTokens-color-neutral-90": "hsl(219, 12%, 68%)",
        "graphAppThemeTokens-color-neutral-900": "hsl(219, 12%, 3%)",
        "graphAppThemeTokens-color-primary": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-color-primary-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-color-primary-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-color-primary-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-color-primary-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-color-primary-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-color-primary-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-color-primary-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-color-primary-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-color-primary-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-color-primary-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-color-primary-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-primary-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-color-primary-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-color-primary-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-color-primary-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-color-primary-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-color-primary-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-color-primary-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-color-primary-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-color-primary-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-color-primary-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-color-primary-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-color-primary-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-color-primary-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-color-primary-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-color-secondary": "hsl(329,60%,57%)",
        "graphAppThemeTokens-color-secondary-00": "hsl(329,60%,100%)",
        "graphAppThemeTokens-color-secondary-10": "hsl(329,60%,98%)",
        "graphAppThemeTokens-color-secondary-100": "hsl(329,60%,62%)",
        "graphAppThemeTokens-color-secondary-1000": "hsl(329,60%,0%)",
        "graphAppThemeTokens-color-secondary-20": "hsl(329,60%,97%)",
        "graphAppThemeTokens-color-secondary-200": "hsl(329,60%,57%)",
        "graphAppThemeTokens-color-secondary-30": "hsl(329,60%,92%)",
        "graphAppThemeTokens-color-secondary-300": "hsl(329,60%,55%)",
        "graphAppThemeTokens-color-secondary-40": "hsl(329,60%,88%)",
        "graphAppThemeTokens-color-secondary-400": "hsl(329,60%,52%)",
        "graphAppThemeTokens-color-secondary-450": "hsl(329,60%,40%)",
        "graphAppThemeTokens-color-secondary-50": "hsl(329,60%,84%)",
        "graphAppThemeTokens-color-secondary-500": "hsl(329,60%,37%)",
        "graphAppThemeTokens-color-secondary-550": "hsl(329,60%,32%)",
        "graphAppThemeTokens-color-secondary-60": "hsl(329,60%,78%)",
        "graphAppThemeTokens-color-secondary-600": "hsl(329,60%,30%)",
        "graphAppThemeTokens-color-secondary-650": "hsl(329,60%,27%)",
        "graphAppThemeTokens-color-secondary-70": "hsl(329,60%,76%)",
        "graphAppThemeTokens-color-secondary-700": "hsl(329,60%,22%)",
        "graphAppThemeTokens-color-secondary-750": "hsl(329,60%,16%)",
        "graphAppThemeTokens-color-secondary-80": "hsl(329,60%,72%)",
        "graphAppThemeTokens-color-secondary-800": "hsl(329,60%,11%)",
        "graphAppThemeTokens-color-secondary-850": "hsl(329,60%,9%)",
        "graphAppThemeTokens-color-secondary-90": "hsl(329,60%,68%)",
        "graphAppThemeTokens-color-secondary-900": "hsl(329,60%,4%)",
        "graphAppThemeTokens-color-status-icon-alert": "hsl(0, 100%, 84%)",
        "graphAppThemeTokens-color-status-icon-info": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-color-status-icon-neutral": "hsl(219, 12%, 84%)",
        "graphAppThemeTokens-color-status-icon-success": "hsl(123, 46%, 82%)",
        "graphAppThemeTokens-color-status-icon-warning": "hsl(43, 89%, 84%)",
        "graphAppThemeTokens-color-success-00": "hsl(123, 0%, 100%)",
        "graphAppThemeTokens-color-success-10": "hsl(123, 46%, 98%)",
        "graphAppThemeTokens-color-success-100": "hsl(123, 46%, 63%)",
        "graphAppThemeTokens-color-success-1000": "hsl(123, 0%, 0%)",
        "graphAppThemeTokens-color-success-20": "hsl(123, 46%, 95%)",
        "graphAppThemeTokens-color-success-200": "hsl(123, 46%, 58%)",
        "graphAppThemeTokens-color-success-30": "hsl(123, 46%, 90%)",
        "graphAppThemeTokens-color-success-300": "hsl(123, 46%, 55%)",
        "graphAppThemeTokens-color-success-40": "hsl(123, 46%, 87%)",
        "graphAppThemeTokens-color-success-400": "hsl(123, 46%, 48%)",
        "graphAppThemeTokens-color-success-450": "hsl(123, 46%, 43%)",
        "graphAppThemeTokens-color-success-50": "hsl(123, 46%, 82%)",
        "graphAppThemeTokens-color-success-500": "hsl(123, 46%, 36%)",
        "graphAppThemeTokens-color-success-550": "hsl(123, 46%, 34%)",
        "graphAppThemeTokens-color-success-60": "hsl(123, 46%, 78%)",
        "graphAppThemeTokens-color-success-600": "hsl(123, 46%, 30%)",
        "graphAppThemeTokens-color-success-650": "hsl(123, 46%, 25%)",
        "graphAppThemeTokens-color-success-70": "hsl(123, 46%, 75%)",
        "graphAppThemeTokens-color-success-700": "hsl(123, 46%, 22%)",
        "graphAppThemeTokens-color-success-750": "hsl(123, 46%, 17%)",
        "graphAppThemeTokens-color-success-80": "hsl(123, 46%, 70%)",
        "graphAppThemeTokens-color-success-800": "hsl(123, 46%, 12%)",
        "graphAppThemeTokens-color-success-850": "hsl(123, 46%, 8%)",
        "graphAppThemeTokens-color-success-90": "hsl(123, 46%, 66%)",
        "graphAppThemeTokens-color-success-900": "hsl(123, 46%, 3%)",
        "graphAppThemeTokens-color-text-neutral": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-color-text-primary": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-color-warning-00": "hsl(43, 0%, 100%)",
        "graphAppThemeTokens-color-warning-10": "hsl(43, 89%, 98%)",
        "graphAppThemeTokens-color-warning-100": "hsl(43, 89%, 64%)",
        "graphAppThemeTokens-color-warning-1000": "hsl(43, 0%, 0%)",
        "graphAppThemeTokens-color-warning-20": "hsl(43, 89%, 95%)",
        "graphAppThemeTokens-color-warning-200": "hsl(43, 89%, 60%)",
        "graphAppThemeTokens-color-warning-30": "hsl(43, 89%, 92%)",
        "graphAppThemeTokens-color-warning-300": "hsl(43, 89%, 56%)",
        "graphAppThemeTokens-color-warning-40": "hsl(43, 89%, 88%)",
        "graphAppThemeTokens-color-warning-400": "hsl(43, 89%, 52%)",
        "graphAppThemeTokens-color-warning-450": "hsl(43, 89%, 44%)",
        "graphAppThemeTokens-color-warning-50": "hsl(43, 89%, 84%)",
        "graphAppThemeTokens-color-warning-500": "hsl(43, 89%, 39%)",
        "graphAppThemeTokens-color-warning-550": "hsl(43, 89%, 35%)",
        "graphAppThemeTokens-color-warning-60": "hsl(43, 89%, 79%)",
        "graphAppThemeTokens-color-warning-600": "hsl(43, 89%, 31%)",
        "graphAppThemeTokens-color-warning-650": "hsl(43, 89%, 27%)",
        "graphAppThemeTokens-color-warning-70": "hsl(43, 89%, 76%)",
        "graphAppThemeTokens-color-warning-700": "hsl(43, 89%, 24%)",
        "graphAppThemeTokens-color-warning-750": "hsl(43, 89%, 17%)",
        "graphAppThemeTokens-color-warning-80": "hsl(43, 89%, 72%)",
        "graphAppThemeTokens-color-warning-800": "hsl(43, 89%, 12%)",
        "graphAppThemeTokens-color-warning-850": "hsl(43, 89%, 8%)",
        "graphAppThemeTokens-color-warning-90": "hsl(43, 89%, 68%)",
        "graphAppThemeTokens-color-warning-900": "hsl(43, 89%, 3%)",
        "graphAppThemeTokens-font-family-primary": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "graphAppThemeTokens-font-size-body-text-l": "11.85pt",
        "graphAppThemeTokens-font-size-body-text-m": "10.5pt",
        "graphAppThemeTokens-font-size-body-text-m-rem": "0.875rem",
        "graphAppThemeTokens-font-size-body-text-s": "9.3pt",
        "graphAppThemeTokens-font-size-body-text-xl": "13.92pt",
        "graphAppThemeTokens-font-size-body-text-xs": "8.325pt",
        "graphAppThemeTokens-font-size-body-text-xxl": "14.925pt",
        "graphAppThemeTokens-font-size-body-text-xxs": "7.35pt",
        "graphAppThemeTokens-font-size-body-text-xxxl": "16.8pt",
        "graphAppThemeTokens-font-size-body-text-xxxs": "6.525pt",
        "graphAppThemeTokens-font-size-body-text-xxxxl": "18.9pt",
        "graphAppThemeTokens-font-size-heading-text-1": "34pt",
        "graphAppThemeTokens-font-size-heading-text-2": "27pt",
        "graphAppThemeTokens-font-size-heading-text-3": "21pt",
        "graphAppThemeTokens-font-size-heading-text-4": "17pt",
        "graphAppThemeTokens-font-size-heading-text-5": "11pt",
        "graphAppThemeTokens-font-size-heading-text-6": "9pt",
        "graphAppThemeTokens-font-style-expression": "normal",
        "graphAppThemeTokens-font-style-overflow-wrap-normal": "normal",
        "graphAppThemeTokens-font-style-weight-400": "400",
        "graphAppThemeTokens-font-style-weight-700": "700",
        "graphAppThemeTokens-size-border-width-s": "1px",
        "graphs-band-displayOpts": "fill outline",
        "graphs-bar-displayOpts": "outline fill fillpattern",
        "graphs-blockPlot-altBlock-color": "hsl(219, 0%, 0%)",
        "graphs-blockPlot-altBlock-fill-color": "hsl(219, 0%, 0%)",
        "graphs-blockPlot-block-color": "hsl(219, 0%, 0%)",
        "graphs-blockPlot-block-fill-color": "hsl(219, 0%, 0%)",
        "graphs-box-capStyle": "serif",
        "graphs-box-connect": "mean",
        "graphs-box-displayOpts": "caps median mean outliers fill fillpattern",
        "graphs-box-mean-alt-color": "#E8E8E8",
        "graphs-box-mean-marker-color": "#E8E8E8",
        "graphs-box-mean-marker-size": "16px",
        "graphs-box-mean-marker-symbol": "squarefilled",
        "graphs-box-mean-text-color": "#C9C9C9",
        "graphs-box-median-alt-color": "#E8E8E8",
        "graphs-box-median-line-color": "#E8E8E8",
        "graphs-box-median-line-pattern": "1",
        "graphs-box-median-line-thickness": "3px",
        "graphs-box-median-text-color": "#C9C9C9",
        "graphs-box-whisker-alt-color": "#C9C9C9",
        "graphs-box-whisker-line-color": "#C9C9C9",
        "graphs-box-whisker-line-pattern": "1",
        "graphs-box-whisker-line-thickness": "3px",
        "graphs-box-whisker-text-color": "#C9C9C9",
        "graphs-bubble-displayOpts": "outline fill fillpattern",
        "graphs-bubble-size-max": "44px",
        "graphs-bubble-size-min": "11px",
        "graphs-decisionTree-displayOpts": "nodefill nodeoutline nodefillpattern",
        "graphs-ellipse-displayOpts": "outline",
        "graphs-heatMap-displayOpts": "fill fillpattern",
        "graphs-highLow-displayOpts": "outline fill fillpattern",
        "graphs-histogram-displayOpts": "outline fill fillpattern",
        "graphs-icicle-displayOpts": "outline fill fillpattern",
        "graphs-icicle-gap": "1dpx",
        "graphs-keyValue-outline-line-color": "#61A8FA",
        "graphs-keyValue-outline-line-thickness": "12px",
        "graphs-keyValue-text-color": "#9CC9FC",
        "graphs-keyValue-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "graphs-keyValue-text-fontSize": "9.3pt",
        "graphs-keyValue-text-fontStyle": "normal",
        "graphs-keyValue-text-fontWeight": "400",
        "graphs-lineChart-displayOpts": "standard",
        "graphs-mapRegionLayer-displayOpts": "fill fillpattern outline",
        "graphs-mosaic-displayOpts": "outline fill labels values",
        "graphs-mosaic-gap": "1dpx",
        "graphs-network-displayOpts": "nodeoutline nodefill nodefillpattern",
        "graphs-pie-displayOpts": "outline fill pieheader fillpattern",
        "graphs-pie-donut": "1",
        "graphs-pie-gap": "1dpx",
        "graphs-pie-hole-size-min": "0.15",
        "graphs-pie-ring-size": "0.3",
        "graphs-sankey-displayOpts": "volumnebars volume labels volumebarfillpattern",
        "graphs-scatter-marker-size-max": "44px",
        "graphs-scatter-marker-size-min": "11px",
        "graphs-schedule-displayOpts": "outline fill fillpattern",
        "graphs-series-displayOpts": "standard",
        "graphs-series-line-thickness-max": "10px",
        "graphs-series-line-thickness-min": "4px",
        "graphs-timeSeries-displayOpts": "standard",
        "graphs-treeMap-displayOpts": "statustext datalabel",
        "graphs-treeMap-gap": "1dpx",
        "graphs-waterfall-connect-line-color": "#C9C9C9",
        "graphs-waterfall-connect-line-pattern": "1",
        "graphs-waterfall-connect-line-thickness": "3px",
        "graphs-waterfall-displayOpts": "fill finalbar outline connect fillpattern",
        "graphs-waterfall-final-alt-color": "#D9D9D9",
        "graphs-waterfall-final-color": "#BABABA",
        "graphs-waterfall-final-fill-color": "#BABABA",
        "graphs-waterfall-final-fill-pattern": "X1",
        "graphs-waterfall-final-fill-patternColor": "hsl(219, 0%, 0%)",
        "graphs-waterfall-final-line-color": "#D9D9D9",
        "graphs-waterfall-final-line-pattern": "1",
        "graphs-waterfall-final-line-thickness": "3px",
        "graphs-waterfall-final-marker-color": "#D9D9D9",
        "graphs-waterfall-final-marker-size": "16px",
        "graphs-waterfall-final-marker-symbol": "squarefilled",
        "graphs-waterfall-final-text-color": "hsl(219, 12%, 88%)",
        "graphs-waterfall-initial-alt-color": "#D9D9D9",
        "graphs-waterfall-initial-color": "#BABABA",
        "graphs-waterfall-initial-fill-color": "#BABABA",
        "graphs-waterfall-initial-fill-pattern": "X4",
        "graphs-waterfall-initial-fill-patternColor": "hsl(219, 0%, 0%)",
        "graphs-waterfall-initial-line-color": "#D9D9D9",
        "graphs-waterfall-initial-line-pattern": "1",
        "graphs-waterfall-initial-line-thickness": "3px",
        "graphs-waterfall-initial-marker-color": "#D9D9D9",
        "graphs-waterfall-initial-marker-size": "16px",
        "graphs-waterfall-initial-marker-symbol": "trianglerightfilled",
        "graphs-waterfall-initial-text-color": "hsl(219, 12%, 88%)",
        "interaction-animationControlPanel-fill-color": "hsl(219, 0%, 0%)",
        "interaction-animationControlPanel-frameBorder": "1",
        "interaction-animationControlPanel-line-color": "hsl(219, 0%, 100%)",
        "interaction-dropZone-fill-color": "hsl(212, 94%, 35%)",
        "interaction-dropZone-line-color": "hsl(212, 94%, 62%)",
        "interaction-dropZone-line-pattern": "1",
        "interaction-dropZone-line-thickness": "2px",
        "interaction-dropZone-transparency": "0.5",
        "interaction-hyperlink-text-color": "hsl(219, 12%, 79%)",
        "interaction-keyFrameValue-padding": "0.03",
        "interaction-keyFrameValue-text-alignment-horizontal": "right",
        "interaction-keyFrameValue-text-alignment-vertical": "bottom",
        "interaction-keyFrameValue-text-color": "hsl(219, 0%, 100%)",
        "interaction-keyFrameValue-text-fitWidth": "0.42",
        "interaction-keyFrameValue-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "interaction-keyFrameValue-text-fontSize": "13.92pt",
        "interaction-keyFrameValue-text-fontStyle": "normal",
        "interaction-keyFrameValue-text-fontWeight": "700",
        "interaction-keyFrameValue-text-transparency": "0",
        "kpiStyles-indicator-alt-color": "hsl(219, 0%, 100%)",
        "kpiStyles-indicator-fill-color": "hsl(219, 0%, 0%)",
        "kpiStyles-indicator-line-color": "hsl(219, 0%, 100%)",
        "kpiStyles-indicator-transparency": "0.4",
        "kpiStyles-overflow-alt-color": "#A2DDA5",
        "kpiStyles-overflow-color": "#75CC7A",
        "kpiStyles-overflow-fill-color": "#75CC7A",
        "kpiStyles-overflow-fill-pattern": "R2",
        "kpiStyles-overflow-fill-patternColor": "hsl(219, 0%, 0%)",
        "kpiStyles-overflow-line-color": "#A2DDA5",
        "kpiStyles-overflow-line-pattern": "1",
        "kpiStyles-overflow-line-thickness": "5px",
        "kpiStyles-overflow-marker-color": "#A2DDA5",
        "kpiStyles-overflow-marker-size": "16px",
        "kpiStyles-overflow-marker-symbol": "circlefilled",
        "kpiStyles-overflow-text-color": "#A2DDA5",
        "kpiStyles-range-1-alt-color": "#FFA3A3",
        "kpiStyles-range-1-color": "#FF6464",
        "kpiStyles-range-1-fill-color": "#FF6464",
        "kpiStyles-range-1-fill-pattern": "R3",
        "kpiStyles-range-1-fill-patternColor": "hsl(219, 0%, 0%)",
        "kpiStyles-range-1-line-color": "#FFA3A3",
        "kpiStyles-range-1-line-pattern": "1",
        "kpiStyles-range-1-line-thickness": "5px",
        "kpiStyles-range-1-marker-color": "#FFA3A3",
        "kpiStyles-range-1-marker-size": "16px",
        "kpiStyles-range-1-marker-symbol": "circlefilled",
        "kpiStyles-range-1-text-color": "#FFA3A3",
        "kpiStyles-range-2-alt-color": "#F1C398",
        "kpiStyles-range-2-color": "#EAA563",
        "kpiStyles-range-2-fill-color": "#EAA563",
        "kpiStyles-range-2-fill-pattern": "L1",
        "kpiStyles-range-2-fill-patternColor": "hsl(219, 0%, 0%)",
        "kpiStyles-range-2-line-color": "#F1C398",
        "kpiStyles-range-2-line-pattern": "1",
        "kpiStyles-range-2-line-thickness": "5px",
        "kpiStyles-range-2-marker-color": "#F1C398",
        "kpiStyles-range-2-marker-size": "16px",
        "kpiStyles-range-2-marker-symbol": "circlefilled",
        "kpiStyles-range-2-text-color": "#F1C398",
        "kpiStyles-range-3-alt-color": "#F1EC7E",
        "kpiStyles-range-3-color": "#EBE447",
        "kpiStyles-range-3-fill-color": "#EBE447",
        "kpiStyles-range-3-fill-pattern": "R4",
        "kpiStyles-range-3-fill-patternColor": "hsl(219, 0%, 0%)",
        "kpiStyles-range-3-line-color": "#F1EC7E",
        "kpiStyles-range-3-line-pattern": "1",
        "kpiStyles-range-3-line-thickness": "5px",
        "kpiStyles-range-3-marker-color": "#F1EC7E",
        "kpiStyles-range-3-marker-size": "16px",
        "kpiStyles-range-3-marker-symbol": "circlefilled",
        "kpiStyles-range-3-text-color": "#F1EC7E",
        "kpiStyles-range-4-alt-color": "#C1E297",
        "kpiStyles-range-4-color": "#A5D569",
        "kpiStyles-range-4-fill-color": "#A5D569",
        "kpiStyles-range-4-fill-pattern": "X1",
        "kpiStyles-range-4-fill-patternColor": "hsl(219, 0%, 0%)",
        "kpiStyles-range-4-line-color": "#C1E297",
        "kpiStyles-range-4-line-pattern": "1",
        "kpiStyles-range-4-line-thickness": "5px",
        "kpiStyles-range-4-marker-color": "#C1E297",
        "kpiStyles-range-4-marker-size": "16px",
        "kpiStyles-range-4-marker-symbol": "circlefilled",
        "kpiStyles-range-4-text-color": "#C1E297",
        "kpiStyles-range-5-alt-color": "#8FD693",
        "kpiStyles-range-5-color": "#63C568",
        "kpiStyles-range-5-fill-color": "#63C568",
        "kpiStyles-range-5-fill-pattern": "X3",
        "kpiStyles-range-5-fill-patternColor": "hsl(219, 0%, 0%)",
        "kpiStyles-range-5-line-color": "#8FD693",
        "kpiStyles-range-5-line-pattern": "1",
        "kpiStyles-range-5-line-thickness": "5px",
        "kpiStyles-range-5-marker-color": "#8FD693",
        "kpiStyles-range-5-marker-size": "16px",
        "kpiStyles-range-5-marker-symbol": "circlefilled",
        "kpiStyles-range-5-text-color": "#8FD693",
        "kpiStyles-range-alt-color": "#040506",
        "kpiStyles-range-text-color": "hsl(219, 0%, 100%)",
        "kpiStyles-range-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "kpiStyles-range-text-fontSize": "9.3pt",
        "kpiStyles-range-text-fontStyle": "normal",
        "kpiStyles-range-text-fontWeight": "400",
        "kpiStyles-underflow-alt-color": "#FFBDBD",
        "kpiStyles-underflow-color": "#FF8080",
        "kpiStyles-underflow-fill-color": "#FF8080",
        "kpiStyles-underflow-fill-pattern": "L2",
        "kpiStyles-underflow-fill-patternColor": "hsl(219, 0%, 0%)",
        "kpiStyles-underflow-line-color": "#FFBDBD",
        "kpiStyles-underflow-line-pattern": "1",
        "kpiStyles-underflow-line-thickness": "5px",
        "kpiStyles-underflow-marker-color": "#FFBDBD",
        "kpiStyles-underflow-marker-size": "16px",
        "kpiStyles-underflow-marker-symbol": "circlefilled",
        "kpiStyles-underflow-text-color": "#FFBDBD",
        "kpiStyles-value-alt-text-color": "#2F343C",
        "kpiStyles-value-text-color": "hsl(219, 12%, 79%)",
        "kpiStyles-value-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "kpiStyles-value-text-fontSize": "9.3pt",
        "kpiStyles-value-text-fontStyle": "normal",
        "kpiStyles-value-text-fontWeight": "400",
        "layout-dataMatrix-cellSeparator": "1",
        "layout-dataMatrix-matrixBorder": "hsl(219, 0%, 100%)",
        "layout-dataPanel-confineTickValues": "true",
        "layout-lattice-confineTickValues": "true",
        "layout-matrixBorder-line-color": "hsl(219, 0%, 100%)",
        "layout-matrixBorder-line-pattern": "1",
        "layout-matrixBorder-line-thickness": "2dpx",
        "layout-overlay": "top",
        "legend-continuous-frameBorder": "0",
        "legend-continuous-title-hAlign": "left",
        "legend-continuous-title-position": "top",
        "legend-continuous-titleSeparatorTop": "1",
        "legend-discrete-frameBorder": "0",
        "legend-discrete-title-hAlign": "left",
        "legend-discrete-title-position": "top",
        "legend-discrete-titleSeparatorTop": "1",
        "legend-global-dataMatrix-align": "begin",
        "legend-global-dataMatrix-alignTo": "wall",
        "legend-global-lattice": "begin",
        "legend-global-overlay-align": "begin",
        "legend-global-overlay-alignTo": "wall",
        "legend-global-region-align": "begin",
        "legend-size-frameBorder": "0",
        "legend-size-title-hAlign": "left",
        "legend-size-title-position": "top",
        "legend-size-titleSeparatorTop": "1",
        "nodeLinkDiagram-dataNode-0-alt-color": "#C0C0C0",
        "nodeLinkDiagram-dataNode-0-color": "#D7D7D7",
        "nodeLinkDiagram-dataNode-0-fill-color": "#D7D7D7",
        "nodeLinkDiagram-dataNode-0-fill-pattern": "L1",
        "nodeLinkDiagram-dataNode-0-fill-patternColor": "hsla(0, 0%, 0%, 1)",
        "nodeLinkDiagram-dataNode-0-line-color": "#C0C0C0",
        "nodeLinkDiagram-dataNode-0-line-thickness": "3px",
        "nodeLinkDiagram-dataNode-0-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-dataNode-1-alt-color": "#9CC9FC",
        "nodeLinkDiagram-dataNode-1-color": "#C0DCFD",
        "nodeLinkDiagram-dataNode-1-fill-color": "#C0DCFD",
        "nodeLinkDiagram-dataNode-1-line-color": "#9CC9FC",
        "nodeLinkDiagram-dataNode-1-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-dataNode-2-alt-color": "#FBB074",
        "nodeLinkDiagram-dataNode-2-color": "#FDD2B0",
        "nodeLinkDiagram-dataNode-2-fill-color": "#FDD2B0",
        "nodeLinkDiagram-dataNode-2-line-color": "#FBB074",
        "nodeLinkDiagram-dataNode-2-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-dataNode-3-alt-color": "#3ADECB",
        "nodeLinkDiagram-dataNode-3-color": "#A6E4DC",
        "nodeLinkDiagram-dataNode-3-fill-color": "#A6E4DC",
        "nodeLinkDiagram-dataNode-3-line-color": "#3ADECB",
        "nodeLinkDiagram-dataNode-3-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-dataNode-4-alt-color": "#FFADDA",
        "nodeLinkDiagram-dataNode-4-color": "#FFC5E5",
        "nodeLinkDiagram-dataNode-4-fill-color": "#FFC5E5",
        "nodeLinkDiagram-dataNode-4-line-color": "#FFADDA",
        "nodeLinkDiagram-dataNode-4-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-dataNode-5-alt-color": "#A4D053",
        "nodeLinkDiagram-dataNode-5-color": "#CFE1AD",
        "nodeLinkDiagram-dataNode-5-fill-color": "#CFE1AD",
        "nodeLinkDiagram-dataNode-5-line-color": "#A4D053",
        "nodeLinkDiagram-dataNode-5-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-dataNode-6-alt-color": "#E4C7FF",
        "nodeLinkDiagram-dataNode-6-color": "#E8D0FF",
        "nodeLinkDiagram-dataNode-6-fill-color": "#E8D0FF",
        "nodeLinkDiagram-dataNode-6-line-color": "#E4C7FF",
        "nodeLinkDiagram-dataNode-6-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-dataNode-7-alt-color": "#E0D46B",
        "nodeLinkDiagram-dataNode-7-color": "#EEE8B0",
        "nodeLinkDiagram-dataNode-7-fill-color": "#EEE8B0",
        "nodeLinkDiagram-dataNode-7-line-color": "#E0D46B",
        "nodeLinkDiagram-dataNode-7-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-dataNode-8-alt-color": "#FFB1AD",
        "nodeLinkDiagram-dataNode-8-color": "#FFCAC7",
        "nodeLinkDiagram-dataNode-8-fill-color": "#FFCAC7",
        "nodeLinkDiagram-dataNode-8-line-color": "#FFB1AD",
        "nodeLinkDiagram-dataNode-8-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-dataNode-ramps-0-fill-end": "#F98E39",
        "nodeLinkDiagram-dataNode-ramps-0-fill-neutral": "#FFFFFF",
        "nodeLinkDiagram-dataNode-ramps-0-fill-start": "#61A8FA",
        "nodeLinkDiagram-details-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-details-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-details-text-fontSize": "7.35pt",
        "nodeLinkDiagram-details-text-fontStyle": "normal",
        "nodeLinkDiagram-details-text-fontWeight": "400",
        "nodeLinkDiagram-group-closed-fill-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-group-closed-line-color": "#C9C9C9",
        "nodeLinkDiagram-group-closed-line-thickness": "3px",
        "nodeLinkDiagram-group-closed-text-color": "#C9C9C9",
        "nodeLinkDiagram-group-closed-transparency": "0",
        "nodeLinkDiagram-group-contentArea-fill-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-group-contentArea-fill-transparency": "0.2",
        "nodeLinkDiagram-group-open-fill-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-group-open-line-color": "#C9C9C9",
        "nodeLinkDiagram-group-open-line-thickness": "3px",
        "nodeLinkDiagram-group-open-text-color": "#C9C9C9",
        "nodeLinkDiagram-group-open-transparency": "0",
        "nodeLinkDiagram-group-title-fill-transparency": "0.2",
        "nodeLinkDiagram-group-title-text-color": "#C9C9C9",
        "nodeLinkDiagram-group-title-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-group-title-text-fontSize": "10.5pt",
        "nodeLinkDiagram-group-title-text-fontStyle": "normal",
        "nodeLinkDiagram-group-title-text-fontWeight": "400",
        "nodeLinkDiagram-iconNode-end-text-color": "hsl(0, 100%, 84%)",
        "nodeLinkDiagram-iconNode-fill-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-iconNode-gateway-exclusive-text-color": "hsl(212, 94%, 83%)",
        "nodeLinkDiagram-iconNode-gateway-inclusive-text-color": "hsl(212, 94%, 83%)",
        "nodeLinkDiagram-iconNode-start-text-color": "hsl(123, 46%, 82%)",
        "nodeLinkDiagram-iconNode-timer-text-color": "hsl(212, 94%, 83%)",
        "nodeLinkDiagram-inputLabel-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-inputLabel-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-inputLabel-text-fontSize": "10.5pt",
        "nodeLinkDiagram-inputLabel-text-fontStyle": "normal",
        "nodeLinkDiagram-inputLabel-text-fontWeight": "400",
        "nodeLinkDiagram-label-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-label-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-label-text-fontSize": "10.5pt",
        "nodeLinkDiagram-label-text-fontStyle": "normal",
        "nodeLinkDiagram-label-text-fontWeight": "400",
        "nodeLinkDiagram-link-alt-color": "#B4B4B4",
        "nodeLinkDiagram-link-color": "#878787",
        "nodeLinkDiagram-link-crossover-alt-color": "hsla(0, 0%, 69%, 1)",
        "nodeLinkDiagram-link-crossover-line-color": "hsla(0, 0%, 69%, 1)",
        "nodeLinkDiagram-link-crossover-line-pattern": "2",
        "nodeLinkDiagram-link-crossover-line-thickness": "5px",
        "nodeLinkDiagram-link-crossover-line-transparency": "0",
        "nodeLinkDiagram-link-fill-color": "#878787",
        "nodeLinkDiagram-link-line-color": "#B4B4B4",
        "nodeLinkDiagram-link-line-pattern": "1",
        "nodeLinkDiagram-link-line-thickness": "5px",
        "nodeLinkDiagram-link-marker-color": "#B4B4B4",
        "nodeLinkDiagram-note-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-note-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-note-text-fontSize": "7.35pt",
        "nodeLinkDiagram-note-text-fontStyle": "normal",
        "nodeLinkDiagram-note-text-fontWeight": "400",
        "nodeLinkDiagram-outlinesNode-line-color": "hsl(219, 12%, 42%)",
        "nodeLinkDiagram-status-animatedProgressIndicator-text-color": "hsl(212, 94%, 83%)",
        "nodeLinkDiagram-status-background-fill-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-status-clustered-text-color": "hsl(212, 94%, 83%)",
        "nodeLinkDiagram-status-complete-text-color": "hsl(123, 46%, 82%)",
        "nodeLinkDiagram-status-error-text-color": "hsl(0, 100%, 84%)",
        "nodeLinkDiagram-status-important-text-color": "hsl(0, 100%, 84%)",
        "nodeLinkDiagram-status-incomplete-text-color": "hsl(0, 100%, 84%)",
        "nodeLinkDiagram-status-incompleteInProgress-text-color": "hsl(212, 94%, 83%)",
        "nodeLinkDiagram-status-information-text-color": "hsl(212, 94%, 83%)",
        "nodeLinkDiagram-status-locked-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-status-mediumPriority-text-color": "hsl(43, 89%, 84%)",
        "nodeLinkDiagram-status-neutral-text-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-status-progress-text-color": "hsl(212, 94%, 83%)",
        "nodeLinkDiagram-status-scheduled-text-color": "hsl(212, 94%, 83%)",
        "nodeLinkDiagram-status-stopped-text-color": "hsl(0, 100%, 84%)",
        "nodeLinkDiagram-status-stopping-text-color": "hsl(0, 100%, 84%)",
        "nodeLinkDiagram-status-warning-text-color": "hsl(43, 89%, 84%)",
        "nodeLinkDiagram-subject-fill-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-subject-line-color": "#9CC9FC",
        "nodeLinkDiagram-subject-line-pattern": "1",
        "nodeLinkDiagram-subject-line-thickness": "3px",
        "nodeLinkDiagram-subject-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-title-text-color": "hsl(219, 0%, 0%)",
        "nodeLinkDiagram-title-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-title-text-fontSize": "9.3pt",
        "nodeLinkDiagram-title-text-fontStyle": "normal",
        "nodeLinkDiagram-title-text-fontWeight": "700",
        "outlier-alt-color": "#E8E8E8",
        "outlier-color": "#C9C9C9",
        "outlier-fill-color": "#C9C9C9",
        "outlier-line-color": "#E8E8E8",
        "outlier-line-pattern": "1",
        "outlier-line-thickness": "5px",
        "outlier-marker-color": "#E8E8E8",
        "outlier-marker-size": "16px",
        "outlier-marker-symbol": "circlefilled",
        "outlier-ramps-fill-color-end": "#8C8C8C",
        "outlier-ramps-fill-color-start": "#F0F0F0",
        "outlier-text-color": "#E8E8E8",
        "outlines-line-color": "hsl(219, 0%, 0%)",
        "outlines-line-pattern": "1",
        "outlines-line-thickness": "3px",
        "outlines-unfilled-line-color": "#C9C9C9",
        "outlines-unfilled-line-pattern": "1",
        "outlines-unfilled-line-thickness": "3px",
        "overplotting-grouped-marker-size-min": "8px",
        "overplotting-ungrouped-marker-size-min": "6px",
        "overview-axis-filter-color": "hsl(219, 0%, 0%)",
        "overview-axis-filter-fill-color": "hsl(219, 0%, 0%)",
        "overview-axis-filter-fill-transparency": "0.5",
        "overview-axis-line-color": "hsl(219, 0%, 100%)",
        "overview-axis-line-thickness": "2dpx",
        "overview-border-line-color": "hsl(219, 0%, 100%)",
        "overview-border-line-thickness": "2dpx",
        "overview-border-transparency": "0",
        "overview-fill-color": "hsl(219, 0%, 0%)",
        "overview-filter-fill-color": "hsl(219, 0%, 0%)",
        "overview-filter-transparency": "0.5",
        "overview-transparency": "0",
        "overview-viewportBorder-line-color": "hsl(212, 94%, 62%)",
        "overview-viewportBorder-line-thickness": "2dpx",
        "overview-viewportBorder-transparency": "0",
        "palette-discrete-1": "#61A8FA",
        "palette-discrete-2": "#F98E39",
        "palette-discrete-3": "#1FBBA9",
        "palette-discrete-4": "#FF6FBD",
        "palette-discrete-5": "#87B532",
        "palette-discrete-6": "#C68AFF",
        "palette-discrete-7": "#D6C539",
        "palette-discrete-8": "#FF7973",
        "palette-kpi-1": "#FF6464",
        "palette-kpi-3": "#EBE447",
        "palette-kpi-5": "#63C568",
        "prediction-alt-color": "#984DE0",
        "prediction-color": "#CFACF1",
        "prediction-fill-color": "#CFACF1",
        "prediction-line-color": "#984DE0",
        "prediction-line-pattern": "34",
        "prediction-line-thickness": "5px",
        "prediction-marker-color": "#984DE0",
        "prediction-marker-size": "16px",
        "prediction-marker-symbol": "squarefilled",
        "prediction-text-color": "#7F25D5",
        "predictionLimits-alt-color": "#E4C7FF",
        "predictionLimits-color": "#4C2670",
        "predictionLimits-fill-color": "#4C2670",
        "predictionLimits-fill-pattern": "E",
        "predictionLimits-fill-patternColor": "hsl(219, 0%, 0%)",
        "predictionLimits-fill-transparency": "0.4",
        "predictionLimits-line-color": "#E4C7FF",
        "predictionLimits-line-pattern": "34",
        "predictionLimits-line-thickness": "1px",
        "predictionLimits-marker-color": "#E4C7FF",
        "predictionLimits-marker-size": "16px",
        "predictionLimits-marker-symbol": "trianglefilled",
        "predictionLimits-text-color": "#8C50C4",
        "ramps-threeColorDivergent-0-alt-color-end": "#FBB074",
        "ramps-threeColorDivergent-0-alt-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-0-alt-color-start": "#9CC9FC",
        "ramps-threeColorDivergent-0-fill-color-end": "#F98E39",
        "ramps-threeColorDivergent-0-fill-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-0-fill-color-start": "#61A8FA",
        "ramps-threeColorDivergent-1-alt-color-end": "#FBB074",
        "ramps-threeColorDivergent-1-alt-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-1-alt-color-start": "#9CC9FC",
        "ramps-threeColorDivergent-1-fill-color-end": "#F98E39",
        "ramps-threeColorDivergent-1-fill-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-1-fill-color-start": "#61A8FA",
        "ramps-threeColorDivergent-2-alt-color-end": "#FFADDA",
        "ramps-threeColorDivergent-2-alt-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-2-alt-color-start": "#3ADECB",
        "ramps-threeColorDivergent-2-fill-color-end": "#FF6FBD",
        "ramps-threeColorDivergent-2-fill-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-2-fill-color-start": "#1FBBA9",
        "ramps-threeColorDivergent-3-alt-color-end": "#E4C7FF",
        "ramps-threeColorDivergent-3-alt-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-3-alt-color-start": "#A4D053",
        "ramps-threeColorDivergent-3-fill-color-end": "#C68AFF",
        "ramps-threeColorDivergent-3-fill-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-3-fill-color-start": "#87B532",
        "ramps-threeColorDivergent-4-alt-color-end": "#FFB1AD",
        "ramps-threeColorDivergent-4-alt-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-4-alt-color-start": "#E0D46B",
        "ramps-threeColorDivergent-4-fill-color-end": "#FF7973",
        "ramps-threeColorDivergent-4-fill-color-neutral": "#FFFFFF",
        "ramps-threeColorDivergent-4-fill-color-start": "#D6C539",
        "ramps-threeColorKPI-alt-color-end": "#8FD693",
        "ramps-threeColorKPI-alt-color-neutral": "#F1EC7E",
        "ramps-threeColorKPI-alt-color-start": "#FFA3A3",
        "ramps-threeColorKPI-fill-color-end": "#63C568",
        "ramps-threeColorKPI-fill-color-neutral": "#EBE447",
        "ramps-threeColorKPI-fill-color-start": "#FF6464",
        "ramps-twoColorLinear-0-alt-color-end": "#83BBFC",
        "ramps-twoColorLinear-0-alt-color-start": "#E7F2FE",
        "ramps-twoColorLinear-0-fill-color-end": "#489BFA",
        "ramps-twoColorLinear-0-fill-color-start": "#E7F2FE",
        "ramps-twoColorLinear-1-alt-color-end": "#83BBFC",
        "ramps-twoColorLinear-1-alt-color-start": "#E7F2FE",
        "ramps-twoColorLinear-1-fill-color-end": "#489BFA",
        "ramps-twoColorLinear-1-fill-color-start": "#E7F2FE",
        "ramps-twoColorLinear-2-alt-color-end": "#FFAF70",
        "ramps-twoColorLinear-2-alt-color-start": "#FEEEE1",
        "ramps-twoColorLinear-2-fill-color-end": "#FF8D33",
        "ramps-twoColorLinear-2-fill-color-start": "#FEEEE1",
        "ramps-twoColorLinear-3-alt-color-end": "#2EEAD5",
        "ramps-twoColorLinear-3-alt-color-start": "#DDF5F2",
        "ramps-twoColorLinear-3-fill-color-end": "#14C6B2",
        "ramps-twoColorLinear-3-fill-color-start": "#DDF5F2",
        "ramps-twoColorLinear-4-alt-color-end": "#FFADDA",
        "ramps-twoColorLinear-4-alt-color-start": "#FFE9F5",
        "ramps-twoColorLinear-4-fill-color-end": "#FF6FBD",
        "ramps-twoColorLinear-4-fill-color-start": "#FFE9F5",
        "ramps-twoColorLinear-5-alt-color-end": "#A7DB48",
        "ramps-twoColorLinear-5-alt-color-start": "#EDF4E0",
        "ramps-twoColorLinear-5-fill-color-end": "#8BC126",
        "ramps-twoColorLinear-5-fill-color-start": "#EDF4E0",
        "ramps-twoColorLinear-6-alt-color-end": "#E4C7FF",
        "ramps-twoColorLinear-6-alt-color-start": "#F6EDFF",
        "ramps-twoColorLinear-6-fill-color-end": "#C68AFF",
        "ramps-twoColorLinear-6-fill-color-start": "#F6EDFF",
        "ramps-twoColorLinear-7-alt-color-end": "#ECDC60",
        "ramps-twoColorLinear-7-alt-color-start": "#F9F6E1",
        "ramps-twoColorLinear-7-fill-color-end": "#E5D12A",
        "ramps-twoColorLinear-7-fill-color-start": "#F9F6E1",
        "ramps-twoColorLinear-8-alt-color-end": "#FFB1AD",
        "ramps-twoColorLinear-8-alt-color-start": "#FFEBEA",
        "ramps-twoColorLinear-8-fill-color-end": "#FF7973",
        "ramps-twoColorLinear-8-fill-color-start": "#FFEBEA",
        "ramps-twoColorLinear-other-alt-color-end": "#ABABAB",
        "ramps-twoColorLinear-other-alt-color-start": "#F0F0F0",
        "ramps-twoColorLinear-other-fill-color-end": "#8C8C8C",
        "ramps-twoColorLinear-other-fill-color-start": "#F0F0F0",
        "reports-base-font-family": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "reports-base-font-size": "10.5pt",
        "reports-base-font-style": "normal",
        "reports-base-font-weight": "400",
        "reports-base-text-color": "hsl(219, 0%, 100%)",
        "reports-button-bar-background-color": "hsl(219, 0%, 0%)",
        "reports-button-bar-color": "hsl(219, 0%, 100%)",
        "reports-button-bar-font-weight": "normal",
        "reports-button-bar-selected-background-color": "hsl(212, 0%, 100%)",
        "reports-button-bar-selected-color": "hsl(219, 12%, 30%)",
        "reports-checkbox-list-background-color": "hsl(219, 0%, 0%)",
        "reports-checkbox-list-color": "hsl(219, 0%, 100%)",
        "reports-combobox-background-color": "hsl(219, 0%, 0%)",
        "reports-combobox-color": "hsl(219, 0%, 100%)",
        "reports-container-background-color": "hsl(219, 0%, 0%)",
        "reports-container-border-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-header-background-color": "hsl(219, 0%, 0%)",
        "reports-crosstab-header-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-header-font-size": "9.3pt",
        "reports-crosstab-header-font-weight": "700",
        "reports-crosstab-header-line-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-measureHeader-background-color": "hsl(219, 0%, 0%)",
        "reports-crosstab-measureHeader-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-measureHeader-font-size": "9.3pt",
        "reports-crosstab-measureHeader-font-weight": "700",
        "reports-crosstab-rowHeader-background-color": "hsl(219, 0%, 0%)",
        "reports-crosstab-rowHeader-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-rowHeader-font-size": "9.3pt",
        "reports-crosstab-rowHeader-font-weight": "700",
        "reports-crosstab-scrollbar-fill-color": "hsl(219, 12%, 84%)",
        "reports-crosstab-subtotals-background-color": "hsl(219, 0%, 0%)",
        "reports-crosstab-subtotals-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-subtotals-font-size": "9.3pt",
        "reports-crosstab-subtotals-font-weight": "700",
        "reports-crosstab-table-alt-row-color": "hsl(219, 0%, 0%)",
        "reports-crosstab-table-border-style": "none",
        "reports-crosstab-table-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-table-displayOpts": "plain",
        "reports-crosstab-table-font-size": "9.3pt",
        "reports-crosstab-table-font-weight": "400",
        "reports-crosstab-table-horizontal-line-pattern": "solid",
        "reports-crosstab-table-vertical-line-pattern": "solid",
        "reports-crosstab-totals-background-color": "hsl(219, 0%, 0%)",
        "reports-crosstab-totals-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-totals-font-size": "9.3pt",
        "reports-crosstab-totals-font-weight": "700",
        "reports-element-container-padding": "16px",
        "reports-graph-menu-border-color": "hsl(219, 0%, 100%)",
        "reports-graph-menu-text-colorSelected": "hsl(219, 12%, 30%)",
        "reports-graph-slider-bar-fill-color": "hsl(219, 0%, 0%)",
        "reports-graph-slider-bar-line-colorBottom": "hsl(219, 0%, 100%)",
        "reports-graph-slider-bar-line-colorTop": "hsl(219, 0%, 100%)",
        "reports-graph-slider-thumb-fill-colorCenter": "hsl(329,60%,62%)",
        "reports-graph-slider-thumb-line-color": "hsl(219, 0%, 100%)",
        "reports-graph-slider-ui5-bar-fill-color": "hsl(212, 94%, 83%)",
        "reports-graph-slider-ui5-bar-line-colorBottom": "hsl(219, 0%, 100%)",
        "reports-graph-slider-ui5-bar-line-colorTop": "hsl(219, 0%, 100%)",
        "reports-graph-slider-ui5-thumb-fill-colorCenter": "hsl(212, 94%, 83%)",
        "reports-graph-slider-ui5-thumb-fill-colorDonut": "hsl(219, 0%, 0%)",
        "reports-graph-slider-ui5-thumb-line-color": "hsl(219, 0%, 100%)",
        "reports-heading-alt-color": "hsl(212, 94%, 83%)",
        "reports-heading-color": "hsl(219, 0%, 100%)",
        "reports-heading-font-family": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "reports-heading-font-weight": "400",
        "reports-hover-background-color": "hsl(219, 0%, 0%)",
        "reports-hover-text-color": "hsl(219, 0%, 100%)",
        "reports-page-padding": "16px",
        "reports-prompt-bar-background-color": "hsl(219, 0%, 0%)",
        "reports-radio-button-color": "hsl(219, 0%, 100%)",
        "reports-report-background-color": "hsl(219, 0%, 0%)",
        "reports-selected-background-color": "hsl(212, 0%, 100%)",
        "reports-selected-text-color": "hsl(219, 0%, 100%)",
        "reports-stack-container-background-color": "hsl(219, 0%, 0%)",
        "reports-stack-container-color": "hsl(219, 0%, 100%)",
        "reports-stack-container-selected-background-color": "hsl(212, 0%, 100%)",
        "reports-stack-container-selected-border-color": "hsl(219, 0%, 100%)",
        "reports-stack-container-selected-color": "hsl(219, 12%, 30%)",
        "reports-subtotals-background-color": "hsl(219, 0%, 0%)",
        "reports-subtotals-color": "hsl(219, 0%, 100%)",
        "reports-subtotals-font-size": "9.3pt",
        "reports-subtotals-font-weight": "700",
        "reports-table-alt-row-color": "hsl(219, 0%, 0%)",
        "reports-table-border-color": "hsl(219, 0%, 100%)",
        "reports-table-border-style": "solid",
        "reports-table-border-width": "1px",
        "reports-table-color": "hsl(219, 0%, 100%)",
        "reports-table-displayOpts": "plain",
        "reports-table-font-size": "9.3pt",
        "reports-table-header-background-color": "hsl(219, 0%, 0%)",
        "reports-table-header-color": "hsl(219, 0%, 100%)",
        "reports-table-header-font-size": "9.3pt",
        "reports-table-header-font-weight": "700",
        "reports-table-horizontal-line-pattern": "solid",
        "reports-table-row-color": "hsl(219, 0%, 0%)",
        "reports-table-scrollbar-fill-color": "hsl(219, 12%, 84%)",
        "reports-table-totals-background-color": "hsl(219, 0%, 0%)",
        "reports-table-totals-color": "hsl(219, 0%, 100%)",
        "reports-table-totals-font-size": "9.3pt",
        "reports-table-totals-font-weight": "400",
        "reports-table-vertical-line-pattern": "solid",
        "reports-text-input-color": "hsl(219, 0%, 100%)",
        "reports-title-style-color": "hsl(219, 0%, 100%)",
        "reports-title-style-font-size": "13.92pt",
        "reports-totals-background-color": "hsl(219, 0%, 0%)",
        "reports-totals-color": "hsl(219, 0%, 100%)",
        "reports-totals-font-size": "9.3pt",
        "reports-totals-font-weight": "700",
        "reports-visual-prompt-container-background-color": "hsl(219, 0%, 0%)",
        "reports-zoom-scrollbar-endHandle-color": "hsl(219, 12%, 84%)",
        "reports-zoom-scrollbar-endHandle-line-color": "hsl(219, 12%, 84%)",
        "reports-zoom-scrollbar-thumb-color": "hsl(219, 0%, 0%)",
        "skin-blend-color-end": "hsl(219, 0%, 100%)",
        "skin-blend-color-start": "hsl(219, 0%, 100%)",
        "skin-blend-endColorFactor": "0.3",
        "skin-blend-mode": "normal",
        "skin-blend-startColorFactor": "0",
        "skin-data": "none",
        "skin-glow-blur": "0",
        "skin-glow-color": "hsl(219, 0%, 100%)",
        "skin-glow-colorFactor": "-0.9",
        "skin-glow-thickness": "1px",
        "skin-kpi": "none",
        "states-focus-background": "1",
        "states-focus-background-line-color": "hsl(219, 0%, 0%)",
        "states-focus-background-line-pattern": "1",
        "states-focus-background-line-thickness": "5px",
        "states-focus-background-line-transparency": "0",
        "states-focus-line-color": "#FFFFFF",
        "states-focus-line-pattern": "2",
        "states-focus-line-thickness": "3px",
        "states-focus-line-transparency": "0",
        "states-selection-alt-color": "#FFFFFF",
        "states-selection-color": "hsl(219, 0%, 0%)",
        "states-selection-fill-color": "hsl(219, 0%, 0%)",
        "states-selection-line-color": "#FFFFFF",
        "states-selection-line-pattern": "1",
        "states-selection-line-thickness": "5px",
        "states-selection-marker-color": "#FFFFFF",
        "states-selection-marker-size": "16px",
        "states-selection-marker-symbol": "circlefilled",
        "states-selection-text-color": "#FFFFFF",
        "templateContainer-attributeProperty": "none",
        "templateContainer-dataStyleReference": "remapped",
        "typography-data-text-color": "hsl(219, 0%, 100%)",
        "typography-data-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-data-text-fontSize": "8.325pt",
        "typography-data-text-fontStyle": "normal",
        "typography-data-text-fontWeight": "400",
        "typography-footnote-text-color": "hsl(219, 0%, 100%)",
        "typography-footnote-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-footnote-text-fontSize": "10.5pt",
        "typography-footnote-text-fontStyle": "normal",
        "typography-footnote-text-fontWeight": "400",
        "typography-label-text-color": "hsl(219, 0%, 100%)",
        "typography-label-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-label-text-fontSize": "10.5pt",
        "typography-label-text-fontStyle": "normal",
        "typography-label-text-fontWeight": "700",
        "typography-title-text-color": "hsl(219, 0%, 100%)",
        "typography-title-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-title-text-fontSize": "13.92pt",
        "typography-title-text-fontStyle": "normal",
        "typography-title-text-fontWeight": "400",
        "typography-values-text-color": "hsl(219, 12%, 79%)",
        "typography-values-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-values-text-fontSize": "9.3pt",
        "typography-values-text-fontStyle": "normal",
        "typography-values-text-fontWeight": "400"
    }
};

const LightTokens = {
    name: "light",
    selectors: [":root", "[data-sas-theme='graph-light']"],
    tokens: {
        "annotation-line-alt-color": "hsl(219, 12%, 22%)",
        "annotation-line-color": "hsl(219, 12%, 22%)",
        "annotation-line-pattern": "1",
        "annotation-line-text-color": "hsl(219, 12%, 42%)",
        "annotation-line-thickness": "1px",
        "annotation-reference-alt-color": "hsl(219, 12%, 22%)",
        "annotation-reference-line-color": "hsl(219, 12%, 22%)",
        "annotation-reference-line-pattern": "1",
        "annotation-reference-line-thickness": "1dpx",
        "annotation-reference-marker-color": "hsl(219, 12%, 22%)",
        "annotation-reference-text-color": "hsl(219, 12%, 22%)",
        "annotation-shape-alt-color": "hsl(219, 12%, 79%)",
        "annotation-shape-color": "hsl(219, 0%, 100%)",
        "annotation-shape-fill-color": "hsl(219, 0%, 100%)",
        "annotation-shape-line-color": "hsl(219, 12%, 79%)",
        "annotation-shape-line-pattern": "1",
        "annotation-shape-line-thickness": "1px",
        "annotation-shape-marker-color": "hsl(219, 12%, 42%)",
        "annotation-shape-marker-size": "11px",
        "annotation-shape-marker-symbol": "starfilled",
        "annotation-shape-text-color": "hsl(219, 12%, 42%)",
        "annotation-text-color": "hsl(219, 12%, 42%)",
        "annotation-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "annotation-text-fontSize": "9.3pt",
        "annotation-text-fontStyle": "normal",
        "annotation-text-fontWeight": "400",
        "axis-discrete-displayOpts": "tickvalues ticks line label",
        "axis-discrete-gridDisplay": "false",
        "axis-linear-displayOpts": "tickvalues label",
        "axis-linear-gridDisplay": "true",
        "axis-log-displayOpts": "tickvalues label",
        "axis-log-gridDisplay": "true",
        "axis-time-displayOpts": "tickvalues label",
        "axis-time-gridDisplay": "true",
        "chrome-axis-line-color": "hsl(219, 12%, 22%)",
        "chrome-axis-line-pattern": "1",
        "chrome-axis-line-thickness": "1dpx",
        "chrome-axis-tickDisplay": "OUTSIDE",
        "chrome-background-fill-color": "hsl(219, 0%, 100%)",
        "chrome-background-frameBorder": "false",
        "chrome-border-line-color": "hsl(219, 12%, 22%)",
        "chrome-border-line-pattern": "1",
        "chrome-border-line-thickness": "1dpx",
        "chrome-callout-line-color": "hsl(219, 12%, 22%)",
        "chrome-callout-line-pattern": "1",
        "chrome-callout-line-thickness": "1dpx",
        "chrome-callout-line-transparency": "0.4",
        "chrome-cellSeparator-line-color": "hsl(219, 12%, 22%)",
        "chrome-cellSeparator-line-pattern": "34",
        "chrome-cellSeparator-line-thickness": "1dpx",
        "chrome-grid-gridLayer": "front",
        "chrome-grid-line-color": "hsl(219, 12%, 22%)",
        "chrome-grid-line-pattern": "34",
        "chrome-grid-line-thickness": "1dpx",
        "chrome-grid-line-transparency": "0.6",
        "chrome-header-fill-color": "hsl(219, 12%, 92%)",
        "chrome-legend-fill-color": "hsl(219, 0%, 100%)",
        "chrome-legend-frameBorder": "false",
        "chrome-legend-titleBorder": "0",
        "chrome-wall-displayOpts": "none",
        "chrome-wall-fill-color": "hsl(219, 0%, 100%)",
        "chrome-wall-fill-transparency": "0",
        "chrome-wall-frameBorder": "false",
        "chrome-wall-line-color": "hsl(219, 12%, 22%)",
        "chrome-wall-line-pattern": "1",
        "chrome-wall-line-thickness": "1dpx",
        "chrome-wall-line-transparency": "0",
        "confidence-1-alt-color": "#8C9CAD",
        "confidence-1-color": "#B9CEE5",
        "confidence-1-fill-color": "#B9CEE5",
        "confidence-1-fill-pattern": "E",
        "confidence-1-fill-patternColor": "#8C9CAD",
        "confidence-1-fill-transparency": "0.5",
        "confidence-1-line-color": "#8C9CAD",
        "confidence-1-line-pattern": "4",
        "confidence-1-line-thickness": "2px",
        "confidence-1-marker-color": "#8C9CAD",
        "confidence-1-marker-size": "11px",
        "confidence-1-marker-symbol": "squarefilled",
        "confidence-1-text-color": "#778594",
        "confidence-2-alt-color": "#AB988B",
        "confidence-2-color": "#E2C9B8",
        "confidence-2-fill-color": "#E2C9B8",
        "confidence-2-fill-pattern": "E",
        "confidence-2-fill-patternColor": "#AB988B",
        "confidence-2-fill-transparency": "0.5",
        "confidence-2-line-color": "#AB988B",
        "confidence-2-line-pattern": "8",
        "confidence-2-line-thickness": "2px",
        "confidence-2-marker-color": "#AB988B",
        "confidence-2-marker-size": "11px",
        "confidence-2-marker-symbol": "trianglefilled",
        "confidence-2-text-color": "#918176",
        "dataStyle-0-alt-color": "#3C89E0",
        "dataStyle-0-color": "#4398F9",
        "dataStyle-0-fill-color": "#4398F9",
        "dataStyle-0-fill-pattern": "L1",
        "dataStyle-0-fill-patternColor": "#3C89E0",
        "dataStyle-0-line-color": "#3C89E0",
        "dataStyle-0-line-pattern": "1",
        "dataStyle-0-line-thickness": "2px",
        "dataStyle-0-marker-color": "#3C89E0",
        "dataStyle-0-marker-size": "11px",
        "dataStyle-0-marker-symbol": "circlefilled",
        "dataStyle-0-text-color": "#2E68AB",
        "dataStyle-1-alt-color": "#3C89E0",
        "dataStyle-1-color": "#4398F9",
        "dataStyle-1-fill-color": "#4398F9",
        "dataStyle-1-fill-pattern": "L1",
        "dataStyle-1-fill-patternColor": "#3C89E0",
        "dataStyle-1-line-color": "#3C89E0",
        "dataStyle-1-line-pattern": "1",
        "dataStyle-1-line-thickness": "2px",
        "dataStyle-1-marker-color": "#3C89E0",
        "dataStyle-1-marker-size": "11px",
        "dataStyle-1-marker-symbol": "circlefilled",
        "dataStyle-1-text-color": "#2E68AB",
        "dataStyle-10-fill-pattern": "X4",
        "dataStyle-10-line-pattern": "42",
        "dataStyle-10-line-thickness": "2px",
        "dataStyle-11-fill-pattern": "L3",
        "dataStyle-11-line-pattern": "2",
        "dataStyle-11-line-thickness": "2px",
        "dataStyle-2-alt-color": "#D97D3D",
        "dataStyle-2-color": "#F28D44",
        "dataStyle-2-fill-color": "#F28D44",
        "dataStyle-2-fill-pattern": "X1",
        "dataStyle-2-fill-patternColor": "#D97D3D",
        "dataStyle-2-line-color": "#D97D3D",
        "dataStyle-2-line-pattern": "4",
        "dataStyle-2-line-thickness": "2px",
        "dataStyle-2-marker-color": "#D97D3D",
        "dataStyle-2-marker-size": "11px",
        "dataStyle-2-marker-symbol": "squarefilled",
        "dataStyle-2-text-color": "#A35F2E",
        "dataStyle-3-alt-color": "#489C8C",
        "dataStyle-3-color": "#54B6A4",
        "dataStyle-3-fill-color": "#54B6A4",
        "dataStyle-3-fill-pattern": "R4",
        "dataStyle-3-fill-patternColor": "#489C8C",
        "dataStyle-3-line-color": "#489C8C",
        "dataStyle-3-line-pattern": "8",
        "dataStyle-3-line-thickness": "2px",
        "dataStyle-3-marker-color": "#489C8C",
        "dataStyle-3-marker-size": "11px",
        "dataStyle-3-marker-symbol": "trianglefilled",
        "dataStyle-3-text-color": "#2F665C",
        "dataStyle-4-alt-color": "#D473B8",
        "dataStyle-4-color": "#EC80CE",
        "dataStyle-4-fill-color": "#EC80CE",
        "dataStyle-4-fill-pattern": "X3",
        "dataStyle-4-fill-patternColor": "#D473B8",
        "dataStyle-4-line-color": "#D473B8",
        "dataStyle-4-line-pattern": "5",
        "dataStyle-4-line-thickness": "2px",
        "dataStyle-4-marker-color": "#D473B8",
        "dataStyle-4-marker-size": "11px",
        "dataStyle-4-marker-symbol": "diamondfilled",
        "dataStyle-4-text-color": "#9E568A",
        "dataStyle-5-alt-color": "#82A637",
        "dataStyle-5-color": "#97C03F",
        "dataStyle-5-fill-color": "#97C03F",
        "dataStyle-5-fill-pattern": "R3",
        "dataStyle-5-fill-patternColor": "#82A637",
        "dataStyle-5-line-color": "#82A637",
        "dataStyle-5-line-pattern": "14",
        "dataStyle-5-line-thickness": "2px",
        "dataStyle-5-marker-color": "#82A637",
        "dataStyle-5-marker-size": "11px",
        "dataStyle-5-marker-symbol": "starfilled",
        "dataStyle-5-text-color": "#587025",
        "dataStyle-6-alt-color": "#9364CF",
        "dataStyle-6-color": "#A570E8",
        "dataStyle-6-fill-color": "#A570E8",
        "dataStyle-6-fill-pattern": "L5",
        "dataStyle-6-fill-patternColor": "#9364CF",
        "dataStyle-6-line-color": "#9364CF",
        "dataStyle-6-line-pattern": "26",
        "dataStyle-6-line-thickness": "2px",
        "dataStyle-6-marker-color": "#9364CF",
        "dataStyle-6-marker-size": "11px",
        "dataStyle-6-marker-symbol": "triangledownfilled",
        "dataStyle-6-text-color": "#6D4A99",
        "dataStyle-7-alt-color": "#C29F16",
        "dataStyle-7-color": "#DCB519",
        "dataStyle-7-fill-color": "#DCB519",
        "dataStyle-7-fill-pattern": "R1",
        "dataStyle-7-fill-patternColor": "#C29F16",
        "dataStyle-7-line-color": "#C29F16",
        "dataStyle-7-line-pattern": "15",
        "dataStyle-7-line-thickness": "2px",
        "dataStyle-7-marker-color": "#C29F16",
        "dataStyle-7-marker-size": "11px",
        "dataStyle-7-marker-symbol": "homedownfilled",
        "dataStyle-7-text-color": "#8C7310",
        "dataStyle-8-alt-color": "#D66354",
        "dataStyle-8-color": "#F06F5E",
        "dataStyle-8-fill-color": "#F06F5E",
        "dataStyle-8-fill-pattern": "X5",
        "dataStyle-8-fill-patternColor": "#D66354",
        "dataStyle-8-line-color": "#D66354",
        "dataStyle-8-line-pattern": "20",
        "dataStyle-8-line-thickness": "2px",
        "dataStyle-8-marker-color": "#D66354",
        "dataStyle-8-marker-size": "11px",
        "dataStyle-8-text-color": "#A14A3F",
        "dataStyle-9-fill-pattern": "L4",
        "dataStyle-9-line-pattern": "41",
        "dataStyle-9-line-thickness": "2px",
        "dataStyle-ramps-0-color-end": "#F28D44",
        "dataStyle-ramps-0-color-neutral": "#F4F3F4",
        "dataStyle-ramps-0-color-start": "#4398F9",
        "dataStyle-specificUse-decrease-alt-color": "#FF1414",
        "dataStyle-specificUse-decrease-color": "#FF4747",
        "dataStyle-specificUse-decrease-fill-color": "#FF4747",
        "dataStyle-specificUse-decrease-fill-pattern": "L1",
        "dataStyle-specificUse-decrease-fill-patternColor": "#FF1414",
        "dataStyle-specificUse-decrease-line-color": "#FF1414",
        "dataStyle-specificUse-decrease-line-pattern": "1",
        "dataStyle-specificUse-decrease-line-thickness": "1px",
        "dataStyle-specificUse-decrease-marker-color": "#FF1414",
        "dataStyle-specificUse-decrease-marker-symbol": "triangledownfilled",
        "dataStyle-specificUse-decrease-text-color": "#FF1414",
        "dataStyle-specificUse-error-alt-color": "#7E7E7E",
        "dataStyle-specificUse-error-color": "#969696",
        "dataStyle-specificUse-error-fill-color": "#969696",
        "dataStyle-specificUse-error-line-color": "#7E7E7E",
        "dataStyle-specificUse-error-line-pattern": "5",
        "dataStyle-specificUse-error-line-thickness": "2px",
        "dataStyle-specificUse-error-marker-color": "#7E7E7E",
        "dataStyle-specificUse-error-marker-size": "11px",
        "dataStyle-specificUse-error-marker-symbol": "diamondfilled",
        "dataStyle-specificUse-error-text-color": "#474747",
        "dataStyle-specificUse-increase-alt-color": "#42B248",
        "dataStyle-specificUse-increase-color": "#63C568",
        "dataStyle-specificUse-increase-fill-color": "#63C568",
        "dataStyle-specificUse-increase-fill-pattern": "R2",
        "dataStyle-specificUse-increase-fill-patternColor": "#42B248",
        "dataStyle-specificUse-increase-line-color": "#42B248",
        "dataStyle-specificUse-increase-line-pattern": "1",
        "dataStyle-specificUse-increase-line-thickness": "1px",
        "dataStyle-specificUse-increase-marker-color": "#42B248",
        "dataStyle-specificUse-increase-marker-symbol": "triangleupfilled",
        "dataStyle-specificUse-increase-text-color": "#42B248",
        "dataStyle-specificUse-missing-alt-color": "#B8B8B8",
        "dataStyle-specificUse-missing-color": "#D0D0D0",
        "dataStyle-specificUse-missing-fill-color": "#D0D0D0",
        "dataStyle-specificUse-missing-fill-pattern": "R5",
        "dataStyle-specificUse-missing-fill-patternColor": "#B8B8B8",
        "dataStyle-specificUse-missing-line-color": "#B8B8B8",
        "dataStyle-specificUse-missing-line-pattern": "35",
        "dataStyle-specificUse-missing-line-thickness": "2px",
        "dataStyle-specificUse-missing-marker-color": "#B8B8B8",
        "dataStyle-specificUse-missing-marker-size": "11px",
        "dataStyle-specificUse-missing-marker-symbol": "x",
        "dataStyle-specificUse-missing-text-color": "#828282",
        "dataStyle-specificUse-other-alt-color": "#7B7B7B",
        "dataStyle-specificUse-other-color": "#898989",
        "dataStyle-specificUse-other-fill-color": "#898989",
        "dataStyle-specificUse-other-fill-pattern": "X2",
        "dataStyle-specificUse-other-fill-patternColor": "#7B7B7B",
        "dataStyle-specificUse-other-line-color": "#7B7B7B",
        "dataStyle-specificUse-other-line-pattern": "34",
        "dataStyle-specificUse-other-line-thickness": "2px",
        "dataStyle-specificUse-other-marker-color": "#7B7B7B",
        "dataStyle-specificUse-other-marker-size": "11px",
        "dataStyle-specificUse-other-marker-symbol": "asterisk",
        "dataStyle-specificUse-other-text-color": "#3B3B3B",
        "dataStyle-specificUse-overflow-alt-color": "#A073DB",
        "dataStyle-specificUse-overflow-color": "#B381f5",
        "dataStyle-specificUse-overflow-fill-color": "#B381f5",
        "dataStyle-specificUse-overflow-fill-pattern": "R2",
        "dataStyle-specificUse-overflow-fill-patternColor": "#A073DB",
        "dataStyle-specificUse-overflow-line-color": "#A073DB",
        "dataStyle-specificUse-overflow-line-pattern": "1",
        "dataStyle-specificUse-overflow-line-thickness": "2px",
        "dataStyle-specificUse-overflow-marker-color": "#A073DB",
        "dataStyle-specificUse-overflow-marker-size": "11px",
        "dataStyle-specificUse-overflow-marker-symbol": "triangleupfilled",
        "dataStyle-specificUse-overflow-text-color": "#7957A6",
        "dataStyle-specificUse-underflow-alt-color": "#64C9C1",
        "dataStyle-specificUse-underflow-color": "#71E4DA",
        "dataStyle-specificUse-underflow-fill-color": "#71E4DA",
        "dataStyle-specificUse-underflow-fill-pattern": "L2",
        "dataStyle-specificUse-underflow-fill-patternColor": "#64C9C1",
        "dataStyle-specificUse-underflow-line-color": "#64C9C1",
        "dataStyle-specificUse-underflow-line-pattern": "1",
        "dataStyle-specificUse-underflow-line-thickness": "2px",
        "dataStyle-specificUse-underflow-marker-color": "#64C9C1",
        "dataStyle-specificUse-underflow-marker-size": "11px",
        "dataStyle-specificUse-underflow-marker-symbol": "triangledownfilled",
        "dataStyle-specificUse-underflow-text-color": "#49948D",
        "dataTip-fill-color": "hsl(219, 0%, 100%)",
        "dataTip-text-color": "hsl(219, 12%, 12%)",
        "dataTip-transparency": "0",
        "elementMeasurement-line-thickness": "2px",
        "elementMeasurement-marker-size": "11px",
        "elementMeasurement-thinLine-line-color": "#3C89E0",
        "elementMeasurement-thinLine-line-pattern": "1",
        "elementMeasurement-thinLine-line-thickness": "1px",
        "fit-1-alt-color": "#547294",
        "fit-1-color": "#749DCC",
        "fit-1-fill-color": "#749DCC",
        "fit-1-fill-pattern": "E",
        "fit-1-fill-patternColor": "#547294",
        "fit-1-line-color": "#547294",
        "fit-1-line-pattern": "4",
        "fit-1-line-thickness": "2px",
        "fit-1-marker-color": "#547294",
        "fit-1-marker-size": "11px",
        "fit-1-marker-symbol": "squarefilled",
        "fit-1-text-color": "#455E7A",
        "fit-2-alt-color": "#8C6951",
        "fit-2-color": "#C49372",
        "fit-2-fill-color": "#749DCC",
        "fit-2-fill-pattern": "E",
        "fit-2-fill-patternColor": "#8C6951",
        "fit-2-line-color": "#8C6951",
        "fit-2-line-pattern": "8",
        "fit-2-line-thickness": "2px",
        "fit-2-marker-color": "#8C6951",
        "fit-2-marker-size": "11px",
        "fit-2-marker-symbol": "trianglefilled",
        "fit-2-text-color": "#735642",
        "geospatial-area-fill-color": "hsl(219, 0%, 100%)",
        "geospatial-area-fill-transparency": "0.8",
        "geospatial-area-focus-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-focus-line-pattern": "34",
        "geospatial-area-focus-line-thickness": "1px",
        "geospatial-area-focus-line-transparency": "0",
        "geospatial-area-focusPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-focusPerimeter-line-pattern": "solid",
        "geospatial-area-focusPerimeter-line-thickness": "0",
        "geospatial-area-focusPerimeter-line-transparency": "1",
        "geospatial-area-innerPerimeter-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-innerPerimeter-line-pattern": "1",
        "geospatial-area-innerPerimeter-line-thickness": "0",
        "geospatial-area-innerPerimeter-line-transparency": "1",
        "geospatial-area-innerPerimeterThick-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-innerPerimeterThick-line-pattern": "1",
        "geospatial-area-innerPerimeterThick-line-thickness": "0",
        "geospatial-area-innerPerimeterThick-line-transparency": "1",
        "geospatial-area-line-color": "hsl(219, 12%, 8%)",
        "geospatial-area-line-pattern": "1",
        "geospatial-area-line-thickness": "1px",
        "geospatial-area-line-transparency": "0",
        "geospatial-area-outerHover-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-outerHover-line-pattern": "1",
        "geospatial-area-outerHover-line-thickness": "3px",
        "geospatial-area-outerHover-line-transparency": "0.4",
        "geospatial-area-outerPerimeter-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-outerPerimeter-line-pattern": "1",
        "geospatial-area-outerPerimeter-line-thickness": "1px",
        "geospatial-area-outerPerimeter-line-transparency": "0.6",
        "geospatial-area-outerPerimeterInverse-line-color": "hsl(219, 0%, 0%)",
        "geospatial-area-outerPerimeterInverse-line-pattern": "1",
        "geospatial-area-outerPerimeterInverse-line-thickness": "1px",
        "geospatial-area-outerPerimeterInverse-line-transparency": "0.85",
        "geospatial-area-outerSelection-line-color": "hsl(219, 0%, 100%)",
        "geospatial-area-outerSelection-line-pattern": "1",
        "geospatial-area-outerSelection-line-thickness": "3px",
        "geospatial-area-outerSelection-line-transparency": "0",
        "geospatial-area-selection-line-color": "hsl(219, 12%, 8%)",
        "geospatial-area-selection-line-pattern": "2",
        "geospatial-area-selection-line-thickness": "2px",
        "geospatial-area-selection-line-transparency": "0",
        "geospatial-basemap-tileset": "Light",
        "geospatial-overlayData-inset-aspectRatio": "1",
        "geospatial-overlayData-inset-size-default": "60px",
        "geospatial-overlayData-inset-size-max": "100px",
        "geospatial-overlayData-inset-size-min": "30px",
        "geospatial-pie-inset-aspectRatio": "1",
        "geospatial-pie-inset-otherSlicePercent": "10",
        "geospatial-pie-inset-ring-size": "0.4",
        "geospatial-pie-inset-size-default": "60px",
        "geospatial-pie-inset-size-max": "100px",
        "geospatial-pie-inset-size-min": "30px",
        "geospatial-pie-outlinesPerimeter-line-color": "hsl(219, 12%, 42%)",
        "geospatial-pie-outlinesPerimeter-line-pattern": "1",
        "geospatial-pie-outlinesPerimeter-line-thickness": "1px",
        "geospatial-pie-outlinesPerimeter-line-transparency": "0",
        "geospatial-pin-color": "hsl(219, 12%, 8%)",
        "geospatial-pin-icon-text-color": "hsl(219, 0%, 100%)",
        "geospatial-pin-icon-text-fontFamily": "sas-icons",
        "geospatial-pin-icon-text-fontSize": "11.85pt",
        "geospatial-pin-icon-text-fontStyle": "normal",
        "geospatial-pin-icon-text-fontWeight": "400",
        "geospatial-pin-label-text-color": "hsl(219, 0%, 100%)",
        "geospatial-pin-label-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "geospatial-pin-label-text-fontSize": "10.5pt",
        "geospatial-pin-label-text-fontStyle": "normal",
        "geospatial-pin-label-text-fontWeight": "700",
        "geospatial-pin-search-color": "hsl(219, 12%, 42%)",
        "geospatial-pin-search-style": "light",
        "geospatial-pin-style": "light",
        "geospatial-region-empty-fill-color": "hsl(219, 0%, 100%)",
        "geospatial-region-empty-fill-pattern": "E",
        "geospatial-region-empty-fill-transparency": "0",
        "geospatial-region-empty-line-color": "#D0D0D0",
        "geospatial-region-empty-line-pattern": "1",
        "geospatial-region-empty-line-thickness": "2px",
        "geospatial-region-empty-line-transparency": "0",
        "geospatial-route-centerPath-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-centerPath-line-pattern": "1",
        "geospatial-route-centerPath-line-thickness": "2px",
        "geospatial-route-centerPath-line-transparency": "0",
        "geospatial-route-centroidPoint-pin-color": "hsl(219, 12%, 8%)",
        "geospatial-route-centroidPoint-pin-style": "light",
        "geospatial-route-mainPath-line-color": "hsl(219, 12%, 8%)",
        "geospatial-route-mainPath-line-pattern": "1",
        "geospatial-route-mainPath-line-thickness": "8px",
        "geospatial-route-mainPath-line-transparency": "0",
        "geospatial-route-pathFocus-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-pathFocus-line-pattern": "34",
        "geospatial-route-pathFocus-line-thickness": "1px",
        "geospatial-route-pathFocus-line-transparency": "0",
        "geospatial-route-pathFocusPerimeter-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-pathFocusPerimeter-line-pattern": "solid",
        "geospatial-route-pathFocusPerimeter-line-thickness": "0",
        "geospatial-route-pathFocusPerimeter-line-transparency": "1",
        "geospatial-route-pathHover-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-pathHover-line-pattern": "1",
        "geospatial-route-pathHover-line-thickness": "3px",
        "geospatial-route-pathHover-line-transparency": "0.4",
        "geospatial-route-pathInnerPerimeter-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-pathInnerPerimeter-line-pattern": "1",
        "geospatial-route-pathInnerPerimeter-line-thickness": "0",
        "geospatial-route-pathInnerPerimeter-line-transparency": "1",
        "geospatial-route-pathOuterPerimeter-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-pathOuterPerimeter-line-pattern": "1",
        "geospatial-route-pathOuterPerimeter-line-thickness": "1px",
        "geospatial-route-pathOuterPerimeter-line-transparency": "0.6",
        "geospatial-route-pathOuterPerimeterInverse-line-color": "hsl(219, 0%, 0%)",
        "geospatial-route-pathOuterPerimeterInverse-line-pattern": "1",
        "geospatial-route-pathOuterPerimeterInverse-line-thickness": "1px",
        "geospatial-route-pathOuterPerimeterInverse-line-transparency": "0.85",
        "geospatial-route-pathSelection-line-color": "hsl(219, 0%, 100%)",
        "geospatial-route-pathSelection-line-pattern": "1",
        "geospatial-route-pathSelection-line-thickness": "3px",
        "geospatial-route-pathSelection-line-transparency": "0",
        "geospatial-route-point-pin-color": "hsl(219, 12%, 8%)",
        "geospatial-route-point-pin-style": "light",
        "geospatial-route-point-text-color": "hsl(219, 12%, 8%)",
        "geospatial-route-point-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "geospatial-route-point-text-fontSize": "7.35pt",
        "geospatial-route-point-text-fontStyle": "normal",
        "geospatial-route-point-text-fontWeight": "700",
        "graphAppThemeTokens-brand-color-alert": "hsl(0, 100%, 40%)",
        "graphAppThemeTokens-brand-color-alert-00": "hsl(0, 0%, 100%)",
        "graphAppThemeTokens-brand-color-alert-10": "hsl(0, 100%, 98%)",
        "graphAppThemeTokens-brand-color-alert-100": "hsl(0, 100%, 64%)",
        "graphAppThemeTokens-brand-color-alert-1000": "hsl(0, 0%, 0%)",
        "graphAppThemeTokens-brand-color-alert-20": "hsl(0, 100%, 95%)",
        "graphAppThemeTokens-brand-color-alert-200": "hsl(0, 100%, 59%)",
        "graphAppThemeTokens-brand-color-alert-30": "hsl(0, 100%, 92%)",
        "graphAppThemeTokens-brand-color-alert-300": "hsl(0, 100%, 54%)",
        "graphAppThemeTokens-brand-color-alert-40": "hsl(0, 100%, 88%)",
        "graphAppThemeTokens-brand-color-alert-400": "hsl(0, 100%, 46%)",
        "graphAppThemeTokens-brand-color-alert-450": "hsl(0, 100%, 40%)",
        "graphAppThemeTokens-brand-color-alert-50": "hsl(0, 100%, 84%)",
        "graphAppThemeTokens-brand-color-alert-500": "hsl(0, 100%, 36%)",
        "graphAppThemeTokens-brand-color-alert-550": "hsl(0, 100%, 33%)",
        "graphAppThemeTokens-brand-color-alert-60": "hsl(0, 100%, 79%)",
        "graphAppThemeTokens-brand-color-alert-600": "hsl(0, 100%, 30%)",
        "graphAppThemeTokens-brand-color-alert-650": "hsl(0, 100%, 27%)",
        "graphAppThemeTokens-brand-color-alert-70": "hsl(0, 100%, 76%)",
        "graphAppThemeTokens-brand-color-alert-700": "hsl(0, 100%, 22%)",
        "graphAppThemeTokens-brand-color-alert-750": "hsl(0, 100%, 17%)",
        "graphAppThemeTokens-brand-color-alert-80": "hsl(0, 100%, 72%)",
        "graphAppThemeTokens-brand-color-alert-800": "hsl(0, 100%, 12%)",
        "graphAppThemeTokens-brand-color-alert-850": "hsl(0, 100%, 8%)",
        "graphAppThemeTokens-brand-color-alert-90": "hsl(0, 100%, 68%)",
        "graphAppThemeTokens-brand-color-alert-900": "hsl(0, 100%, 3%)",
        "graphAppThemeTokens-brand-color-blue": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-blue-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-brand-color-blue-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-brand-color-blue-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-brand-color-blue-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-brand-color-blue-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-brand-color-blue-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-brand-color-blue-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-brand-color-blue-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-brand-color-blue-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-brand-color-blue-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-brand-color-blue-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-blue-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-brand-color-blue-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-brand-color-blue-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-brand-color-blue-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-brand-color-blue-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-brand-color-blue-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-brand-color-blue-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-brand-color-blue-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-brand-color-blue-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-brand-color-blue-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-brand-color-blue-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-brand-color-blue-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-brand-color-blue-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-brand-color-blue-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-brand-color-cranberry": "hsl(329, 60%, 40%)",
        "graphAppThemeTokens-brand-color-cranberry-00": "hsl(329,60%,100%)",
        "graphAppThemeTokens-brand-color-cranberry-10": "hsl(329,60%,98%)",
        "graphAppThemeTokens-brand-color-cranberry-100": "hsl(329,60%,62%)",
        "graphAppThemeTokens-brand-color-cranberry-1000": "hsl(329,60%,0%)",
        "graphAppThemeTokens-brand-color-cranberry-20": "hsl(329,60%,97%)",
        "graphAppThemeTokens-brand-color-cranberry-200": "hsl(329,60%,57%)",
        "graphAppThemeTokens-brand-color-cranberry-30": "hsl(329,60%,92%)",
        "graphAppThemeTokens-brand-color-cranberry-300": "hsl(329,60%,55%)",
        "graphAppThemeTokens-brand-color-cranberry-40": "hsl(329,60%,88%)",
        "graphAppThemeTokens-brand-color-cranberry-400": "hsl(329,60%,52%)",
        "graphAppThemeTokens-brand-color-cranberry-450": "hsl(329,60%,40%)",
        "graphAppThemeTokens-brand-color-cranberry-50": "hsl(329,60%,84%)",
        "graphAppThemeTokens-brand-color-cranberry-500": "hsl(329,60%,37%)",
        "graphAppThemeTokens-brand-color-cranberry-550": "hsl(329,60%,32%)",
        "graphAppThemeTokens-brand-color-cranberry-60": "hsl(329,60%,78%)",
        "graphAppThemeTokens-brand-color-cranberry-600": "hsl(329,60%,30%)",
        "graphAppThemeTokens-brand-color-cranberry-650": "hsl(329,60%,27%)",
        "graphAppThemeTokens-brand-color-cranberry-70": "hsl(329,60%,76%)",
        "graphAppThemeTokens-brand-color-cranberry-700": "hsl(329,60%,22%)",
        "graphAppThemeTokens-brand-color-cranberry-750": "hsl(329,60%,16%)",
        "graphAppThemeTokens-brand-color-cranberry-80": "hsl(329,60%,72%)",
        "graphAppThemeTokens-brand-color-cranberry-800": "hsl(329,60%,11%)",
        "graphAppThemeTokens-brand-color-cranberry-850": "hsl(329,60%,9%)",
        "graphAppThemeTokens-brand-color-cranberry-90": "hsl(329,60%,68%)",
        "graphAppThemeTokens-brand-color-cranberry-900": "hsl(329,60%,4%)",
        "graphAppThemeTokens-brand-color-grey": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-brand-color-grey-00": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-brand-color-grey-10": "hsl(219, 12%, 98%)",
        "graphAppThemeTokens-brand-color-grey-100": "hsl(219, 12%, 64%)",
        "graphAppThemeTokens-brand-color-grey-1000": "hsl(219, 0%, 0%)",
        "graphAppThemeTokens-brand-color-grey-20": "hsl(219, 12%, 96%)",
        "graphAppThemeTokens-brand-color-grey-200": "hsl(219, 12%, 59%)",
        "graphAppThemeTokens-brand-color-grey-30": "hsl(219, 12%, 92%)",
        "graphAppThemeTokens-brand-color-grey-300": "hsl(219, 12%, 55%)",
        "graphAppThemeTokens-brand-color-grey-40": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-brand-color-grey-400": "hsl(219, 12%, 48%)",
        "graphAppThemeTokens-brand-color-grey-450": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-brand-color-grey-50": "hsl(219, 12%, 84%)",
        "graphAppThemeTokens-brand-color-grey-500": "hsl(219, 12%, 36%)",
        "graphAppThemeTokens-brand-color-grey-550": "hsl(219, 12%, 33%)",
        "graphAppThemeTokens-brand-color-grey-60": "hsl(219, 12%, 79%)",
        "graphAppThemeTokens-brand-color-grey-600": "hsl(219, 12%, 30%)",
        "graphAppThemeTokens-brand-color-grey-650": "hsl(219, 12%, 27%)",
        "graphAppThemeTokens-brand-color-grey-70": "hsl(219, 12%, 76%)",
        "graphAppThemeTokens-brand-color-grey-700": "hsl(219, 12%, 22%)",
        "graphAppThemeTokens-brand-color-grey-750": "hsl(219, 12%, 17%)",
        "graphAppThemeTokens-brand-color-grey-80": "hsl(219, 12%, 72%)",
        "graphAppThemeTokens-brand-color-grey-800": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-brand-color-grey-850": "hsl(219, 12%, 8%)",
        "graphAppThemeTokens-brand-color-grey-90": "hsl(219, 12%, 68%)",
        "graphAppThemeTokens-brand-color-grey-900": "hsl(219, 12%, 3%)",
        "graphAppThemeTokens-brand-color-info": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-info-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-brand-color-info-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-brand-color-info-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-brand-color-info-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-brand-color-info-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-brand-color-info-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-brand-color-info-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-brand-color-info-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-brand-color-info-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-brand-color-info-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-brand-color-info-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-brand-color-info-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-brand-color-info-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-brand-color-info-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-brand-color-info-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-brand-color-info-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-brand-color-info-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-brand-color-info-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-brand-color-info-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-brand-color-info-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-brand-color-info-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-brand-color-info-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-brand-color-info-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-brand-color-info-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-brand-color-info-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-brand-color-success": "hsl(123, 46%, 43%)",
        "graphAppThemeTokens-brand-color-success-00": "hsl(123, 0%, 100%)",
        "graphAppThemeTokens-brand-color-success-10": "hsl(123, 46%, 98%)",
        "graphAppThemeTokens-brand-color-success-100": "hsl(123, 46%, 63%)",
        "graphAppThemeTokens-brand-color-success-1000": "hsl(123, 0%, 0%)",
        "graphAppThemeTokens-brand-color-success-20": "hsl(123, 46%, 95%)",
        "graphAppThemeTokens-brand-color-success-200": "hsl(123, 46%, 58%)",
        "graphAppThemeTokens-brand-color-success-30": "hsl(123, 46%, 90%)",
        "graphAppThemeTokens-brand-color-success-300": "hsl(123, 46%, 55%)",
        "graphAppThemeTokens-brand-color-success-40": "hsl(123, 46%, 87%)",
        "graphAppThemeTokens-brand-color-success-400": "hsl(123, 46%, 48%)",
        "graphAppThemeTokens-brand-color-success-450": "hsl(123, 46%, 43%)",
        "graphAppThemeTokens-brand-color-success-50": "hsl(123, 46%, 82%)",
        "graphAppThemeTokens-brand-color-success-500": "hsl(123, 46%, 36%)",
        "graphAppThemeTokens-brand-color-success-550": "hsl(123, 46%, 34%)",
        "graphAppThemeTokens-brand-color-success-60": "hsl(123, 46%, 78%)",
        "graphAppThemeTokens-brand-color-success-600": "hsl(123, 46%, 30%)",
        "graphAppThemeTokens-brand-color-success-650": "hsl(123, 46%, 25%)",
        "graphAppThemeTokens-brand-color-success-70": "hsl(123, 46%, 75%)",
        "graphAppThemeTokens-brand-color-success-700": "hsl(123, 46%, 22%)",
        "graphAppThemeTokens-brand-color-success-750": "hsl(123, 46%, 17%)",
        "graphAppThemeTokens-brand-color-success-80": "hsl(123, 46%, 70%)",
        "graphAppThemeTokens-brand-color-success-800": "hsl(123, 46%, 12%)",
        "graphAppThemeTokens-brand-color-success-850": "hsl(123, 46%, 8%)",
        "graphAppThemeTokens-brand-color-success-90": "hsl(123, 46%, 66%)",
        "graphAppThemeTokens-brand-color-success-900": "hsl(123, 46%, 3%)",
        "graphAppThemeTokens-brand-color-warning": "hsl(43, 89%, 44%)",
        "graphAppThemeTokens-brand-color-warning-00": "hsl(43, 0%, 100%)",
        "graphAppThemeTokens-brand-color-warning-10": "hsl(43, 89%, 98%)",
        "graphAppThemeTokens-brand-color-warning-100": "hsl(43, 89%, 64%)",
        "graphAppThemeTokens-brand-color-warning-1000": "hsl(43, 0%, 0%)",
        "graphAppThemeTokens-brand-color-warning-20": "hsl(43, 89%, 95%)",
        "graphAppThemeTokens-brand-color-warning-200": "hsl(43, 89%, 60%)",
        "graphAppThemeTokens-brand-color-warning-30": "hsl(43, 89%, 92%)",
        "graphAppThemeTokens-brand-color-warning-300": "hsl(43, 89%, 56%)",
        "graphAppThemeTokens-brand-color-warning-40": "hsl(43, 89%, 88%)",
        "graphAppThemeTokens-brand-color-warning-400": "hsl(43, 89%, 52%)",
        "graphAppThemeTokens-brand-color-warning-450": "hsl(43, 89%, 44%)",
        "graphAppThemeTokens-brand-color-warning-50": "hsl(43, 89%, 84%)",
        "graphAppThemeTokens-brand-color-warning-500": "hsl(43, 89%, 39%)",
        "graphAppThemeTokens-brand-color-warning-550": "hsl(43, 89%, 35%)",
        "graphAppThemeTokens-brand-color-warning-60": "hsl(43, 89%, 79%)",
        "graphAppThemeTokens-brand-color-warning-600": "hsl(43, 89%, 31%)",
        "graphAppThemeTokens-brand-color-warning-650": "hsl(43, 89%, 27%)",
        "graphAppThemeTokens-brand-color-warning-70": "hsl(43, 89%, 76%)",
        "graphAppThemeTokens-brand-color-warning-700": "hsl(43, 89%, 24%)",
        "graphAppThemeTokens-brand-color-warning-750": "hsl(43, 89%, 17%)",
        "graphAppThemeTokens-brand-color-warning-80": "hsl(43, 89%, 72%)",
        "graphAppThemeTokens-brand-color-warning-800": "hsl(43, 89%, 12%)",
        "graphAppThemeTokens-brand-color-warning-850": "hsl(43, 89%, 8%)",
        "graphAppThemeTokens-brand-color-warning-90": "hsl(43, 89%, 68%)",
        "graphAppThemeTokens-brand-color-warning-900": "hsl(43, 89%, 3%)",
        "graphAppThemeTokens-color-action-background-subtle-selected": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-color-action-text-subtle-selected": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-color-alert-00": "hsl(0, 0%, 100%)",
        "graphAppThemeTokens-color-alert-10": "hsl(0, 100%, 98%)",
        "graphAppThemeTokens-color-alert-100": "hsl(0, 100%, 64%)",
        "graphAppThemeTokens-color-alert-1000": "hsl(0, 0%, 0%)",
        "graphAppThemeTokens-color-alert-20": "hsl(0, 100%, 95%)",
        "graphAppThemeTokens-color-alert-200": "hsl(0, 100%, 59%)",
        "graphAppThemeTokens-color-alert-30": "hsl(0, 100%, 92%)",
        "graphAppThemeTokens-color-alert-300": "hsl(0, 100%, 54%)",
        "graphAppThemeTokens-color-alert-40": "hsl(0, 100%, 88%)",
        "graphAppThemeTokens-color-alert-400": "hsl(0, 100%, 46%)",
        "graphAppThemeTokens-color-alert-450": "hsl(0, 100%, 40%)",
        "graphAppThemeTokens-color-alert-50": "hsl(0, 100%, 84%)",
        "graphAppThemeTokens-color-alert-500": "hsl(0, 100%, 36%)",
        "graphAppThemeTokens-color-alert-550": "hsl(0, 100%, 33%)",
        "graphAppThemeTokens-color-alert-60": "hsl(0, 100%, 79%)",
        "graphAppThemeTokens-color-alert-600": "hsl(0, 100%, 30%)",
        "graphAppThemeTokens-color-alert-650": "hsl(0, 100%, 27%)",
        "graphAppThemeTokens-color-alert-70": "hsl(0, 100%, 76%)",
        "graphAppThemeTokens-color-alert-700": "hsl(0, 100%, 22%)",
        "graphAppThemeTokens-color-alert-750": "hsl(0, 100%, 17%)",
        "graphAppThemeTokens-color-alert-80": "hsl(0, 100%, 72%)",
        "graphAppThemeTokens-color-alert-800": "hsl(0, 100%, 12%)",
        "graphAppThemeTokens-color-alert-850": "hsl(0, 100%, 8%)",
        "graphAppThemeTokens-color-alert-90": "hsl(0, 100%, 68%)",
        "graphAppThemeTokens-color-alert-900": "hsl(0, 100%, 3%)",
        "graphAppThemeTokens-color-body-text": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-color-container-background-0": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-color-container-background-1": "hsl(219, 12%, 98%)",
        "graphAppThemeTokens-color-container-background-2": "hsl(219, 12%, 96%)",
        "graphAppThemeTokens-color-container-background-3": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-container-border-4": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-color-heading-text": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-color-info-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-color-info-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-color-info-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-color-info-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-color-info-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-color-info-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-color-info-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-color-info-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-color-info-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-color-info-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-color-info-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-info-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-color-info-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-color-info-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-color-info-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-color-info-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-color-info-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-color-info-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-color-info-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-color-info-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-color-info-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-color-info-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-color-info-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-color-info-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-color-info-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-color-neutral": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-color-neutral-00": "hsl(219, 0%, 100%)",
        "graphAppThemeTokens-color-neutral-10": "hsl(219, 12%, 98%)",
        "graphAppThemeTokens-color-neutral-100": "hsl(219, 12%, 64%)",
        "graphAppThemeTokens-color-neutral-1000": "hsl(219, 0%, 0%)",
        "graphAppThemeTokens-color-neutral-20": "hsl(219, 12%, 96%)",
        "graphAppThemeTokens-color-neutral-200": "hsl(219, 12%, 59%)",
        "graphAppThemeTokens-color-neutral-30": "hsl(219, 12%, 92%)",
        "graphAppThemeTokens-color-neutral-300": "hsl(219, 12%, 55%)",
        "graphAppThemeTokens-color-neutral-40": "hsl(219, 12%, 88%)",
        "graphAppThemeTokens-color-neutral-400": "hsl(219, 12%, 48%)",
        "graphAppThemeTokens-color-neutral-450": "hsl(219, 12%, 42%)",
        "graphAppThemeTokens-color-neutral-50": "hsl(219, 12%, 84%)",
        "graphAppThemeTokens-color-neutral-500": "hsl(219, 12%, 36%)",
        "graphAppThemeTokens-color-neutral-550": "hsl(219, 12%, 33%)",
        "graphAppThemeTokens-color-neutral-60": "hsl(219, 12%, 79%)",
        "graphAppThemeTokens-color-neutral-600": "hsl(219, 12%, 30%)",
        "graphAppThemeTokens-color-neutral-650": "hsl(219, 12%, 27%)",
        "graphAppThemeTokens-color-neutral-70": "hsl(219, 12%, 76%)",
        "graphAppThemeTokens-color-neutral-700": "hsl(219, 12%, 22%)",
        "graphAppThemeTokens-color-neutral-750": "hsl(219, 12%, 17%)",
        "graphAppThemeTokens-color-neutral-80": "hsl(219, 12%, 72%)",
        "graphAppThemeTokens-color-neutral-800": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-color-neutral-850": "hsl(219, 12%, 8%)",
        "graphAppThemeTokens-color-neutral-90": "hsl(219, 12%, 68%)",
        "graphAppThemeTokens-color-neutral-900": "hsl(219, 12%, 3%)",
        "graphAppThemeTokens-color-primary": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-primary-00": "hsl(212, 0%, 100%)",
        "graphAppThemeTokens-color-primary-10": "hsl(212, 94%, 97%)",
        "graphAppThemeTokens-color-primary-100": "hsl(212, 94%, 62%)",
        "graphAppThemeTokens-color-primary-1000": "hsl(212, 0%, 0%)",
        "graphAppThemeTokens-color-primary-20": "hsl(212, 94%, 94%)",
        "graphAppThemeTokens-color-primary-200": "hsl(212, 94%, 57%)",
        "graphAppThemeTokens-color-primary-30": "hsl(212, 94%, 90%)",
        "graphAppThemeTokens-color-primary-300": "hsl(212, 94%, 53%)",
        "graphAppThemeTokens-color-primary-40": "hsl(212, 94%, 88%)",
        "graphAppThemeTokens-color-primary-400": "hsl(212, 94%, 47%)",
        "graphAppThemeTokens-color-primary-450": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-primary-50": "hsl(212, 94%, 83%)",
        "graphAppThemeTokens-color-primary-500": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-color-primary-550": "hsl(212, 94%, 35%)",
        "graphAppThemeTokens-color-primary-60": "hsl(212, 94%, 78%)",
        "graphAppThemeTokens-color-primary-600": "hsl(212, 94%, 31%)",
        "graphAppThemeTokens-color-primary-650": "hsl(212, 94%, 27%)",
        "graphAppThemeTokens-color-primary-70": "hsl(212, 94%, 76%)",
        "graphAppThemeTokens-color-primary-700": "hsl(212, 94%, 23%)",
        "graphAppThemeTokens-color-primary-750": "hsl(212, 94%, 17%)",
        "graphAppThemeTokens-color-primary-80": "hsl(212, 94%, 72%)",
        "graphAppThemeTokens-color-primary-800": "hsl(212, 94%, 12%)",
        "graphAppThemeTokens-color-primary-850": "hsl(212, 94%, 8%)",
        "graphAppThemeTokens-color-primary-90": "hsl(212, 94%, 68%)",
        "graphAppThemeTokens-color-primary-900": "hsl(212, 94%, 3%)",
        "graphAppThemeTokens-color-secondary": "hsl(329,60%,30%)",
        "graphAppThemeTokens-color-secondary-00": "hsl(329,60%,100%)",
        "graphAppThemeTokens-color-secondary-10": "hsl(329,60%,98%)",
        "graphAppThemeTokens-color-secondary-100": "hsl(329,60%,62%)",
        "graphAppThemeTokens-color-secondary-1000": "hsl(329,60%,0%)",
        "graphAppThemeTokens-color-secondary-20": "hsl(329,60%,97%)",
        "graphAppThemeTokens-color-secondary-200": "hsl(329,60%,57%)",
        "graphAppThemeTokens-color-secondary-30": "hsl(329,60%,92%)",
        "graphAppThemeTokens-color-secondary-300": "hsl(329,60%,55%)",
        "graphAppThemeTokens-color-secondary-40": "hsl(329,60%,88%)",
        "graphAppThemeTokens-color-secondary-400": "hsl(329,60%,52%)",
        "graphAppThemeTokens-color-secondary-450": "hsl(329,60%,40%)",
        "graphAppThemeTokens-color-secondary-50": "hsl(329,60%,84%)",
        "graphAppThemeTokens-color-secondary-500": "hsl(329,60%,37%)",
        "graphAppThemeTokens-color-secondary-550": "hsl(329,60%,32%)",
        "graphAppThemeTokens-color-secondary-60": "hsl(329,60%,78%)",
        "graphAppThemeTokens-color-secondary-600": "hsl(329,60%,30%)",
        "graphAppThemeTokens-color-secondary-650": "hsl(329,60%,27%)",
        "graphAppThemeTokens-color-secondary-70": "hsl(329,60%,76%)",
        "graphAppThemeTokens-color-secondary-700": "hsl(329,60%,22%)",
        "graphAppThemeTokens-color-secondary-750": "hsl(329,60%,16%)",
        "graphAppThemeTokens-color-secondary-80": "hsl(329,60%,72%)",
        "graphAppThemeTokens-color-secondary-800": "hsl(329,60%,11%)",
        "graphAppThemeTokens-color-secondary-850": "hsl(329,60%,9%)",
        "graphAppThemeTokens-color-secondary-90": "hsl(329,60%,68%)",
        "graphAppThemeTokens-color-secondary-900": "hsl(329,60%,4%)",
        "graphAppThemeTokens-color-status-icon-alert": "hsl(0, 100%, 36%)",
        "graphAppThemeTokens-color-status-icon-info": "hsl(212, 94%, 36%)",
        "graphAppThemeTokens-color-status-icon-neutral": "hsl(219, 12%, 48%)",
        "graphAppThemeTokens-color-status-icon-success": "hsl(123, 46%, 36%)",
        "graphAppThemeTokens-color-status-icon-warning": "hsl(43, 89%, 39%)",
        "graphAppThemeTokens-color-success-00": "hsl(123, 0%, 100%)",
        "graphAppThemeTokens-color-success-10": "hsl(123, 46%, 98%)",
        "graphAppThemeTokens-color-success-100": "hsl(123, 46%, 63%)",
        "graphAppThemeTokens-color-success-1000": "hsl(123, 0%, 0%)",
        "graphAppThemeTokens-color-success-20": "hsl(123, 46%, 95%)",
        "graphAppThemeTokens-color-success-200": "hsl(123, 46%, 58%)",
        "graphAppThemeTokens-color-success-30": "hsl(123, 46%, 90%)",
        "graphAppThemeTokens-color-success-300": "hsl(123, 46%, 55%)",
        "graphAppThemeTokens-color-success-40": "hsl(123, 46%, 87%)",
        "graphAppThemeTokens-color-success-400": "hsl(123, 46%, 48%)",
        "graphAppThemeTokens-color-success-450": "hsl(123, 46%, 43%)",
        "graphAppThemeTokens-color-success-50": "hsl(123, 46%, 82%)",
        "graphAppThemeTokens-color-success-500": "hsl(123, 46%, 36%)",
        "graphAppThemeTokens-color-success-550": "hsl(123, 46%, 34%)",
        "graphAppThemeTokens-color-success-60": "hsl(123, 46%, 78%)",
        "graphAppThemeTokens-color-success-600": "hsl(123, 46%, 30%)",
        "graphAppThemeTokens-color-success-650": "hsl(123, 46%, 25%)",
        "graphAppThemeTokens-color-success-70": "hsl(123, 46%, 75%)",
        "graphAppThemeTokens-color-success-700": "hsl(123, 46%, 22%)",
        "graphAppThemeTokens-color-success-750": "hsl(123, 46%, 17%)",
        "graphAppThemeTokens-color-success-80": "hsl(123, 46%, 70%)",
        "graphAppThemeTokens-color-success-800": "hsl(123, 46%, 12%)",
        "graphAppThemeTokens-color-success-850": "hsl(123, 46%, 8%)",
        "graphAppThemeTokens-color-success-90": "hsl(123, 46%, 66%)",
        "graphAppThemeTokens-color-success-900": "hsl(123, 46%, 3%)",
        "graphAppThemeTokens-color-text-neutral": "hsl(219, 12%, 12%)",
        "graphAppThemeTokens-color-text-primary": "hsl(212, 94%, 42%)",
        "graphAppThemeTokens-color-warning-00": "hsl(43, 0%, 100%)",
        "graphAppThemeTokens-color-warning-10": "hsl(43, 89%, 98%)",
        "graphAppThemeTokens-color-warning-100": "hsl(43, 89%, 64%)",
        "graphAppThemeTokens-color-warning-1000": "hsl(43, 0%, 0%)",
        "graphAppThemeTokens-color-warning-20": "hsl(43, 89%, 95%)",
        "graphAppThemeTokens-color-warning-200": "hsl(43, 89%, 60%)",
        "graphAppThemeTokens-color-warning-30": "hsl(43, 89%, 92%)",
        "graphAppThemeTokens-color-warning-300": "hsl(43, 89%, 56%)",
        "graphAppThemeTokens-color-warning-40": "hsl(43, 89%, 88%)",
        "graphAppThemeTokens-color-warning-400": "hsl(43, 89%, 52%)",
        "graphAppThemeTokens-color-warning-450": "hsl(43, 89%, 44%)",
        "graphAppThemeTokens-color-warning-50": "hsl(43, 89%, 84%)",
        "graphAppThemeTokens-color-warning-500": "hsl(43, 89%, 39%)",
        "graphAppThemeTokens-color-warning-550": "hsl(43, 89%, 35%)",
        "graphAppThemeTokens-color-warning-60": "hsl(43, 89%, 79%)",
        "graphAppThemeTokens-color-warning-600": "hsl(43, 89%, 31%)",
        "graphAppThemeTokens-color-warning-650": "hsl(43, 89%, 27%)",
        "graphAppThemeTokens-color-warning-70": "hsl(43, 89%, 76%)",
        "graphAppThemeTokens-color-warning-700": "hsl(43, 89%, 24%)",
        "graphAppThemeTokens-color-warning-750": "hsl(43, 89%, 17%)",
        "graphAppThemeTokens-color-warning-80": "hsl(43, 89%, 72%)",
        "graphAppThemeTokens-color-warning-800": "hsl(43, 89%, 12%)",
        "graphAppThemeTokens-color-warning-850": "hsl(43, 89%, 8%)",
        "graphAppThemeTokens-color-warning-90": "hsl(43, 89%, 68%)",
        "graphAppThemeTokens-color-warning-900": "hsl(43, 89%, 3%)",
        "graphAppThemeTokens-font-family-primary": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "graphAppThemeTokens-font-size-body-text-l": "11.85pt",
        "graphAppThemeTokens-font-size-body-text-m": "10.5pt",
        "graphAppThemeTokens-font-size-body-text-m-rem": "0.875rem",
        "graphAppThemeTokens-font-size-body-text-s": "9.3pt",
        "graphAppThemeTokens-font-size-body-text-xl": "13.92pt",
        "graphAppThemeTokens-font-size-body-text-xs": "8.325pt",
        "graphAppThemeTokens-font-size-body-text-xxl": "14.925pt",
        "graphAppThemeTokens-font-size-body-text-xxs": "7.35pt",
        "graphAppThemeTokens-font-size-body-text-xxxl": "16.8pt",
        "graphAppThemeTokens-font-size-body-text-xxxs": "6.525pt",
        "graphAppThemeTokens-font-size-body-text-xxxxl": "18.9pt",
        "graphAppThemeTokens-font-size-heading-text-1": "34pt",
        "graphAppThemeTokens-font-size-heading-text-2": "27pt",
        "graphAppThemeTokens-font-size-heading-text-3": "21pt",
        "graphAppThemeTokens-font-size-heading-text-4": "17pt",
        "graphAppThemeTokens-font-size-heading-text-5": "11pt",
        "graphAppThemeTokens-font-size-heading-text-6": "9pt",
        "graphAppThemeTokens-font-style-expression": "normal",
        "graphAppThemeTokens-font-style-overflow-wrap-normal": "normal",
        "graphAppThemeTokens-font-style-weight-400": "400",
        "graphAppThemeTokens-font-style-weight-700": "700",
        "graphAppThemeTokens-size-border-width-s": "1px",
        "graphs-band-displayOpts": "standard",
        "graphs-bar-displayOpts": "standard",
        "graphs-blockPlot-altBlock-color": "hsl(219, 12%, 92%)",
        "graphs-blockPlot-altBlock-fill-color": "hsl(219, 12%, 92%)",
        "graphs-blockPlot-block-color": "hsl(219, 0%, 100%)",
        "graphs-blockPlot-block-fill-color": "hsl(219, 0%, 100%)",
        "graphs-box-capStyle": "serif",
        "graphs-box-connect": "mean",
        "graphs-box-displayOpts": "standard",
        "graphs-box-mean-alt-color": "#7E7E7E",
        "graphs-box-mean-marker-color": "#7E7E7E",
        "graphs-box-mean-marker-size": "11px",
        "graphs-box-mean-marker-symbol": "squarefilled",
        "graphs-box-mean-text-color": "#636363",
        "graphs-box-median-alt-color": "#7E7E7E",
        "graphs-box-median-line-color": "#7E7E7E",
        "graphs-box-median-line-pattern": "1",
        "graphs-box-median-line-thickness": "1px",
        "graphs-box-median-text-color": "#636363",
        "graphs-box-whisker-alt-color": "#7E7E7E",
        "graphs-box-whisker-line-color": "#7E7E7E",
        "graphs-box-whisker-line-pattern": "1",
        "graphs-box-whisker-line-thickness": "1px",
        "graphs-box-whisker-text-color": "#636363",
        "graphs-bubble-displayOpts": "standard",
        "graphs-bubble-size-max": "28px",
        "graphs-bubble-size-min": "7px",
        "graphs-decisionTree-displayOpts": "standard",
        "graphs-ellipse-displayOpts": "standard",
        "graphs-heatMap-displayOpts": "standard",
        "graphs-highLow-displayOpts": "standard",
        "graphs-histogram-displayOpts": "standard",
        "graphs-icicle-displayOpts": "standard",
        "graphs-icicle-gap": "1dpx",
        "graphs-keyValue-outline-line-color": "#4398F9",
        "graphs-keyValue-outline-line-thickness": "12px",
        "graphs-keyValue-text-color": "#3C89E0",
        "graphs-keyValue-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "graphs-keyValue-text-fontSize": "9.3pt",
        "graphs-keyValue-text-fontStyle": "normal",
        "graphs-keyValue-text-fontWeight": "400",
        "graphs-lineChart-displayOpts": "standard",
        "graphs-mapRegionLayer-displayOpts": "standard",
        "graphs-mosaic-displayOpts": "standard",
        "graphs-mosaic-gap": "1dpx",
        "graphs-network-displayOpts": "standard",
        "graphs-pie-displayOpts": "standard",
        "graphs-pie-donut": "true",
        "graphs-pie-gap": "1dpx",
        "graphs-pie-hole-size-min": "0.15",
        "graphs-pie-ring-size": "0.3",
        "graphs-sankey-displayOpts": "standard",
        "graphs-scatter-marker-size-max": "28px",
        "graphs-scatter-marker-size-min": "7px",
        "graphs-schedule-displayOpts": "standard",
        "graphs-series-displayOpts": "standard",
        "graphs-series-line-thickness-max": "8px",
        "graphs-series-line-thickness-min": "2px",
        "graphs-timeSeries-displayOpts": "standard",
        "graphs-treeMap-displayOpts": "standard",
        "graphs-treeMap-gap": "1dpx",
        "graphs-waterfall-connect-line-color": "#7E7E7E",
        "graphs-waterfall-connect-line-pattern": "1",
        "graphs-waterfall-connect-line-thickness": "1px",
        "graphs-waterfall-displayOpts": "standard",
        "graphs-waterfall-final-alt-color": "#575757",
        "graphs-waterfall-final-color": "#707070",
        "graphs-waterfall-final-fill-color": "#707070",
        "graphs-waterfall-final-fill-pattern": "X1",
        "graphs-waterfall-final-fill-patternColor": "#575757",
        "graphs-waterfall-final-line-color": "#575757",
        "graphs-waterfall-final-line-pattern": "1",
        "graphs-waterfall-final-line-thickness": "1px",
        "graphs-waterfall-final-marker-color": "#575757",
        "graphs-waterfall-final-marker-size": "11px",
        "graphs-waterfall-final-marker-symbol": "squarefilled",
        "graphs-waterfall-final-text-color": "hsl(219, 0%, 0%)",
        "graphs-waterfall-initial-alt-color": "#575757",
        "graphs-waterfall-initial-color": "#707070",
        "graphs-waterfall-initial-fill-color": "#707070",
        "graphs-waterfall-initial-fill-pattern": "X4",
        "graphs-waterfall-initial-fill-patternColor": "#575757",
        "graphs-waterfall-initial-line-color": "#575757",
        "graphs-waterfall-initial-line-pattern": "1",
        "graphs-waterfall-initial-line-thickness": "1px",
        "graphs-waterfall-initial-marker-color": "#575757",
        "graphs-waterfall-initial-marker-size": "11px",
        "graphs-waterfall-initial-marker-symbol": "trianglerightfilled",
        "graphs-waterfall-initial-text-color": "hsl(219, 0%, 0%)",
        "interaction-animationControlPanel-fill-color": "hsl(219, 0%, 100%)",
        "interaction-animationControlPanel-frameBorder": "true",
        "interaction-animationControlPanel-line-color": "hsl(219, 12%, 79%)",
        "interaction-dropZone-fill-color": "hsl(212, 94%, 53%)",
        "interaction-dropZone-line-color": "hsl(212, 94%, 42%)",
        "interaction-dropZone-line-pattern": "1",
        "interaction-dropZone-line-thickness": "1px",
        "interaction-dropZone-transparency": "0.85",
        "interaction-hyperlink-text-color": "hsl(219, 12%, 42%)",
        "interaction-keyFrameValue-padding": "0.03",
        "interaction-keyFrameValue-text-alignment-horizontal": "right",
        "interaction-keyFrameValue-text-alignment-vertical": "bottom",
        "interaction-keyFrameValue-text-color": "hsl(219, 12%, 27%)",
        "interaction-keyFrameValue-text-fitWidth": "0.42",
        "interaction-keyFrameValue-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "interaction-keyFrameValue-text-fontSize": "13.92pt",
        "interaction-keyFrameValue-text-fontStyle": "normal",
        "interaction-keyFrameValue-text-fontWeight": "700",
        "interaction-keyFrameValue-text-transparency": "0",
        "kpiStyles-indicator-alt-color": "hsl(219, 0%, 100%)",
        "kpiStyles-indicator-fill-color": "hsl(219, 12%, 8%)",
        "kpiStyles-indicator-line-color": "hsl(219, 0%, 100%)",
        "kpiStyles-indicator-transparency": "0.6",
        "kpiStyles-overflow-alt-color": "#3C783F",
        "kpiStyles-overflow-color": "#49914D",
        "kpiStyles-overflow-fill-color": "#49914D",
        "kpiStyles-overflow-fill-pattern": "R2",
        "kpiStyles-overflow-fill-patternColor": "#3C783F",
        "kpiStyles-overflow-line-color": "#3C783F",
        "kpiStyles-overflow-line-pattern": "1",
        "kpiStyles-overflow-line-thickness": "2px",
        "kpiStyles-overflow-marker-color": "#3C783F",
        "kpiStyles-overflow-marker-size": "11px",
        "kpiStyles-overflow-marker-symbol": "circlefilled",
        "kpiStyles-overflow-text-color": "#214223",
        "kpiStyles-range-1-alt-color": "#E54040",
        "kpiStyles-range-1-color": "#FF4747",
        "kpiStyles-range-1-fill-color": "#FF4747",
        "kpiStyles-range-1-fill-pattern": "R3",
        "kpiStyles-range-1-fill-patternColor": "#E54040",
        "kpiStyles-range-1-line-color": "#E54040",
        "kpiStyles-range-1-line-pattern": "1",
        "kpiStyles-range-1-line-thickness": "2px",
        "kpiStyles-range-1-marker-color": "#E54040",
        "kpiStyles-range-1-marker-size": "11px",
        "kpiStyles-range-1-marker-symbol": "circlefilled",
        "kpiStyles-range-1-text-color": "#B03131",
        "kpiStyles-range-2-alt-color": "#D48A51",
        "kpiStyles-range-2-color": "#ED9A5B",
        "kpiStyles-range-2-fill-color": "#ED9A5B",
        "kpiStyles-range-2-fill-pattern": "L1",
        "kpiStyles-range-2-fill-patternColor": "#D48A51",
        "kpiStyles-range-2-line-color": "#D48A51",
        "kpiStyles-range-2-line-pattern": "1",
        "kpiStyles-range-2-line-thickness": "2px",
        "kpiStyles-range-2-marker-color": "#D48A51",
        "kpiStyles-range-2-marker-size": "11px",
        "kpiStyles-range-2-marker-symbol": "circlefilled",
        "kpiStyles-range-2-text-color": "#9E673D",
        "kpiStyles-range-3-alt-color": "#DBC549",
        "kpiStyles-range-3-color": "#F5DC51",
        "kpiStyles-range-3-fill-color": "#F5DC51",
        "kpiStyles-range-3-fill-pattern": "R4",
        "kpiStyles-range-3-fill-patternColor": "#DBC549",
        "kpiStyles-range-3-line-color": "#DBC549",
        "kpiStyles-range-3-line-pattern": "1",
        "kpiStyles-range-3-line-thickness": "2px",
        "kpiStyles-range-3-marker-color": "#DBC549",
        "kpiStyles-range-3-marker-size": "11px",
        "kpiStyles-range-3-marker-symbol": "circlefilled",
        "kpiStyles-range-3-text-color": "#A69537",
        "kpiStyles-range-4-alt-color": "#9ABF61",
        "kpiStyles-range-4-color": "#AFDA6E",
        "kpiStyles-range-4-fill-color": "#AFDA6E",
        "kpiStyles-range-4-fill-pattern": "X1",
        "kpiStyles-range-4-fill-patternColor": "#9ABF61",
        "kpiStyles-range-4-line-color": "#9ABF61",
        "kpiStyles-range-4-line-pattern": "1",
        "kpiStyles-range-4-line-thickness": "2px",
        "kpiStyles-range-4-marker-color": "#9ABF61",
        "kpiStyles-range-4-marker-size": "11px",
        "kpiStyles-range-4-marker-symbol": "circlefilled",
        "kpiStyles-range-4-text-color": "#6F8A45",
        "kpiStyles-range-5-alt-color": "#56AB5A",
        "kpiStyles-range-5-color": "#63C568",
        "kpiStyles-range-5-fill-color": "#63C568",
        "kpiStyles-range-5-fill-pattern": "X3",
        "kpiStyles-range-5-fill-patternColor": "#56AB5A",
        "kpiStyles-range-5-line-color": "#56AB5A",
        "kpiStyles-range-5-line-pattern": "1",
        "kpiStyles-range-5-line-thickness": "2px",
        "kpiStyles-range-5-marker-color": "#56AB5A",
        "kpiStyles-range-5-marker-size": "11px",
        "kpiStyles-range-5-marker-symbol": "circlefilled",
        "kpiStyles-range-5-text-color": "#3B753E",
        "kpiStyles-range-alt-color": "#B6CAE8",
        "kpiStyles-range-text-color": "hsl(219, 12%, 8%)",
        "kpiStyles-range-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "kpiStyles-range-text-fontSize": "9.3pt",
        "kpiStyles-range-text-fontStyle": "normal",
        "kpiStyles-range-text-fontWeight": "400",
        "kpiStyles-underflow-alt-color": "#B23232",
        "kpiStyles-underflow-color": "#CC3939",
        "kpiStyles-underflow-fill-color": "#CC3939",
        "kpiStyles-underflow-fill-pattern": "L2",
        "kpiStyles-underflow-fill-patternColor": "#B23232",
        "kpiStyles-underflow-line-color": "#B23232",
        "kpiStyles-underflow-line-pattern": "1",
        "kpiStyles-underflow-line-thickness": "2px",
        "kpiStyles-underflow-marker-color": "#B23232",
        "kpiStyles-underflow-marker-size": "11px",
        "kpiStyles-underflow-marker-symbol": "circlefilled",
        "kpiStyles-underflow-text-color": "#7D2323",
        "kpiStyles-value-alt-text-color": "#6A7487",
        "kpiStyles-value-text-color": "hsl(219, 12%, 42%)",
        "kpiStyles-value-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "kpiStyles-value-text-fontSize": "9.3pt",
        "kpiStyles-value-text-fontStyle": "normal",
        "kpiStyles-value-text-fontWeight": "400",
        "layout-dataMatrix-cellSeparator": "true",
        "layout-dataMatrix-matrixBorder": "false",
        "layout-dataPanel-confineTickValues": "true",
        "layout-lattice-confineTickValues": "true",
        "layout-matrixBorder-line-color": "hsl(219, 12%, 22%)",
        "layout-matrixBorder-line-pattern": "1",
        "layout-matrixBorder-line-thickness": "1dpx",
        "layout-overlay": "top",
        "legend-continuous-frameBorder": "false",
        "legend-continuous-title-hAlign": "left",
        "legend-continuous-title-position": "top",
        "legend-continuous-titleSeparatorTop": "true",
        "legend-discrete-frameBorder": "false",
        "legend-discrete-title-hAlign": "left",
        "legend-discrete-title-position": "top",
        "legend-discrete-titleSeparatorTop": "true",
        "legend-global-dataMatrix-align": "begin",
        "legend-global-dataMatrix-alignTo": "wall",
        "legend-global-lattice": "begin",
        "legend-global-overlay-align": "begin",
        "legend-global-overlay-alignTo": "wall",
        "legend-global-region-align": "begin",
        "legend-size-frameBorder": "false",
        "legend-size-title-hAlign": "left",
        "legend-size-title-position": "top",
        "legend-size-titleSeparatorTop": "true",
        "nodeLinkDiagram-dataNode-0-alt-color": "#7B7B7B",
        "nodeLinkDiagram-dataNode-0-color": "#EEEEEE",
        "nodeLinkDiagram-dataNode-0-fill-color": "#EEEEEE",
        "nodeLinkDiagram-dataNode-0-fill-pattern": "L1",
        "nodeLinkDiagram-dataNode-0-fill-patternColor": "#EEEEEE",
        "nodeLinkDiagram-dataNode-0-line-color": "#7B7B7B",
        "nodeLinkDiagram-dataNode-0-line-thickness": "1px",
        "nodeLinkDiagram-dataNode-0-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-dataNode-1-alt-color": "#3C89E0",
        "nodeLinkDiagram-dataNode-1-color": "#E4F1FE",
        "nodeLinkDiagram-dataNode-1-fill-color": "#E4F1FE",
        "nodeLinkDiagram-dataNode-1-line-color": "#3C89E0",
        "nodeLinkDiagram-dataNode-1-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-dataNode-2-alt-color": "#D97D3D",
        "nodeLinkDiagram-dataNode-2-color": "#FEF0E4",
        "nodeLinkDiagram-dataNode-2-fill-color": "#FEF0E4",
        "nodeLinkDiagram-dataNode-2-line-color": "#D97D3D",
        "nodeLinkDiagram-dataNode-2-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-dataNode-3-alt-color": "#489C8C",
        "nodeLinkDiagram-dataNode-3-color": "#E7F8F4",
        "nodeLinkDiagram-dataNode-3-fill-color": "#E7F8F4",
        "nodeLinkDiagram-dataNode-3-line-color": "#489C8C",
        "nodeLinkDiagram-dataNode-3-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-dataNode-4-alt-color": "#D473B8",
        "nodeLinkDiagram-dataNode-4-color": "#FDEBF8",
        "nodeLinkDiagram-dataNode-4-fill-color": "#FDEBF8",
        "nodeLinkDiagram-dataNode-4-line-color": "#D473B8",
        "nodeLinkDiagram-dataNode-4-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-dataNode-5-alt-color": "#82A637",
        "nodeLinkDiagram-dataNode-5-color": "#F3F9E5",
        "nodeLinkDiagram-dataNode-5-fill-color": "#F3F9E5",
        "nodeLinkDiagram-dataNode-5-line-color": "#82A637",
        "nodeLinkDiagram-dataNode-5-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-dataNode-6-alt-color": "#9364CF",
        "nodeLinkDiagram-dataNode-6-color": "#F0E6FD",
        "nodeLinkDiagram-dataNode-6-fill-color": "#F0E6FD",
        "nodeLinkDiagram-dataNode-6-line-color": "#9364CF",
        "nodeLinkDiagram-dataNode-6-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-dataNode-7-alt-color": "#C29F16",
        "nodeLinkDiagram-dataNode-7-color": "#FBF7DF",
        "nodeLinkDiagram-dataNode-7-fill-color": "#FBF7DF",
        "nodeLinkDiagram-dataNode-7-line-color": "#C29F16",
        "nodeLinkDiagram-dataNode-7-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-dataNode-8-alt-color": "#D66354",
        "nodeLinkDiagram-dataNode-8-color": "#FEEAE7",
        "nodeLinkDiagram-dataNode-8-fill-color": "#FEEAE7",
        "nodeLinkDiagram-dataNode-8-line-color": "#D66354",
        "nodeLinkDiagram-dataNode-8-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-dataNode-ramps-0-fill-end": "#F28D44",
        "nodeLinkDiagram-dataNode-ramps-0-fill-neutral": "#F4F3F4",
        "nodeLinkDiagram-dataNode-ramps-0-fill-start": "#4398F9",
        "nodeLinkDiagram-details-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-details-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-details-text-fontSize": "7.35pt",
        "nodeLinkDiagram-details-text-fontStyle": "normal",
        "nodeLinkDiagram-details-text-fontWeight": "400",
        "nodeLinkDiagram-group-closed-fill-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-group-closed-line-color": "hsl(219, 12%, 27%)",
        "nodeLinkDiagram-group-closed-line-thickness": "1px",
        "nodeLinkDiagram-group-closed-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-group-closed-transparency": "0",
        "nodeLinkDiagram-group-contentArea-fill-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-group-contentArea-fill-transparency": "0.2",
        "nodeLinkDiagram-group-open-fill-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-group-open-line-color": "hsl(219, 12%, 27%)",
        "nodeLinkDiagram-group-open-line-thickness": "1px",
        "nodeLinkDiagram-group-open-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-group-open-transparency": "0",
        "nodeLinkDiagram-group-title-fill-transparency": "0.2",
        "nodeLinkDiagram-group-title-text-color": "hsl(219, 12%, 27%)",
        "nodeLinkDiagram-group-title-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-group-title-text-fontSize": "10.5pt",
        "nodeLinkDiagram-group-title-text-fontStyle": "normal",
        "nodeLinkDiagram-group-title-text-fontWeight": "400",
        "nodeLinkDiagram-iconNode-end-text-color": "hsl(0, 100%, 36%)",
        "nodeLinkDiagram-iconNode-fill-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-iconNode-gateway-exclusive-text-color": "hsl(212, 94%, 36%)",
        "nodeLinkDiagram-iconNode-gateway-inclusive-text-color": "hsl(212, 94%, 36%)",
        "nodeLinkDiagram-iconNode-start-text-color": "hsl(123, 46%, 36%)",
        "nodeLinkDiagram-iconNode-timer-text-color": "hsl(212, 94%, 36%)",
        "nodeLinkDiagram-inputLabel-text-color": "hsl(219, 12%, 27%)",
        "nodeLinkDiagram-inputLabel-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-inputLabel-text-fontSize": "10.5pt",
        "nodeLinkDiagram-inputLabel-text-fontStyle": "normal",
        "nodeLinkDiagram-inputLabel-text-fontWeight": "400",
        "nodeLinkDiagram-label-text-color": "hsl(219, 12%, 27%)",
        "nodeLinkDiagram-label-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-label-text-fontSize": "10.5pt",
        "nodeLinkDiagram-label-text-fontStyle": "normal",
        "nodeLinkDiagram-label-text-fontWeight": "400",
        "nodeLinkDiagram-link-alt-color": "#939393",
        "nodeLinkDiagram-link-color": "#B4B4B4",
        "nodeLinkDiagram-link-crossover-alt-color": "#939393",
        "nodeLinkDiagram-link-crossover-line-color": "#939393",
        "nodeLinkDiagram-link-crossover-line-pattern": "2",
        "nodeLinkDiagram-link-crossover-line-thickness": "2px",
        "nodeLinkDiagram-link-crossover-line-transparency": "0",
        "nodeLinkDiagram-link-fill-color": "#B4B4B4",
        "nodeLinkDiagram-link-line-color": "#939393",
        "nodeLinkDiagram-link-line-pattern": "1",
        "nodeLinkDiagram-link-line-thickness": "2px",
        "nodeLinkDiagram-link-marker-color": "#939393",
        "nodeLinkDiagram-note-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-note-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-note-text-fontSize": "7.35pt",
        "nodeLinkDiagram-note-text-fontStyle": "normal",
        "nodeLinkDiagram-note-text-fontWeight": "400",
        "nodeLinkDiagram-outlinesNode-line-color": "hsl(219, 12%, 79%)",
        "nodeLinkDiagram-status-animatedProgressIndicator-text-color": "hsl(212, 94%, 36%)",
        "nodeLinkDiagram-status-background-fill-color": "hsl(219, 0%, 100%)",
        "nodeLinkDiagram-status-clustered-text-color": "hsl(212, 94%, 36%)",
        "nodeLinkDiagram-status-complete-text-color": "hsl(123, 46%, 36%)",
        "nodeLinkDiagram-status-error-text-color": "hsl(0, 100%, 36%)",
        "nodeLinkDiagram-status-important-text-color": "hsl(0, 100%, 36%)",
        "nodeLinkDiagram-status-incomplete-text-color": "hsl(0, 100%, 36%)",
        "nodeLinkDiagram-status-incompleteInProgress-text-color": "hsl(212, 94%, 36%)",
        "nodeLinkDiagram-status-information-text-color": "hsl(212, 94%, 36%)",
        "nodeLinkDiagram-status-locked-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-status-mediumPriority-text-color": "hsl(43, 89%, 39%)",
        "nodeLinkDiagram-status-neutral-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-status-progress-text-color": "hsl(212, 94%, 36%)",
        "nodeLinkDiagram-status-scheduled-text-color": "hsl(212, 94%, 36%)",
        "nodeLinkDiagram-status-stopped-text-color": "hsl(0, 100%, 36%)",
        "nodeLinkDiagram-status-stopping-text-color": "hsl(0, 100%, 36%)",
        "nodeLinkDiagram-status-warning-text-color": "hsl(43, 89%, 39%)",
        "nodeLinkDiagram-subject-fill-color": "#E4F1FE",
        "nodeLinkDiagram-subject-line-color": "#3C89E0",
        "nodeLinkDiagram-subject-line-pattern": "1",
        "nodeLinkDiagram-subject-line-thickness": "1px",
        "nodeLinkDiagram-subject-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-title-text-color": "hsl(219, 12%, 22%)",
        "nodeLinkDiagram-title-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "nodeLinkDiagram-title-text-fontSize": "9.3pt",
        "nodeLinkDiagram-title-text-fontStyle": "normal",
        "nodeLinkDiagram-title-text-fontWeight": "700",
        "outlier-alt-color": "#636363",
        "outlier-color": "#7E7E7E",
        "outlier-fill-color": "#7E7E7E",
        "outlier-line-color": "#636363",
        "outlier-line-pattern": "1",
        "outlier-line-thickness": "2px",
        "outlier-marker-color": "#636363",
        "outlier-marker-size": "11px",
        "outlier-marker-symbol": "circlefilled",
        "outlier-ramps-fill-color-end": "#898989",
        "outlier-ramps-fill-color-start": "#EEEEEE",
        "outlier-text-color": "#2E2E2E",
        "outlines-line-color": "hsl(219, 0%, 100%)",
        "outlines-line-pattern": "1",
        "outlines-line-thickness": "1px",
        "outlines-unfilled-line-color": "#7E7E7E",
        "outlines-unfilled-line-pattern": "1",
        "outlines-unfilled-line-thickness": "1px",
        "overplotting-grouped-marker-size-min": "6px",
        "overplotting-ungrouped-marker-size-min": "4px",
        "overview-axis-filter-color": "hsl(219, 12%, 96%)",
        "overview-axis-filter-fill-color": "hsl(219, 12%, 96%)",
        "overview-axis-filter-fill-transparency": "0.7",
        "overview-axis-line-color": "hsl(219, 12%, 22%)",
        "overview-axis-line-thickness": "1dpx",
        "overview-border-line-color": "hsl(219, 12%, 79%)",
        "overview-border-line-thickness": "1dpx",
        "overview-border-transparency": "0",
        "overview-fill-color": "hsl(219, 0%, 100%)",
        "overview-filter-fill-color": "hsl(219, 12%, 96%)",
        "overview-filter-transparency": "0.7",
        "overview-transparency": "0",
        "overview-viewportBorder-line-color": "hsl(212, 94%, 42%)",
        "overview-viewportBorder-line-thickness": "1dpx",
        "overview-viewportBorder-transparency": "0",
        "palette-discrete-1": "#4398F9",
        "palette-discrete-2": "#F28D44",
        "palette-discrete-3": "#54B6A4",
        "palette-discrete-4": "#EC80CE",
        "palette-discrete-5": "#97C03F",
        "palette-discrete-6": "#A570E8",
        "palette-discrete-7": "#DCB519",
        "palette-discrete-8": "#F06F5E",
        "palette-kpi-1": "#FF4747",
        "palette-kpi-3": "#F5DC51",
        "palette-kpi-5": "#63C568",
        "prediction-alt-color": "#736782",
        "prediction-color": "#A493BA",
        "prediction-fill-color": "#A493BA",
        "prediction-line-color": "#736782",
        "prediction-line-pattern": "34",
        "prediction-line-thickness": "2px",
        "prediction-marker-color": "#736782",
        "prediction-marker-size": "11px",
        "prediction-marker-symbol": "squarefilled",
        "prediction-text-color": "#5C5369",
        "predictionLimits-alt-color": "#9B95A3",
        "predictionLimits-color": "#D1C9DC",
        "predictionLimits-fill-color": "#D1C9DC",
        "predictionLimits-fill-pattern": "E",
        "predictionLimits-fill-patternColor": "#9B95A3",
        "predictionLimits-fill-transparency": "0.5",
        "predictionLimits-line-color": "#9B95A3",
        "predictionLimits-line-pattern": "34",
        "predictionLimits-line-thickness": "2px",
        "predictionLimits-marker-color": "#9B95A3",
        "predictionLimits-marker-size": "11px",
        "predictionLimits-marker-symbol": "trianglefilled",
        "predictionLimits-text-color": "#837E8A",
        "ramps-threeColorDivergent-0-alt-color-end": "#D97D3D",
        "ramps-threeColorDivergent-0-alt-color-neutral": "#DBDADB",
        "ramps-threeColorDivergent-0-alt-color-start": "#3C89E0",
        "ramps-threeColorDivergent-0-fill-color-end": "#F28D44",
        "ramps-threeColorDivergent-0-fill-color-neutral": "#F4F3F4",
        "ramps-threeColorDivergent-0-fill-color-start": "#4398F9",
        "ramps-threeColorDivergent-1-alt-color-end": "#D97D3D",
        "ramps-threeColorDivergent-1-alt-color-neutral": "#DBDADB",
        "ramps-threeColorDivergent-1-alt-color-start": "#3C89E0",
        "ramps-threeColorDivergent-1-fill-color-end": "#F28D44",
        "ramps-threeColorDivergent-1-fill-color-neutral": "#F4F3F4",
        "ramps-threeColorDivergent-1-fill-color-start": "#4398F9",
        "ramps-threeColorDivergent-2-alt-color-end": "#D473B8",
        "ramps-threeColorDivergent-2-alt-color-neutral": "#DCDBDE",
        "ramps-threeColorDivergent-2-alt-color-start": "#489C8C",
        "ramps-threeColorDivergent-2-fill-color-end": "#EC80CE",
        "ramps-threeColorDivergent-2-fill-color-neutral": "#F5F4F7",
        "ramps-threeColorDivergent-2-fill-color-start": "#54B6A4",
        "ramps-threeColorDivergent-3-alt-color-end": "#9364CF",
        "ramps-threeColorDivergent-3-alt-color-neutral": "#DBDBDA",
        "ramps-threeColorDivergent-3-alt-color-start": "#82A637",
        "ramps-threeColorDivergent-3-fill-color-end": "#A570E8",
        "ramps-threeColorDivergent-3-fill-color-neutral": "#F4F4F3",
        "ramps-threeColorDivergent-3-fill-color-start": "#97C03F",
        "ramps-threeColorDivergent-4-alt-color-end": "#D66354",
        "ramps-threeColorDivergent-4-alt-color-neutral": "#E3DBD2",
        "ramps-threeColorDivergent-4-alt-color-start": "#C29F16",
        "ramps-threeColorDivergent-4-fill-color-end": "#F06F5E",
        "ramps-threeColorDivergent-4-fill-color-neutral": "#FCF3E9",
        "ramps-threeColorDivergent-4-fill-color-start": "#DCB519",
        "ramps-threeColorKPI-alt-color-end": "#56AB5A",
        "ramps-threeColorKPI-alt-color-neutral": "#DBC549",
        "ramps-threeColorKPI-alt-color-start": "#E54040",
        "ramps-threeColorKPI-fill-color-end": "#63C568",
        "ramps-threeColorKPI-fill-color-neutral": "#F5DC51",
        "ramps-threeColorKPI-fill-color-start": "#FF4747",
        "ramps-twoColorLinear-0-alt-color-end": "#2079DE",
        "ramps-twoColorLinear-0-alt-color-start": "#B3CAE3",
        "ramps-twoColorLinear-0-fill-color-end": "#2487F8",
        "ramps-twoColorLinear-0-fill-color-start": "#E3F0FE",
        "ramps-twoColorLinear-1-alt-color-end": "#2079DE",
        "ramps-twoColorLinear-1-alt-color-start": "#B3CAE3",
        "ramps-twoColorLinear-1-fill-color-end": "#2487F8",
        "ramps-twoColorLinear-1-fill-color-start": "#E3F0FE",
        "ramps-twoColorLinear-2-alt-color-end": "#D66D22",
        "ramps-twoColorLinear-2-alt-color-start": "#E0C6B4",
        "ramps-twoColorLinear-2-fill-color-end": "#F07A26",
        "ramps-twoColorLinear-2-fill-color-start": "#FDEEE3",
        "ramps-twoColorLinear-3-alt-color-end": "#349987",
        "ramps-twoColorLinear-3-alt-color-start": "#B9D4CE",
        "ramps-twoColorLinear-3-fill-color-end": "#3DB29D",
        "ramps-twoColorLinear-3-fill-color-start": "#E5F4F1",
        "ramps-twoColorLinear-4-alt-color-end": "#D157AE",
        "ramps-twoColorLinear-4-alt-color-start": "#E0C2D7",
        "ramps-twoColorLinear-4-fill-color-end": "#EB63C5",
        "ramps-twoColorLinear-4-fill-color-start": "#FCECF8",
        "ramps-twoColorLinear-5-alt-color-end": "#7AA322",
        "ramps-twoColorLinear-5-alt-color-start": "#C9D4B3",
        "ramps-twoColorLinear-5-fill-color-end": "#8DBD28",
        "ramps-twoColorLinear-5-fill-color-start": "#EFF6E2",
        "ramps-twoColorLinear-6-alt-color-end": "#834ACC",
        "ramps-twoColorLinear-6-alt-color-start": "#CCBEDE",
        "ramps-twoColorLinear-6-fill-color-end": "#9353E5",
        "ramps-twoColorLinear-6-fill-color-start": "#F2EAFC",
        "ramps-twoColorLinear-7-alt-color-end": "#BF9900",
        "ramps-twoColorLinear-7-alt-color-start": "#DBD2AB",
        "ramps-twoColorLinear-7-fill-color-end": "#D9AD00",
        "ramps-twoColorLinear-7-fill-color-start": "#FBF5E0",
        "ramps-twoColorLinear-8-alt-color-end": "#D44B39",
        "ramps-twoColorLinear-8-alt-color-start": "#E0BEB9",
        "ramps-twoColorLinear-8-fill-color-end": "#ED5440",
        "ramps-twoColorLinear-8-fill-color-start": "#FDE9E7",
        "ramps-twoColorLinear-other-alt-color-end": "#696969",
        "ramps-twoColorLinear-other-alt-color-start": "#C6C6C6",
        "ramps-twoColorLinear-other-fill-color-end": "#898989",
        "ramps-twoColorLinear-other-fill-color-start": "#EEEEEE",
        "reports-base-font-family": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "reports-base-font-size": "10.5pt",
        "reports-base-font-style": "normal",
        "reports-base-font-weight": "400",
        "reports-base-text-color": "hsl(219, 12%, 12%)",
        "reports-button-bar-background-color": "hsl(219, 0%, 100%)",
        "reports-button-bar-color": "hsl(219, 12%, 12%)",
        "reports-button-bar-font-weight": "normal",
        "reports-button-bar-selected-background-color": "hsl(212, 94%, 90%)",
        "reports-button-bar-selected-color": "hsl(212, 94%, 31%)",
        "reports-checkbox-list-background-color": "hsl(219, 0%, 100%)",
        "reports-checkbox-list-color": "hsl(219, 12%, 12%)",
        "reports-combobox-background-color": "hsl(219, 0%, 100%)",
        "reports-combobox-color": "hsl(219, 12%, 12%)",
        "reports-container-background-color": "hsl(219, 0%, 100%)",
        "reports-container-border-color": "hsl(219, 12%, 88%)",
        "reports-crosstab-header-background-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-header-color": "hsl(219, 12%, 12%)",
        "reports-crosstab-header-font-size": "9.3pt",
        "reports-crosstab-header-font-weight": "700",
        "reports-crosstab-header-line-color": "hsl(219, 12%, 88%)",
        "reports-crosstab-measureHeader-background-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-measureHeader-color": "hsl(219, 12%, 12%)",
        "reports-crosstab-measureHeader-font-size": "9.3pt",
        "reports-crosstab-measureHeader-font-weight": "700",
        "reports-crosstab-rowHeader-background-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-rowHeader-color": "hsl(219, 12%, 12%)",
        "reports-crosstab-rowHeader-font-size": "9.3pt",
        "reports-crosstab-rowHeader-font-weight": "700",
        "reports-crosstab-scrollbar-fill-color": "hsl(219, 12%, 42%)",
        "reports-crosstab-subtotals-background-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-subtotals-color": "hsl(219, 12%, 12%)",
        "reports-crosstab-subtotals-font-size": "9.3pt",
        "reports-crosstab-subtotals-font-weight": "700",
        "reports-crosstab-table-alt-row-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-table-border-style": "none",
        "reports-crosstab-table-color": "hsl(219, 12%, 12%)",
        "reports-crosstab-table-displayOpts": "plain",
        "reports-crosstab-table-font-size": "9.3pt",
        "reports-crosstab-table-font-weight": "400",
        "reports-crosstab-table-horizontal-line-pattern": "solid",
        "reports-crosstab-table-vertical-line-pattern": "solid",
        "reports-crosstab-totals-background-color": "hsl(219, 0%, 100%)",
        "reports-crosstab-totals-color": "hsl(219, 12%, 12%)",
        "reports-crosstab-totals-font-size": "9.3pt",
        "reports-crosstab-totals-font-weight": "700",
        "reports-element-container-padding": "16px",
        "reports-graph-menu-border-color": "hsl(219, 12%, 88%)",
        "reports-graph-menu-text-colorSelected": "hsl(212, 94%, 31%)",
        "reports-graph-slider-bar-fill-color": "hsl(219, 0%, 100%)",
        "reports-graph-slider-bar-line-colorBottom": "hsl(219, 12%, 88%)",
        "reports-graph-slider-bar-line-colorTop": "hsl(219, 12%, 88%)",
        "reports-graph-slider-thumb-fill-colorCenter": "hsl(212, 94%, 42%)",
        "reports-graph-slider-thumb-line-color": "hsl(219, 12%, 88%)",
        "reports-graph-slider-ui5-bar-fill-color": "hsl(212, 94%, 42%)",
        "reports-graph-slider-ui5-bar-line-colorBottom": "hsl(219, 12%, 88%)",
        "reports-graph-slider-ui5-bar-line-colorTop": "hsl(219, 12%, 88%)",
        "reports-graph-slider-ui5-thumb-fill-colorCenter": "hsl(212, 94%, 42%)",
        "reports-graph-slider-ui5-thumb-fill-colorDonut": "hsl(219, 0%, 100%)",
        "reports-graph-slider-ui5-thumb-line-color": "hsl(219, 12%, 88%)",
        "reports-heading-alt-color": "hsl(212, 94%, 42%)",
        "reports-heading-color": "hsl(219, 12%, 12%)",
        "reports-heading-font-family": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "reports-heading-font-weight": "400",
        "reports-hover-background-color": "hsl(219, 0%, 100%)",
        "reports-hover-text-color": "hsl(219, 12%, 12%)",
        "reports-page-padding": "16px",
        "reports-prompt-bar-background-color": "hsl(219, 0%, 100%)",
        "reports-radio-button-color": "hsl(219, 12%, 12%)",
        "reports-report-background-color": "hsl(219, 0%, 100%)",
        "reports-selected-background-color": "hsl(212, 94%, 90%)",
        "reports-selected-text-color": "hsl(219, 12%, 12%)",
        "reports-stack-container-background-color": "hsl(219, 0%, 100%)",
        "reports-stack-container-color": "hsl(219, 12%, 12%)",
        "reports-stack-container-selected-background-color": "hsl(212, 94%, 90%)",
        "reports-stack-container-selected-border-color": "hsl(219, 12%, 88%)",
        "reports-stack-container-selected-color": "hsl(212, 94%, 31%)",
        "reports-subtotals-background-color": "hsl(219, 0%, 100%)",
        "reports-subtotals-color": "hsl(219, 12%, 12%)",
        "reports-subtotals-font-size": "9.3pt",
        "reports-subtotals-font-weight": "700",
        "reports-table-alt-row-color": "hsl(219, 0%, 100%)",
        "reports-table-border-color": "hsl(219, 12%, 88%)",
        "reports-table-border-style": "solid",
        "reports-table-border-width": "1px",
        "reports-table-color": "hsl(219, 12%, 12%)",
        "reports-table-displayOpts": "plain",
        "reports-table-font-size": "9.3pt",
        "reports-table-header-background-color": "hsl(219, 0%, 100%)",
        "reports-table-header-color": "hsl(219, 12%, 12%)",
        "reports-table-header-font-size": "9.3pt",
        "reports-table-header-font-weight": "700",
        "reports-table-horizontal-line-pattern": "solid",
        "reports-table-row-color": "hsl(219, 0%, 100%)",
        "reports-table-scrollbar-fill-color": "hsl(219, 12%, 42%)",
        "reports-table-totals-background-color": "hsl(219, 0%, 100%)",
        "reports-table-totals-color": "hsl(219, 12%, 12%)",
        "reports-table-totals-font-size": "9.3pt",
        "reports-table-totals-font-weight": "400",
        "reports-table-vertical-line-pattern": "solid",
        "reports-text-input-color": "hsl(219, 12%, 12%)",
        "reports-title-style-color": "hsl(219, 12%, 12%)",
        "reports-title-style-font-size": "13.92pt",
        "reports-totals-background-color": "hsl(219, 0%, 100%)",
        "reports-totals-color": "hsl(219, 12%, 12%)",
        "reports-totals-font-size": "9.3pt",
        "reports-totals-font-weight": "700",
        "reports-visual-prompt-container-background-color": "hsl(219, 0%, 100%)",
        "reports-zoom-scrollbar-endHandle-color": "hsl(219, 12%, 42%)",
        "reports-zoom-scrollbar-endHandle-line-color": "hsl(219, 12%, 42%)",
        "reports-zoom-scrollbar-thumb-color": "hsl(219, 0%, 100%)",
        "skin-blend-color-end": "hsl(219, 0%, 100%)",
        "skin-blend-color-start": "hsl(219, 0%, 100%)",
        "skin-blend-endColorFactor": "0",
        "skin-blend-mode": "normal",
        "skin-blend-startColorFactor": "0",
        "skin-data": "Custom",
        "skin-glow-blur": "0",
        "skin-glow-color": "hsl(219, 0%, 100%)",
        "skin-glow-colorFactor": "-0.9",
        "skin-glow-thickness": "1px",
        "skin-kpi": "Custom",
        "states-focus-background": "false",
        "states-focus-background-line-color": "hsl(219, 0%, 100%)",
        "states-focus-background-line-pattern": "1",
        "states-focus-background-line-thickness": "5px",
        "states-focus-background-line-transparency": "1",
        "states-focus-line-color": "#000000",
        "states-focus-line-pattern": "34",
        "states-focus-line-thickness": "1px",
        "states-focus-line-transparency": "0",
        "states-selection-alt-color": "#000000",
        "states-selection-color": "hsl(219, 0%, 100%)",
        "states-selection-fill-color": "hsl(219, 0%, 100%)",
        "states-selection-line-color": "#000000",
        "states-selection-line-pattern": "1",
        "states-selection-line-thickness": "2px",
        "states-selection-marker-color": "#000000",
        "states-selection-marker-size": "11px",
        "states-selection-marker-symbol": "circlefilled",
        "states-selection-text-color": "#000000",
        "templateContainer-attributeProperty": "color",
        "templateContainer-dataStyleReference": "remapped",
        "typography-data-text-color": "hsl(219, 12%, 8%)",
        "typography-data-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-data-text-fontSize": "8.325pt",
        "typography-data-text-fontStyle": "normal",
        "typography-data-text-fontWeight": "400",
        "typography-footnote-text-color": "hsl(219, 12%, 27%)",
        "typography-footnote-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-footnote-text-fontSize": "10.5pt",
        "typography-footnote-text-fontStyle": "normal",
        "typography-footnote-text-fontWeight": "400",
        "typography-label-text-color": "hsl(219, 12%, 27%)",
        "typography-label-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-label-text-fontSize": "10.5pt",
        "typography-label-text-fontStyle": "normal",
        "typography-label-text-fontWeight": "700",
        "typography-title-text-color": "hsl(219, 12%, 27%)",
        "typography-title-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-title-text-fontSize": "13.92pt",
        "typography-title-text-fontStyle": "normal",
        "typography-title-text-fontWeight": "400",
        "typography-values-text-color": "hsl(219, 12%, 42%)",
        "typography-values-text-fontFamily": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "typography-values-text-fontSize": "9.3pt",
        "typography-values-text-fontStyle": "normal",
        "typography-values-text-fontWeight": "400"
    }
};

export { DarkTokens, HighContrastTokens, LightTokens };
//# sourceMappingURL=index.js.map
